// (() => {
//   'use strict';

//   const DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbx4o7EeOP02BZVv5AwtiFGY-5uTiGalPiJzqIUu7r9hRPPNdasApH7wGxjNxwVRtrQdcA/exec';
//   const REFRESH_INTERVAL_MS = 45000;
//   const REQUEST_TIMEOUT_MS = 15000;
//   const state = {
//     doctors: new Map(),
//     therapists: new Map(),
//     bookedMap: new Map(),
//     pendingMap: new Map(),
//     profileFallback: null,
//     currentDoctorId: '',
//     modalDoctor: null,
//     loaded: false,
//     availabilityEnabled: false,
//     loadingPromise: null,
//     therapistsPromise: null,
//     requestController: null,
//     bookingRequestId: '',
//     otpChallengeId: '',
//     otpVerificationToken: '',
//     otpResendTimer: null,
//     checkoutPromise: null,
//     currentCheckout: null,
//     localBooked: [],
//     refreshTimer: null
//   };

//   const apiUrl = () => {
//     const configured = document.querySelector('[data-booking-api-url]')?.dataset.bookingApiUrl?.trim();
//     return configured || window.DoctorBookingConfig?.apiUrl || DEFAULT_API_URL;
//   };
//   const normalizeId = value => String(value ?? '').trim().toLowerCase();
//   const normalizeMode = value => {
//     const mode = String(value ?? 'online').toLowerCase();
//     return mode.includes('person') || mode.includes('clinic') ? 'in-person' : 'online';
//   };
//   const stringValue = value => String(value ?? '').trim();
//   const sheetKey = value => stringValue(value).toLowerCase()
//     .replace(/[\s-]+/g, '_')
//     .replace(/[^a-z0-9_]/g, '')
//     .replace(/_+/g, '_');
//   const normaliseSlotTime = value => {
//     const text = stringValue(value).toUpperCase();
//     const match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/);
//     if (!match) return text;
//     const hour = Number(match[1]);
//     if (Number(match[2]) > 59 || hour > (match[3] ? 12 : 23) || (match[3] && hour < 1)) return text;
//     return `${String(hour % 12 || 12).padStart(2, '0')}:${match[2]} ${match[3] || (hour >= 12 ? 'PM' : 'AM')}`;
//   };

//   /* ---------- Google Sheet therapist data ---------- */
//   const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
//   const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const DEFAULT_TIME_SLOTS = ['10:00 AM', '11:30 AM', '02:00 PM', '03:30 PM', '05:00 PM', '06:30 PM'];
//   const CARD_PALETTES = [
//     ['#EAD9DE', '#786C8A'],
//     ['#EFE7DA', '#EAD9DE'],
//     ['#786C8A', '#EFE7DA'],
//     ['#EAD9DE', '#EFE7DA'],
//     ['#EFE7DA', '#786C8A']
//   ];
//   const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
//   const safeUrl = value => /^https?:\/\//i.test(stringValue(value)) ? stringValue(value) : '';
//   const initialsOf = name => stringValue(name).split(/\s+/).slice(0, 2).map(word => word.slice(0, 1).toUpperCase()).join('') || '?';

//   function normaliseTherapist(record) {
//     if (!record || typeof record !== 'object') return null;
//     const row = {};
//     Object.keys(record).forEach(key => { row[sheetKey(key)] = record[key]; });
//     const id = normalizeId(row.id || row.handle || row.slug).replace(/\s+/g, '-');
//     if (!id) return null;
//     const active = !['no', 'false', '0', 'hidden'].includes(stringValue(row.active || 'yes').toLowerCase());
//     const slots = stringValue(row.time_slots).split(/[;,]/).map(normaliseSlotTime).filter(Boolean);
//     const rawPrice = stringValue(row.price || row.fee);
//     const days = stringValue(row.days).split(/[,;]/)
//       .map(day => day.trim().toUpperCase().slice(0, 3))
//       .filter(day => DAY_NAMES.includes(day));
//     return {
//       id,
//       name: stringValue(row.name) || 'Therapist',
//       role: stringValue(row.role || row.title) || 'Therapist',
//       rating: stringValue(row.rating),
//       price: /^\d+(\.\d+)?$/.test(rawPrice) ? `₹${Number(rawPrice).toLocaleString('en-IN')}` : rawPrice,
//       duration: stringValue(row.duration),
//       availability: stringValue(row.availability || row.next_slot),
//       image_url: safeUrl(row.image_url || row.image),
//       experience: stringValue(row.experience),
//       expertise: stringValue(row.expertise),
//       languages: stringValue(row.languages || row.speaks),
//       centre: stringValue(row.centre || row.format) || 'Online',
//       gender: stringValue(row.gender),
//       bio: stringValue(row.bio),
//       trust_line: stringValue(row.trust_line),
//       about: stringValue(row.about),
//       how_i_work: stringValue(row.how_i_work),
//       help_tags: stringValue(row.help_tags),
//       faqs: Array.isArray(row.faqs) ? row.faqs : [],
//       sessions: stringValue(row.sessions),
//       switch_policy: stringValue(row.switch_policy),
//       category: stringValue(row.category) || 'therapist',
//       days: days.length ? days : null,
//       time_slots: slots.length ? slots : DEFAULT_TIME_SLOTS.slice(),
//       active
//     };
//   }

//   function activeTherapists() {
//     return Array.from(state.therapists.values()).filter(therapist => therapist.active);
//   }

//   function therapistFee(therapist) {
//     if (!therapist?.price) return '';
//     return therapist.duration ? `${therapist.price} for ${therapist.duration}` : therapist.price;
//   }

//   function loadTherapists() {
//     if (state.therapistsPromise) return state.therapistsPromise;
//     const url = apiUrl();
//     const separator = url.includes('?') ? '&' : '?';
//     state.therapistsPromise = fetchJson(`${url}${separator}action=therapists&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (payload?.success === false) {
//         throw new Error(payload.message || 'The therapist service rejected the request.');
//       }
//       const records = Array.isArray(payload) ? payload : payload?.therapists || payload?.data;
//       if (!Array.isArray(records)) {
//         throw new Error('The therapist response does not contain a valid therapists list.');
//       }
//       const nextTherapists = new Map();
//       records.forEach(record => {
//         const therapist = normaliseTherapist(record);
//         if (therapist) nextTherapists.set(therapist.id, therapist);
//       });
//       state.therapists = nextTherapists;
//       if (state.therapists.size > 0) {
//         renderHomeCarousel();
//         renderListingCards();
//       } else {
//         renderHomeTherapistStatus('No therapists are available right now.');
//         renderListingStatus('No therapists are available right now.');
//         if (!state.profileFallback) {
//           renderProfileStatus('This therapist is not available right now.');
//         }
//       }
//     }).catch(error => {
//       console.warn('[DoctorBooking] Therapist sheet data could not be loaded.', error);
//       renderHomeTherapistStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderListingStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderProfileStatus('This therapist could not be loaded. Please try again shortly.', true);
//       throw error;
//     }).finally(() => { state.therapistsPromise = null; });
//     return state.therapistsPromise;
//   }

//   function renderHomeCarousel() {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     const bookLabel = stringValue(carousel.dataset.bookLabel) || 'Book Session';
//     const endLink = carousel.querySelector('.carousel-end');
//     carousel.innerHTML = therapists.map((therapist, index) => {
//       const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//       const media = therapist.image_url
//         ? `<img loading="lazy" src="${esc(therapist.image_url)}" alt="${esc(therapist.name)}">`
//         : `<div class="mini-initials">${esc(initialsOf(therapist.name))}</div>`;
//       const slot = therapist.availability
//         ? `<span class="mini-slot"><span class="dot"></span>${esc(therapist.availability)}</span>`
//         : '';
//       return `<article class="mini-card" data-therapist-id="${esc(therapist.id)}">
//         <div class="mini-media" style="--card-a:${palette[0]};--card-b:${palette[1]}">${media}${slot}</div>
//         <div class="mini-body"><div class="mini-name-row"><h3>${esc(therapist.name)}</h3><span class="mini-verified" aria-label="Verified">&#10003;</span></div><div class="mini-role">${esc(therapist.role)}</div><div class="mini-meta"><span class="star">&#9733;</span> ${esc(therapist.rating)}</div><div class="mini-price">${esc(therapist.price)}</div><button type="button" class="mini-book db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">${esc(bookLabel)}</button></div>
//       </article>`;
//     }).join('');
//     if (endLink) {
//       endLink.hidden = false;
//       carousel.appendChild(endLink);
//     }
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderHomeTherapistStatus(message, isError = false) {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const status = document.createElement('div');
//     status.className = `mt-therapists-status${isError ? ' mt-therapists-status-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     carousel.replaceChildren(status);
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderListingStatus(message, isError = false) {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const status = document.createElement('div');
//     status.className = `db-list-status${isError ? ' db-list-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     listEl.replaceChildren(status);
//     listEl.setAttribute('aria-busy', 'false');
//   }

//   function renderProfileStatus(message, isError = false) {
//     const loader = document.getElementById('dbProfileLoading');
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!loader || !profile) return;
//     profile.hidden = true;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//     const status = document.createElement('div');
//     status.className = `db-profile-status${isError ? ' db-profile-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     loader.replaceChildren(status);
//     loader.hidden = false;
//   }

//   function revealProfilePage(profile) {
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = true;
//     profile.hidden = false;
//     profile.setAttribute('aria-busy', 'false');
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = false;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//   }

//   function listingCardHtml(therapist, index) {
//     const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//     const tags = therapist.expertise.split(',').map(tag => tag.trim()).filter(Boolean)
//       .map(tag => `<span class="tag">${esc(tag)}</span>`).join('');
//     const mediaStyle = therapist.image_url
//       ? `background:url('${esc(therapist.image_url)}') center/cover no-repeat, linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`
//       : `background:linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`;
//     const meta = [
//       `<span class="star">&#9733;</span>${esc(therapist.rating)}`,
//       therapist.role ? `<span class="sep">&middot;</span> ${esc(therapist.role)}` : '',
//       therapist.experience ? `<span class="sep">&middot;</span> ${esc(therapist.experience)}` : ''
//     ].join(' ');
//     return `<article class="t-card" data-id="${esc(therapist.id)}" data-category="${esc(therapist.category)}" data-open="${esc(therapist.id)}">
//       <div class="media" style="${mediaStyle}">
//         ${therapist.image_url ? '' : `<div class="media-initials">${esc(initialsOf(therapist.name))}</div>`}
//         ${therapist.availability ? `<span class="slot-badge"><span class="dot"></span>Next: ${esc(therapist.availability)}</span>` : ''}
//       </div>
//       <div class="t-body">
//         <div class="name-row"><h2>${esc(therapist.name)}</h2><span class="verified" title="Verified">&#10003;</span></div>
//         <div class="meta-line">${meta}</div>
//         ${tags ? `<div class="tags-row">${tags}</div>` : ''}
//         ${therapist.bio ? `<p class="bio-line">${esc(therapist.bio)}</p>` : ''}
//        ${String(therapist.trust_line || '')
//   .split('|')
//   .map(line => line.trim())
//   .filter(Boolean)
//   .map(line => `
//     <div class="trust-line">
//       <span class="ic">&#10003;</span>
//       <span>${esc(line)}</span>
//     </div>
//   `)
//   .join('')}
//         ${therapist.sessions ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.sessions)}</div>` : ''}
//         ${therapist.switch_policy ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.switch_policy)}</div>` : ''}
//         <div class="price-cta-row">
//           <div class="price-line">
//             <span class="p-label">${esc(therapist.centre)}${therapist.duration ? ` &middot; ${esc(therapist.duration)}` : ''}</span>
//             <span class="p-value">${esc(therapist.price)}</span>
//           </div>
//           <div class="cta-buttons-row">
//             <a href="/pages/doctor-profile?id=${encodeURIComponent(therapist.id)}" class="consult-btn" data-consult="${esc(therapist.id)}">Free 15-min call</a>
//             <button type="button" class="book-btn db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">Book Session</button>
//           </div>
//         </div>
//       </div>
//     </article>`;
//   }

//   function renderListingCards() {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     listEl.innerHTML = therapists.map((therapist, index) => listingCardHtml(therapist, index)).join('');
//     listEl.setAttribute('aria-busy', 'false');
//     updateDoctorCards();
//     filterDoctors();
//   }

//   function isoOf(day) {
//     return `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
//   }

//   function dateFromIso(iso) {
//     const match = stringValue(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
//     if (!match) return null;
//     const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
//     return Number.isNaN(date.getTime()) ? null : date;
//   }

//   function parseBooked(payload) {
//     const entries = Array.isArray(payload?.booked) ? payload.booked : [];
//     state.bookedMap = new Map();
//     state.pendingMap = new Map();
//     entries.forEach(entry => {
//       const docId = normalizeId(entry.doctor_id).replace(/\s+/g, '-');
//       const iso = stringValue(entry.date);
//       const time = normaliseSlotTime(entry.time);
//       if (!docId || !/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//       const key = `${docId}|${iso}`;
//       const pending = stringValue(entry.status).toLowerCase() === 'payment_pending';
//       const target = pending ? state.pendingMap : state.bookedMap;
//       if (!target.has(key)) target.set(key, new Set());
//       target.get(key).add(time);
//     });
//     state.localBooked = state.localBooked.filter(entry => !entry.expiresAt || Date.parse(entry.expiresAt) > Date.now());
//     state.localBooked.forEach(entry => {
//       const key = `${entry.doctorId}|${entry.date}`;
//       if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//       state.pendingMap.get(key).add(entry.time);
//     });
//   }

//   function activeDatePill() {
//     return document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill.active')
//       || document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill');
//   }

//   function modalSlots(iso = activeDatePill()?.dataset.iso || '') {
//     if (state.availabilityEnabled) {
//       return state.doctors.get(state.currentDoctorId)?.schedule?.[iso] || [];
//     }
//     const slots = state.modalDoctor?.time_slots;
//     return slots?.length ? slots : DEFAULT_TIME_SLOTS;
//   }

//   function markFullDatePills() {
//     document.querySelectorAll('#dbBookingModal .db-date-pill').forEach(pill => {
//       const slots = modalSlots(pill.dataset.iso);
//       const booked = state.bookedMap.get(`${state.currentDoctorId}|${pill.dataset.iso}`);
//       const isFull = slots.length > 0 && !!booked && slots.every(slot => booked.has(slot));
//       pill.classList.toggle('db-date-full', isFull);
//     });
//   }

//   function ensureDatePills(therapist) {
//     const row = document.querySelector('#dbBookingModal .db-date-picker-row');
//     if (!row) return;
//     const previousIso = activeDatePill()?.dataset.iso || '';
//     if (!state.loaded) {
//       setHiddenValue('dbBookingDate', '');
//       showLoading(row, 'Loading dates…');
//       return;
//     }

//     if (state.availabilityEnabled) {
//       const today = isoOf(new Date());
//       const schedule = state.doctors.get(state.currentDoctorId)?.schedule || {};
//       const dates = Object.keys(schedule)
//         .filter(iso => iso >= today && Array.isArray(schedule[iso]) && schedule[iso].length)
//         .sort();
//       if (!dates.length) {
//         setHiddenValue('dbBookingDate', '');
//         setHiddenValue('dbBookingTime', '');
//         renderMessage(row, 'No upcoming dates are available for this therapist.');
//         return;
//       }
//       row.innerHTML = dates.map(iso => {
//         const day = dateFromIso(iso);
//         const dayName = DAY_NAMES[day.getDay()];
//         const offset = Math.round((day.getTime() - dateFromIso(today).getTime()) / 86400000);
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         return `<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`;
//       }).join('');
//       markFullDatePills();
//       const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//       const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//       active?.classList.add('active');
//       setHiddenValue('dbBookingDate', active?.dataset.date || '');
//       return;
//     }

//     const build = useDayFilter => {
//       const pills = [];
//       const now = new Date();
//       for (let offset = 0; offset < 60 && pills.length < 30; offset++) {
//         const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
//         const dayName = DAY_NAMES[day.getDay()];
//         if (useDayFilter && therapist?.days && !therapist.days.includes(dayName)) continue;
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         const iso = isoOf(day);
//         pills.push(`<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`);
//       }
//       return pills;
//     };
//     let pills = build(true);
//     if (!pills.length) pills = build(false);
//     row.innerHTML = pills.join('');
//     markFullDatePills();
//     const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//     const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingDate', active?.dataset.date || '');
//   }

//   function renderTimePills() {
//     const grid = document.querySelector('#dbBookingModal .db-time-grid');
//     if (!grid) return;
//     if (!state.loaded) {
//       setHiddenValue('dbBookingTime', '');
//       showLoading(grid);
//       return;
//     }
//     const previous = stringValue(document.getElementById('dbBookingTime')?.value);
//     const iso = activeDatePill()?.dataset.iso || '';
//     const slots = modalSlots(iso);
//     if (!iso || !slots.length) {
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(grid, iso ? 'No times are available on this date.' : 'Select an available date first.');
//       return;
//     }
//     const booked = state.bookedMap.get(`${state.currentDoctorId}|${iso}`);
//     const pending = state.pendingMap.get(`${state.currentDoctorId}|${iso}`);
//     grid.innerHTML = slots.map(slot => {
//       if (booked?.has(slot)) {
//         return `<div class="db-time-pill db-time-booked" aria-disabled="true">${esc(slot)}<span class="db-booked-tag">Booked</span></div>`;
//       }
//       if (pending?.has(slot)) {
//         return `<div class="db-time-pill db-time-pending" title="Reserved. Select only to resume your existing payment.">${esc(slot)}<span class="db-booked-tag">Payment pending</span></div>`;
//       }
//       return `<div class="db-time-pill">${esc(slot)}</div>`;
//     }).join('');
//     const active = Array.from(grid.querySelectorAll('.db-time-pill:not(.db-time-booked)'))
//       .find(pill => slotText(pill) === previous)
//       || grid.querySelector('.db-time-pill:not(.db-time-booked):not(.db-time-pending)');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingTime', active ? slotText(active) : '');
//   }

//   const slotText = pill => pill?.querySelector('.db-booked-tag')
//     ? pill.textContent.replace(pill.querySelector('.db-booked-tag').textContent, '').trim()
//     : stringValue(pill?.textContent);

//   function safeUuid() {
//     if (window.crypto?.randomUUID) return window.crypto.randomUUID();
//     return `booking-${Date.now()}-${Math.random().toString(16).slice(2)}`;
//   }

//   function clearElement(element) {
//     if (element) element.replaceChildren();
//   }

//   function renderMessage(container, message, isError = false) {
//     if (!container) return;
//     clearElement(container);
//     const status = document.createElement('div');
//     status.className = `db-availability-message${isError ? ' db-availability-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     container.appendChild(status);
//   }

//   function showLoading(container, message = 'Loading availability…') {
//     if (!container) return;
//     clearElement(container);
//     const wrapper = document.createElement('div');
//     wrapper.className = 'db-loading-spinner-wrap';
//     wrapper.setAttribute('role', 'status');
//     const spinner = document.createElement('div');
//     spinner.className = 'db-loading-spinner';
//     spinner.setAttribute('aria-hidden', 'true');
//     const label = document.createElement('span');
//     label.textContent = message;
//     wrapper.append(spinner, label);
//     container.appendChild(wrapper);
//   }

//   function normaliseSchedule(value) {
//     const schedule = {};
//     if (Array.isArray(value)) {
//       value.forEach(entry => {
//         const iso = stringValue(entry?.date);
//         const slots = Array.isArray(entry?.slots) ? entry.slots : [];
//         if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
//           schedule[iso] = [...new Set(slots.map(normaliseSlotTime).filter(Boolean))];
//         }
//       });
//       return schedule;
//     }
//     if (!value || typeof value !== 'object') return schedule;
//     Object.keys(value).forEach(iso => {
//       if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !Array.isArray(value[iso])) return;
//       schedule[iso] = [...new Set(value[iso].map(normaliseSlotTime).filter(Boolean))];
//     });
//     return schedule;
//   }

//   function normaliseDoctor(record) {
//     if (!record || typeof record !== 'object') return null;
//     const id = normalizeId(record.doctor_id || record.doctorId || record.handle || record.id);
//     if (!id) return null;
//     const schedule = normaliseSchedule(record.schedule || record.availability_by_date);
//     return {
//       ...record,
//       doctor_id: id,
//       next_slot: stringValue(record.next_slot || record.nextSlot),
//       dates: Array.isArray(record.dates || record.available_dates)
//         ? (record.dates || record.available_dates).map(stringValue).filter(Boolean)
//         : Object.keys(schedule),
//       schedule
//     };
//   }

//   function normalisePayload(payload) {
//     if (payload && payload.success === false) {
//       throw new Error(payload.message || 'The booking service rejected the availability request.');
//     }
//     const records = Array.isArray(payload) ? payload : payload?.doctors || payload?.data || payload?.availability || [];
//     const map = new Map();
//     records.forEach(item => {
//       const doc = normaliseDoctor(item);
//       if (doc) map.set(doc.doctor_id, doc);
//     });
//     return map;
//   }

//   async function fetchJson(url, options = {}) {
//     const controller = new AbortController();
//     const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
//     try {
//       const response = await fetch(url, { ...options, signal: controller.signal });
//       const text = await response.text();
//       let data = null;
//       try { data = JSON.parse(text); } catch (_) { }
//       if (!response.ok) {
//         const error = new Error(data?.message || `Request failed with HTTP status ${response.status}`);
//         error.code = data?.code || `HTTP_${response.status}`;
//         throw error;
//       }
//       if (data === null) {
//         const error = new Error('The booking service returned an invalid response. Check the latest Apps Script execution log.');
//         error.code = 'INVALID_JSON_RESPONSE';
//         throw error;
//       }
//       return data;
//     } finally {
//       window.clearTimeout(timeout);
//     }
//   }

//   function setHiddenValue(id, value) {
//     const input = document.getElementById(id);
//     if (input && typeof value !== 'undefined') input.value = value;
//   }

//   function updateDoctorCards() {
//     document.querySelectorAll('.t-card, .db-doctor-card, .mini-card').forEach(card => {
//       const id = normalizeId(card.dataset.id || card.dataset.open || card.dataset.therapistId);
//       const doctor = state.doctors.get(id);
//       if (!doctor) return;
//       const badge = card.querySelector('.slot-badge, .db-next-slot, .mini-slot');
//       if (doctor.next_slot) {
//         if (badge) {
//           badge.style.display = '';
//           const dot = badge.querySelector('.dot, .db-status-dot');
//           if (dot) {
//             badge.innerHTML = `<span class="dot"></span>Next: ${esc(doctor.next_slot)}`;
//           } else {
//             badge.textContent = `Next: ${doctor.next_slot}`;
//           }
//         }
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     });

//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     const profileId = normalizeId(profile?.dataset.doctorId);
//     const profileDoctor = state.doctors.get(profileId);
//     if (profile && profileDoctor) {
//       const badge = profile.querySelector('.slot-badge');
//       const value = badge?.querySelector('[data-bind="next_slot"]');
//       if (profileDoctor.next_slot) {
//         if (value) value.textContent = profileDoctor.next_slot;
//         if (badge) badge.style.display = '';
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     }
//   }

//   async function loadAvailability() {
//     const url = apiUrl();
//     if (!url) return null;
//     if (state.loadingPromise) return state.loadingPromise;
//     const separator = url.includes('?') ? '&' : '?';
//     state.loadingPromise = fetchJson(`${url}${separator}action=availability&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (!Array.isArray(payload?.booked)) throw new Error('Availability response is missing booked slots.');
//       state.doctors = normalisePayload(payload);
//       state.availabilityEnabled = payload?.availability_enabled === true;
//       state.loaded = true;
//       parseBooked(payload);
//       updateDoctorCards();
//       if (document.getElementById('dbBookingModal')?.classList.contains('active')) {
//         ensureDatePills(state.modalDoctor);
//         renderTimePills();
//       }
//       return payload;
//     }).catch(error => {
//       state.loaded = false;
//       setHiddenValue('dbBookingDate', '');
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(document.querySelector('#dbBookingModal .db-date-picker-row'), 'Available dates could not be checked. Please try again.', true);
//       renderMessage(document.getElementById('dbTimeGrid'), 'Availability could not be checked. Please reopen the booking form to retry.', true);
//       console.warn('[DoctorBooking] Note on live availability:', error);
//     }).finally(() => { state.loadingPromise = null; });
//     return state.loadingPromise;
//   }

//   function initAutoRefresh() {
//     const refreshSheetData = () => {
//       loadTherapists().then(renderProfilePage).catch(() => { });
//       loadAvailability().catch(() => { });
//     };
//     state.refreshTimer = window.setInterval(() => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     }, REFRESH_INTERVAL_MS);
//     document.addEventListener('visibilitychange', () => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     });
//   }

//   /* ---------- Category Filter Tabs ---------- */
//   function initCategoryTabs() {
//     document.querySelectorAll('.db-tab-btn').forEach(tab => {
//       tab.addEventListener('click', () => {
//         document.querySelectorAll('.db-tab-btn').forEach(item => item.classList.remove('active'));
//         tab.classList.add('active');
//         filterDoctors();
//       });
//     });
//   }

//   function filterDoctors() {
//     const category = document.querySelector('.db-tab-btn.active')?.dataset.category || 'all';
//     document.querySelectorAll('.t-card, .db-doctor-card').forEach(card => {
//       const cardCat = stringValue(card.dataset.category).toLowerCase();
//       const visible = (category === 'all' || cardCat.includes(category.toLowerCase()));
//       card.style.display = visible ? '' : 'none';
//     });
//   }

//   /* ---------- Selection Events (Mode / Date / Time) ---------- */
//   function initSelectionEvents() {
//     document.addEventListener('click', event => {
//       const modeButton = event.target.closest('.db-mode-btn');
//       if (modeButton) {
//         const selector = modeButton.closest('.db-mode-selector');
//         selector?.querySelectorAll('.db-mode-btn').forEach(button => {
//           button.classList.toggle('active', button === modeButton);
//         });
//         const mode = normalizeMode(modeButton.dataset.mode || modeButton.textContent);
//         setHiddenValue('dbConsultationMode', mode);
//         return;
//       }

//       const datePill = event.target.closest('.db-date-pill');
//       if (datePill) {
//         if (datePill.classList.contains('db-date-full')) return;
//         const row = datePill.closest('.db-date-picker-row');
//         row?.querySelectorAll('.db-date-pill').forEach(pill => pill.classList.remove('active'));
//         datePill.classList.add('active');
//         setHiddenValue('dbBookingDate', datePill.dataset.date || '');
//         renderTimePills();
//         return;
//       }

//       const timePill = event.target.closest('.db-time-pill');
//       if (timePill) {
//         if (timePill.classList.contains('db-time-booked')) return;
//         const grid = timePill.closest('.db-time-grid');
//         grid?.querySelectorAll('.db-time-pill').forEach(pill => pill.classList.remove('active'));
//         timePill.classList.add('active');
//         setHiddenValue('dbBookingTime', slotText(timePill));
//         if (timePill.classList.contains('db-time-pending')) {
//           window.alert('This slot is reserved pending payment. Continue only to resume your booking using the same verified WhatsApp number.');
//         }
//       }
//     });
//   }

//   /* ---------- Booking Modal Functions ---------- */
//   function openBookingModal(button) {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     const card = button.closest('.t-card, .profile-page, #profileContent');
//     const id = normalizeId(button.dataset.docId || card?.dataset.id || card?.dataset.open || state.currentDoctorId || 'palak-chhabra');
//     state.currentDoctorId = id;
//     state.bookingRequestId = '';
//     state.otpChallengeId = '';
//     state.otpVerificationToken = '';
//     state.currentCheckout = null;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;

//     const name = stringValue(button.dataset.docName)
//       || stringValue(card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent)
//       || 'Therapist';
//     const fee = stringValue(button.dataset.docFee)
//       || stringValue(card?.querySelector('.price-line .p-value, [data-bind="fee"]')?.textContent)
//       || '₹2000';

//     const therapist = state.therapists.get(id);
//     const fallbackDoc = state.profileFallback?.[id];
//     let resolvedName = name;
//     let resolvedFee = fee;
//     if (therapist) {
//       resolvedName = therapist.name || name;
//       resolvedFee = therapistFee(therapist) || fee;
//     } else if (fallbackDoc) {
//       resolvedName = fallbackDoc.name || name;
//       resolvedFee = fallbackDoc.fee || fee;
//     }
//     state.modalDoctor = therapist || null;

//     const nameElement = document.getElementById('dbModalDocName');
//     const feeElement = document.getElementById('dbModalDocFee');
//     if (nameElement) nameElement.textContent = resolvedName;
//     if (feeElement) feeElement.textContent = resolvedFee;

//     setHiddenValue('dbDoctorId', id);
//     setHiddenValue('dbDoctorName', resolvedName);
//     setHiddenValue('dbDoctorFee', resolvedFee);

//     setHiddenValue('dbBookingTime', '');
//     ensureDatePills(therapist);
//     renderTimePills();

//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     if (paymentButtonContainer) {
//       paymentButtonContainer.style.display = 'none';
//       paymentButtonContainer.replaceChildren();
//     }

//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'block';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'none';
//     const otpInput = document.getElementById('dbOtpCode');
//     if (otpInput) otpInput.value = '';
//     const otpStatus = document.getElementById('dbOtpStatus');
//     if (otpStatus) otpStatus.textContent = '';

//     modal.classList.add('active');
//     loadAvailability().catch(() => {});
//   }

//   const closeBookingModal = () => {
//     document.getElementById('dbBookingModal')?.classList.remove('active');
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//   };

//   function markSlotBookedLocally(iso, time, expiresAt) {
//     if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//     state.localBooked.push({ doctorId: state.currentDoctorId, date: iso, time, expiresAt });
//     const key = `${state.currentDoctorId}|${iso}`;
//     if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//     state.pendingMap.get(key).add(time);
//     markFullDatePills();
//     renderTimePills();
//     loadAvailability().catch(() => { });
//   }

//   function loadRazorpayCheckout() {
//     if (window.Razorpay) return Promise.resolve();
//     if (state.checkoutPromise) return state.checkoutPromise;
//     state.checkoutPromise = new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;
//       script.onload = () => resolve();
//       script.onerror = () => reject(new Error('Razorpay Checkout could not be loaded.'));
//       document.head.appendChild(script);
//     }).finally(() => { state.checkoutPromise = null; });
//     return state.checkoutPromise;
//   }

//   async function verifyRazorpayPayment(response) {
//     let lastResult = null;
//     for (let attempt = 0; attempt < 3; attempt++) {
//       if (attempt > 0) await new Promise(resolve => window.setTimeout(resolve, 1500));
//       lastResult = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_payment',
//           request_id: state.bookingRequestId,
//           razorpay_payment_id: response.razorpay_payment_id,
//           razorpay_order_id: response.razorpay_order_id,
//           razorpay_signature: response.razorpay_signature
//         })
//       });
//       if (lastResult?.success === true && stringValue(lastResult?.status).toLowerCase() === 'confirmed') return lastResult;
//       if (lastResult?.code !== 'PAYMENT_NOT_CAPTURED') break;
//     }
//     const error = new Error(lastResult?.message || 'Payment verification is still pending.');
//     error.code = lastResult?.code || 'PAYMENT_VERIFICATION_FAILED';
//     throw error;
//   }

//   async function startRazorpayCheckout(checkout) {
//     if (!checkout?.key_id || !checkout?.order_id || !checkout?.amount) return;
//     try {
//       await loadRazorpayCheckout();
//       const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//       const patientEmail = stringValue(document.getElementById('dbPatientEmail')?.value);
//       const rawPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//       const phoneDigits = rawPhone.replace(/\D/g, '');
//       const patientPhone = rawPhone.startsWith('+')
//         ? `+${phoneDigits}`
//         : phoneDigits.length === 10
//           ? `+91${phoneDigits}`
//           : `+${phoneDigits}`;
//       const razorpay = new window.Razorpay({
//         key: checkout.key_id,
//         order_id: checkout.order_id,
//         amount: checkout.amount,
//         currency: checkout.currency || 'INR',
//         name: 'MushinTalks',
//         description: `Therapy session with ${stringValue(document.getElementById('dbDoctorName')?.value)}`,
//         prefill: {
//           name: patientName,
//           email: patientEmail,
//           contact: patientPhone
//         },
//         readonly: { name: true, contact: true, email: Boolean(patientEmail) },
//         hidden: { contact: true, email: Boolean(patientEmail) },
//         theme: { color: '#786c8a' },
//         handler: async response => {
//           const successTitle = document.getElementById('dbSuccessTitle');
//           const successText = document.getElementById('dbSuccessText');
//           if (successTitle) successTitle.textContent = 'Verifying Payment…';
//           if (successText) successText.textContent = 'Please wait while we securely confirm your payment.';
//           try {
//             const verified = await verifyRazorpayPayment(response);
//             state.bookingRequestId = '';
//             state.currentCheckout = null;
//             showBookingSuccess(verified.payment_status, verified.status, null);
//           } catch (error) {
//             showBookingSuccess('pending', 'payment_pending', checkout);
//             window.alert(error?.message || 'Payment verification is pending. Please contact us with your payment ID.');
//           }
//         }
//       });
//       razorpay.on('payment.failed', response => {
//         const description = response?.error?.description || 'Payment failed. You can retry using the same reserved slot.';
//         window.alert(description);
//       });
//       razorpay.open();
//     } catch (error) {
//       window.alert(error?.message || 'Payment could not be opened. Please try again.');
//     }
//   }

//   function renderCheckoutButton(container, checkout) {
//     container.replaceChildren();
//     const button = document.createElement('button');
//     button.type = 'button';
//     button.className = 'db-btn-primary db-pay-now-btn';
//     button.textContent = 'Pay Now →';
//     button.addEventListener('click', () => startRazorpayCheckout(checkout));
//     container.appendChild(button);
//   }

//   function showBookingSuccess(paymentStatus, bookingStatus, checkout) {
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'none';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'block';
//     const normalizedPaymentStatus = stringValue(paymentStatus).toLowerCase();
//     const normalizedBookingStatus = stringValue(bookingStatus).toLowerCase();
//     const paymentConfirmed = ['paid', 'captured', 'success'].includes(normalizedPaymentStatus)
//       || normalizedBookingStatus === 'confirmed';
//     const successTitle = document.getElementById('dbSuccessTitle');
//     const successText = document.getElementById('dbSuccessText');
//     if (successTitle) successTitle.textContent = paymentConfirmed ? 'Booking Confirmed!' : 'Slot Reserved';
//     if (successText) {
//       successText.textContent = paymentConfirmed
//         ? 'Your payment is confirmed and your consultation has been booked.'
//         : 'Your slot is reserved pending payment. Complete the payment below to confirm your booking.';
//     }
//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     const resolvedCheckout = checkout?.order_id ? checkout : state.currentCheckout;
//     if (paymentButtonContainer) {
//       if (!paymentConfirmed && resolvedCheckout) {
//         state.currentCheckout = resolvedCheckout;
//         paymentButtonContainer.style.display = 'block';
//         renderCheckoutButton(paymentButtonContainer, resolvedCheckout);
//       } else {
//         paymentButtonContainer.style.display = 'none';
//         paymentButtonContainer.replaceChildren();
//         if (!paymentConfirmed && successText) {
//           successText.textContent = 'The payment session could not be prepared. Close this window and retry the same slot with the same phone number.';
//         }
//       }
//     }
//   }

//   function setOtpStatus(message, isError = false) {
//     const status = document.getElementById('dbOtpStatus');
//     if (!status) return;
//     status.textContent = message || '';
//     status.classList.toggle('db-otp-status-error', Boolean(isError));
//   }

//   function validateOtpRequestForm() {
//     if (!state.loaded) {
//       window.alert('Please wait until availability has been checked.');
//       return null;
//     }
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return null;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');
//     const localDigits = phoneDigits.length === 12 && phoneDigits.startsWith('91')
//       ? phoneDigits.slice(2)
//       : phoneDigits.length === 11 && phoneDigits.startsWith('0')
//         ? phoneDigits.slice(1)
//         : phoneDigits;
//     if (!patientName || !/^[6-9]\d{9}$/.test(localDigits)) {
//       window.alert('Please enter your full name and a valid 10-digit Indian WhatsApp number.');
//       return null;
//     }
//     if (!stringValue(document.getElementById('dbBookingTime')?.value)) {
//       window.alert('Please select an available time slot first.');
//       return null;
//     }
//     return { patientName, patientPhone };
//   }

//   function startOtpResendCountdown(seconds) {
//     const button = document.getElementById('dbOtpResendBtn');
//     if (!button) return;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     let remaining = Math.max(1, Number(seconds) || 60);
//     const render = () => {
//       button.disabled = remaining > 0;
//       button.textContent = remaining > 0 ? `Resend in ${remaining}s` : 'Resend code';
//     };
//     render();
//     state.otpResendTimer = window.setInterval(() => {
//       remaining -= 1;
//       render();
//       if (remaining <= 0) {
//         window.clearInterval(state.otpResendTimer);
//         state.otpResendTimer = null;
//       }
//     }, 1000);
//   }

//   async function requestBookingOtp(button) {
//     const details = validateOtpRequestForm();
//     if (!details) return;
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'SENDING CODE…';
//     setOtpStatus('');
//     let result = null;
//     try {
//       result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({ action: 'send_otp', patient_phone: details.patientPhone })
//       });
//       if (result?.success !== true || !result?.challenge_id) {
//         const unknownOtpAction = result?.code === 'UNKNOWN_ACTION' ||
//           /^Unknown action:\s*send_otp$/i.test(stringValue(result?.message));
//         const error = new Error(unknownOtpAction
//           ? 'The booking service is using an older Apps Script deployment. Publish the latest Code.gs as a new version of the existing web app deployment, then try again.'
//           : result?.message || 'The verification code could not be sent.');
//         error.code = result?.code || 'OTP_SEND_FAILED';
//         throw error;
//       }
//       state.otpChallengeId = stringValue(result.challenge_id);
//       state.otpVerificationToken = '';
//       const stepOne = document.getElementById('dbModalStep1');
//       const otpStep = document.getElementById('dbModalStepOtp');
//       if (stepOne) stepOne.style.display = 'none';
//       if (otpStep) otpStep.style.display = 'block';
//       const masked = document.getElementById('dbOtpMaskedPhone');
//       if (masked) masked.textContent = stringValue(result.masked_phone) || 'your WhatsApp number';
//       const input = document.getElementById('dbOtpCode');
//       if (input) {
//         input.value = '';
//         input.focus();
//       }
//       setOtpStatus('Code sent. It expires in 5 minutes.');
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP could not be sent.', error);
//       setOtpStatus(error?.message || 'The verification code could not be sent.', true);
//       window.alert(error?.message || 'The verification code could not be sent.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//     if (result?.success === true) startOtpResendCountdown(result.retry_after);
//   }

//   async function verifyBookingOtp(button) {
//     const otp = stringValue(document.getElementById('dbOtpCode')?.value).replace(/\D/g, '');
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     if (!state.otpChallengeId || !/^\d{6}$/.test(otp)) {
//       setOtpStatus('Enter the 6-digit code sent on WhatsApp.', true);
//       return;
//     }
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'VERIFYING…';
//     setOtpStatus('Verifying code…');
//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_otp',
//           patient_phone: patientPhone,
//           challenge_id: state.otpChallengeId,
//           otp
//         })
//       });
//       if (result?.success !== true || !result?.verification_token) {
//         const error = new Error(result?.message || 'The verification code is incorrect.');
//         error.code = result?.code || 'OTP_INCORRECT';
//         throw error;
//       }
//       state.otpVerificationToken = stringValue(result.verification_token);
//       setOtpStatus('WhatsApp number verified. Reserving your slot…');
//       await submitBooking(button);
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP verification failed.', error);
//       setOtpStatus(error?.message || 'The verification code could not be verified.', true);
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   async function submitBooking(button) {
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');

//     if (!patientName || phoneDigits.length < 7 || phoneDigits.length > 15) {
//       window.alert('Please enter your full name and a valid phone number.');
//       return;
//     }

//     const mode = stringValue(document.getElementById('dbConsultationMode')?.value) || 'Online Video';
//     const datePill = activeDatePill();
//     const date = datePill?.dataset.iso || stringValue(document.getElementById('dbBookingDate')?.value) || 'Today';
//     const time = stringValue(document.getElementById('dbBookingTime')?.value);
//     if (!time) {
//       window.alert('No slots are left on this date — please pick another day.');
//       return;
//     }

//     if (!state.bookingRequestId) state.bookingRequestId = safeUuid();
//     const payload = {
//       action: 'book',
//       request_id: state.bookingRequestId,
//       doctor_id: state.currentDoctorId,
//       doctor_name: stringValue(document.getElementById('dbDoctorName')?.value),
//       doctor_fee: stringValue(document.getElementById('dbDoctorFee')?.value),
//       patient_name: patientName,
//       patient_phone: patientPhone,
//       patient_email: stringValue(document.getElementById('dbPatientEmail')?.value),
//       otp_verification_token: state.otpVerificationToken,
//       mode: mode,
//       date: date,
//       date_label: stringValue(datePill?.dataset.date),
//       time: time,
//       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       source: 'shopify-storefront'
//     };

//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'CONFIRMING…';

//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const resultStatus = stringValue(result?.status || 'booked').toLowerCase();
//       const confirmed = result?.success === true && ['booked', 'confirmed', 'payment_pending', 'reserved'].includes(resultStatus);
//       if (!confirmed) {
//         const bookingError = new Error(result?.message || 'The slot could not be booked.');
//         bookingError.code = result?.code || 'BOOKING_REJECTED';
//         throw bookingError;
//       }
//       showBookingSuccess(
//         result?.payment_status,
//         result?.status,
//         result?.checkout
//       );
//       state.bookingRequestId = stringValue(result?.request_id) || state.bookingRequestId;
//       markSlotBookedLocally(date, time, result?.payment_expires_at);
//     } catch (error) {
//       console.error('[DoctorBooking] Booking was not confirmed.', error);
//       if (error?.code === 'SLOT_ALREADY_BOOKED') state.bookingRequestId = '';
//       if (['OTP_REQUIRED', 'OTP_EXPIRED', 'OTP_INVALID', 'OTP_ALREADY_USED'].includes(error?.code)) {
//         state.otpVerificationToken = '';
//         setOtpStatus(error?.message || 'Verify your WhatsApp number again.', true);
//         const otpStep = document.getElementById('dbModalStepOtp');
//         if (otpStep) otpStep.style.display = 'block';
//       }
//       await loadAvailability().catch(() => { });
//       window.alert(error?.message || 'The booking could not be confirmed. Please try again.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   function initBookingModal() {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     document.addEventListener('click', event => {
//       const bookButton = event.target.closest('.book-btn, .buy-btn, .db-btn-book');
//       if (bookButton) {
//         event.preventDefault();
//         event.stopPropagation();
//         openBookingModal(bookButton);
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.closest('.db-modal-close, .db-modal-cancel')) closeBookingModal();
//     });

//     document.addEventListener('keydown', event => {
//       if (event.key === 'Escape' && modal.classList.contains('active')) closeBookingModal();
//     });

//     modal.querySelector('.db-date-prev')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: -160, behavior: 'smooth' });
//     });
//     modal.querySelector('.db-date-next')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: 160, behavior: 'smooth' });
//     });

//     document.getElementById('dbConfirmBookingBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbVerifyOtpBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       verifyBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpResendBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpBackBtn')?.addEventListener('click', () => {
//       if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//       state.otpResendTimer = null;
//       state.otpChallengeId = '';
//       state.otpVerificationToken = '';
//       const otpStep = document.getElementById('dbModalStepOtp');
//       const stepOne = document.getElementById('dbModalStep1');
//       if (otpStep) otpStep.style.display = 'none';
//       if (stepOne) stepOne.style.display = 'block';
//     });
//     document.getElementById('dbOtpCode')?.addEventListener('keydown', event => {
//       if (event.key === 'Enter') {
//         event.preventDefault();
//         const verifyButton = document.getElementById('dbVerifyOtpBtn');
//         if (verifyButton && !verifyButton.disabled) verifyButton.click();
//       }
//     });
//   }

//   /* ---------- Video Modal ---------- */
//   function initVideoModal() {
//     const modal = document.getElementById('videoModal');
//     const box = document.getElementById('videoBox');
//     if (!modal || !box) return;

//     document.addEventListener('click', event => {
//       const playBtn = event.target.closest('.play-btn, [data-play]');
//       if (playBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//         const card = playBtn.closest('.t-card, .profile-page, #profileContent');
//         const docName = card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent?.trim() || 'this therapist';
//         box.innerHTML = `
//           <div class="vb-fill">A short intro from ${docName} would play here &mdash; 20&ndash;30 seconds, just enough to get a feel for them before you book.</div>
//           <button class="vb-close" id="videoClose">&times;</button>
//         `;
//         modal.classList.add('open');
//         document.getElementById('videoClose')?.addEventListener('click', () => modal.classList.remove('open'));
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.id === 'videoClose') {
//         modal.classList.remove('open');
//       }
//     });
//   }

//   /* ---------- FAQ Accordion ---------- */
//   function initFaqAccordion() {
//     document.addEventListener('click', event => {
//       const faqQ = event.target.closest('.p-faq-q');
//       if (faqQ) {
//         event.preventDefault();
//         const item = faqQ.closest('.p-faq-item');
//         if (item) item.classList.toggle('open');
//       }
//     });
//   }

//   /* ---------- Card Navigation to Profile ---------- */
//   function initCardNavigation() {
//     document.addEventListener('click', event => {
//       const card = event.target.closest('.t-card');
//       if (!card) return;
//       if (event.target.closest('.play-btn, .book-btn, .consult-btn, .db-btn-book, a, button')) return;
//       const docId = card.dataset.open || card.dataset.id;
//       if (docId) {
//         window.location.href = `/pages/doctor-profile?id=${encodeURIComponent(docId)}`;
//       }
//     });
//   }

//   /* ---------- Profile Page Data (Shopify Metafields + Google Sheet) ---------- */
//   function paletteForId(id) {
//     const hash = Array.from(normalizeId(id)).reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 997, 7);
//     return CARD_PALETTES[hash % CARD_PALETTES.length];
//   }

//   function splitList(text) {
//     if (Array.isArray(text)) return text.map(item => stringValue(item)).filter(Boolean);
//     return stringValue(text).split(',').map(item => item.trim()).filter(Boolean);
//   }

//   function normaliseFaqs(value) {
//     return (Array.isArray(value) ? value : []).map(entry => {
//       if (Array.isArray(entry)) return [stringValue(entry[0]), stringValue(entry[1])];
//       if (entry && typeof entry === 'object') return [stringValue(entry.question ?? entry.q), stringValue(entry.answer ?? entry.a)];
//       return ['', ''];
//     }).filter(pair => pair[0] || pair[1]);
//   }

//   function therapistProfile(therapist, palette) {
//     if (!therapist) return null;
//     const data = {
//       name: stringValue(therapist.name),
//       title: stringValue(therapist.role || therapist.title),
//       experience: stringValue(therapist.experience),
//       rating: stringValue(therapist.rating),
//       fee: stringValue(therapist.price || therapist.fee),
//       modes: stringValue(therapist.centre || therapist.modes),
//       duration: stringValue(therapist.duration),
//       speaks: stringValue(therapist.languages || therapist.speaks),
//       initials: initialsOf(therapist.name),
//       next_slot: stringValue(therapist.availability || therapist.next_slot),
//       bio: stringValue(therapist.bio),
//       about: stringValue(therapist.about),
//       how_i_work: stringValue(therapist.how_i_work),
//       sessions: stringValue(therapist.sessions),
//       switch_policy: stringValue(therapist.switch_policy),
//       image_url: safeUrl(therapist.image_url)
//     };
//     const expertise = splitList(therapist.expertise);
//     const helpTags = splitList(therapist.help_tags);
//     const faqs = normaliseFaqs(therapist.faqs);
//     if (expertise.length) data.expertise = expertise;
//     if (helpTags.length) data.help_tags = helpTags;
//     if (faqs.length) data.faqs = faqs;
//     if (palette) data.palette = palette;
//     Object.keys(data).forEach(key => {
//       if (data[key] === '' || data[key] === null || typeof data[key] === 'undefined') {
//         delete data[key];
//       }
//     });
//     return data;
//   }

//   function findTherapistForId(id) {
//     if (!id) return null;
//     const direct = state.therapists.get(id);
//     if (direct) return direct;
//     const fallback = state.profileFallback?.[id];
//     if (!fallback) return null;
//     return state.therapists.get(normalizeId(fallback.name).replace(/\s+/g, '-')) || null;
//   }

//   function applyProfileData(profile, doctor) {
//     if (!profile || !doctor) return;
//     const root = profile.closest('.db-page-wrapper') || profile;

//     ['title', 'experience', 'fee', 'rating', 'speaks', 'about', 'modes', 'duration', 'sessions', 'how_i_work', 'initials', 'next_slot', 'switch_policy'].forEach(field => {
//       root.querySelectorAll(`[data-bind="${field}"]`).forEach(element => {
//         if (doctor[field]) element.textContent = doctor[field];
//       });
//     });

//     root.querySelectorAll('[data-bind="name"]:not(.db-btn-book)').forEach(element => {
//       if (doctor.name) element.textContent = doctor.name;
//     });

//     const slotBadge = root.querySelector('.slot-badge');
//     if (slotBadge) slotBadge.style.display = doctor.next_slot ? '' : 'none';

//     const pMedia = document.getElementById('pMedia');
//     if (pMedia) {
//       const initials = pMedia.querySelector('.media-initials');
//       if (doctor.image_url) {
//         pMedia.style.background = `url("${doctor.image_url.replace(/["'()]/g, '')}") center/cover no-repeat`;
//         if (initials) initials.style.display = 'none';
//       } else if (Array.isArray(doctor.palette)) {
//         pMedia.style.background = `linear-gradient(150deg, ${doctor.palette[0]}, ${doctor.palette[1]} 120%)`;
//         if (initials) initials.style.display = '';
//       }
//     }

//     const tags = root.querySelector('[data-bind="expertise-tags"]');
//     if (tags && Array.isArray(doctor.expertise)) {
//       clearElement(tags);
//       doctor.expertise.forEach(expertise => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = expertise;
//         tags.appendChild(tag);
//       });
//     }

//     const helpTags = root.querySelector('[data-bind="help_tags"]');
//     if (helpTags && Array.isArray(doctor.help_tags)) {
//       clearElement(helpTags);
//       doctor.help_tags.forEach(htag => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = htag;
//         helpTags.appendChild(tag);
//       });
//     }

//     const faqsContainer = document.getElementById('pFAQs');
//     if (faqsContainer && Array.isArray(doctor.faqs)) {
//       clearElement(faqsContainer);
//       doctor.faqs.forEach(([question, answer], index) => {
//         const item = document.createElement('div');
//         item.className = `p-faq-item${index === 0 ? ' open' : ''}`;
//         item.innerHTML = `
//           <button type="button" class="p-faq-q">
//             <span>${esc(question)}</span>
//             <span class="plus">+</span>
//           </button>
//           <div class="p-faq-a">
//             <p>${esc(answer)}</p>
//           </div>
//         `;
//         faqsContainer.appendChild(item);
//       });
//     }
//   }

//   function updateProfileButtons(profile, id, doctor) {
//     const root = profile.closest('.db-page-wrapper') || profile;
//     const displayedName = stringValue(root.querySelector('[data-bind="name"]')?.textContent) || doctor.name || 'Therapist';
//     const price = stringValue(root.querySelector('.p-value[data-bind="fee"]')?.textContent) || doctor.fee || '₹2000';
//     const displayedFee = doctor.duration && !price.includes(doctor.duration) ? `${price} for ${doctor.duration}` : price;

//     root.querySelectorAll('.db-btn-book, .buy-btn, .consult-btn').forEach(button => {
//       button.dataset.docId = id;
//       button.dataset.docName = displayedName;
//       const isFreeCall = button.classList.contains('consult-btn') || /^free\b/i.test(stringValue(button.textContent));
//       if (!isFreeCall) {
//         button.dataset.docFee = displayedFee;
//       }
//     });
//   }

//   function mergeProfileData(sheetDoctor, fallbackDoctor) {
//     const merged = Object.assign({}, sheetDoctor || {}, fallbackDoctor || {});
//     if (sheetDoctor?.fee) merged.fee = sheetDoctor.fee;
//     if (sheetDoctor?.duration) merged.duration = sheetDoctor.duration;
//     return merged;
//   }

//   function renderProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const requested = normalizeId(profile.dataset.doctorId);
//     const therapist = findTherapistForId(requested);
//     const fallbackDoctor = state.profileFallback?.[requested] || null;

//     // Do not reveal a hard-coded/Shopify-only profile. The Sheet record must
//     // resolve first so visitors never see stale data flash before replacement.
//     if (!therapist) {
//       renderProfileStatus('This therapist was not found in the Google Sheet.', true);
//       return;
//     }

//     const sheetDoctor = therapistProfile(therapist, paletteForId(therapist.id));
//     // Shopify may supply richer profile copy, but the Sheet is the source of
//     // truth for live commercial fields. Without these explicit overrides, the
//     // hard-coded fallback fee (usually ₹2000) masks every Sheet price update.
//     const doctor = mergeProfileData(sheetDoctor, fallbackDoctor);
//     if (sheetDoctor?.faqs?.length && !fallbackDoctor?.faqs?.length) {
//       doctor.faqs = sheetDoctor.faqs;
//     }
//     if (sheetDoctor?.next_slot && !fallbackDoctor?.next_slot) {
//       doctor.next_slot = sheetDoctor.next_slot;
//     }

//     if (state.loaded && state.availabilityEnabled) {
//       doctor.next_slot = state.doctors.get(therapist.id)?.next_slot || '';
//     }

//     applyProfileData(profile, doctor);

//     const id = therapist?.id || requested;
//     profile.dataset.doctorId = id;
//     updateProfileButtons(profile, id, doctor);
//     revealProfilePage(profile);
//   }

//   /* ---------- Profile Page Initialization ---------- */
//   function initProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const queryId = new URLSearchParams(window.location.search).get('id')
//       || new URLSearchParams(window.location.search).get('doctor')
//       || new URLSearchParams(window.location.search).get('handle');

//    const profileData = {
//   "palak-chhabra": {
//     "name": "Palak Chhabra",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "PC",
//     "expertise": ["Emotional concerns", "Life transitions", "Grief and loss", "Self esteem"],
//     "help_tags": ["Relationship concerns", "Self and body image", "Burnout", "Confidence and growth"],
//     "bio": "Helping adults navigate their feelings and finding their way through life’s tough moments.",
//     "about": "Trauma-informed, queer-affirmative Counselling Psychologist supporting adults through emotions and transitions, with an M.A. in Lifespan Counselling, B.A. in Psychology & Philosophy, and a Diploma in Narrative Therapy.",
//     "how_i_work": "Warm, collaborative, non-pathologising sessions without having the pressure to figure it out. We explore your story together, your context, the meaning you make of your experiences and a range of emotions with empathy and understanding.",
//     "faqs": [
//       ["I'm part of the LGBTQ+ community. Is your practice queer-affirmative?", "Yes, absolutely. I work from a queer-affirmative and trauma-informed lens, and my practice is grounded in creating a safe, inclusive, non-judgmental space where you can come as you are without labels or the pressure to have everything figured out. I work in both English and Hindi."],
//       ["I don't know exactly what's wrong I just feel stuck or disconnected. Can I still come?", "Yes. You don't need to have a clear problem or everything figured out before you start. Many people come feeling stuck, lost, or disconnected from themselves, and we can explore that together at your pace, without forcing a diagnosis or a fixed way of working."],
//       ["Will I have homework or need to do things between sessions?", "Only if it feels useful to you. I may offer reflections, questions, or exercises between sessions when they seem helpful, but I don't believe therapy needs to be done perfectly curiosity, honesty, and engagement matter far more to me than getting everything \"right.\""],
//       ["Can I disagree with you or change what we talk about?", "Absolutely, in fact, I encourage it. You can call me by my first name, tell me something isn't working, change your mind about what you want to discuss, or simply show up on a day when you don't know what to say. I believe therapy works best when there's room for all of that."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "arushi-raheja": {
//     "name": "Arushi Raheja",
//     "title": "Child Psychologist",
//     "experience": "9+ yrs",
//     "sessions": "4000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AR",
//     "expertise": ["Parenting support", "Anxiety", "Attention and focus difficulties", "Autism"],
//     "help_tags": ["Trauma and grief", "Thoughts of self-harm or deep distress", "Emotional and behavioural difficulties", "Building self-confidence"],
//     "bio": "Helps in guiding children, adolescents, and parents through emotional hurdles, behavioural challenges, and parenting struggles in a safe environment.",
//     "about": "A Child Psychologist with a Master's degree in Clinical Psychology and NCERT- PG Diploma in Child Guidance, using a Gestalt-informed lens and experience helping children, young adults, and families thrive.",
//     "how_i_work": "Through compassionate conversations, creative activities, and practical guidance, we work together to help you understand your feelings, build strength, and make lasting progress to achieve a better sense of self.",
//     "faqs": [
//       ["My child has been diagnosed with ADHD or Autism — how do you approach that?", "I hold a Master's degree and a PG Diploma in Child Guidance and Counselling, and my practice focuses on supporting children and adolescents with ADHD, autism, learning disabilities, and related concerns. I tailor my approach to each child's unique needs, using a Gestalt-informed lens alongside practical, structured strategies that work for them."],
//       ["Do you work with adults too, or only children?", "While my core focus is children, adolescents, and young adults, I also work with parents and families. I facilitate workshops and training for parents, educators, and organisations on emotional well-being, positive parenting, and mental health topics."],
//       ["I'm worried about my child's self-harm or deep distress — how do you handle that?", "I have clinical experience supporting individuals experiencing self-harm or suicidal ideation. My approach is to create a safe, compassionate space where your child feels heard, assess the level of risk carefully, and work collaboratively with you to ensure they get the right support — including involving a psychiatrist or crisis support if needed."],
//       ["What does a session with you look like?", "Sessions are warm and tailored to your child's age and needs. I use compassionate conversations, creative activities, and practical guidance — drawing on Gestalt therapy and other modalities including dance movement therapy where appropriate — so therapy feels engaging rather than clinical."],
//       ["Do you only do individual therapy, or also workshops?", "I do both. Alongside individual sessions, I facilitate workshops and training programmes for schools, educators, parents, and organisations on emotional well-being, positive parenting, resilience, trauma, grief, and suicide prevention."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "mahita-kochhar": {
//     "name": "Mahita Kochhar",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "MK",
//     "expertise": ["Children and adolescent concerns", "Parenting support", "Emotional regulation", "School-related concerns"],
//     "help_tags": ["Behavioural concerns", "Self-esteem and confidence", "Social and relationship skills", "Adjustment and life transitions"],
//     "bio": "Sits with emotional, behavioural, and school-related difficulties with children, teens and parents to work through them with art based approaches.",
//     "about": "A Counselling Psychologist with a Masters in Clinical Psychology and a PG Diploma in Guidance and counselling and experience in school counselling and Special Educational Needs (SEN) settings.",
//     "how_i_work": "Sessions are warm, empathetic, and conversational. Through engaging activities and creative art-based techniques, we work together to build self-awareness, emotional regulation and develop healthy coping habits.",
//     "faqs": [
//       ["I'm an adult — do you only work with children?", "No — while my core focus is children and adolescents, I also work with adults, especially parents and those navigating emotional regulation, anxiety, self-esteem, and life transitions. My art-based approach can be adapted to adults too, if that feels helpful."],
//       ["I'm not great at talking about my feelings — will therapy still work for me?", "Absolutely. I use creative and art-based techniques alongside conversation, so you can express yourself in ways beyond words — through drawing, colours, and activities — at a pace that feels comfortable for you."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, in Hindi or English. We'll begin by understanding your story and goals, then build a warm, personalised rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your concerns and goals — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["I'm a parent — can you help me support my child better?", "Yes — parenting support is one of my focus areas. I work with parents to help them understand and support their child's emotional and behavioural needs, through separate parent sessions or joint check-ins where helpful."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   },
//   "chavika-dudeja": {
//     "name": "Chavika Dudeja",
//     "title": "Counselling Psychologist | RCI Licensed Rehabilitation Counselor",
//     "experience": "2 yrs",
//     "sessions": "1300+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "CD",
//     "expertise": ["Child counselling", "Family concerns", "Adjustment issues", "Emotional well being"],
//     "help_tags": ["Child counselling and rehabilitation", "Special needs children", "Personal growth", "Self-esteem challenges"],
//     "bio": "Works with individuals and children navigating emotions and transitions to build clarity and self-connection.",
//     "about": "A Counselling Psychologist with a B.A. in Human Development & Family Empowerment and an M.A. in Psychology specializing in Child and Adolescent Guidance.",
//     "how_i_work": "Sessions are warm, grounded, and structured yet flexible. Through compassionate conversations, clear understanding and practical strategies, we work together to help you gain insight and growth.",
//     "faqs": [
//       ["Do you take couples counselling?", "I work primarily with individuals, but if you're navigating relational concerns, we can explore those together in individual sessions."],
//       ["Do you provide medication?", "No — I'm a counselling psychologist, not a psychiatrist, so I don't prescribe medication. If it feels relevant, I can work alongside a psychiatrist or help you connect with one while we continue therapy together."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, and conducted in Hindi or English. We'll start with understanding your story and goals, then build a warm, structured yet flexible rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your goals and what you're navigating — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["Do you work with children and adolescents?", "Yes — I'm specializing in Child and Adolescent Guidance and Counselling, so I work with young people as well as adults, tailoring the approach to their age and needs."]
//     ],
//     "palette": ["#EAD9DE", "#EFE7DA"]
//   },
//   "alisha-crasto": {
//     "name": "Alisha Crasto",
//     "title": "Counselling Psychologist",
//     "experience": "7+ yrs",
//     "sessions": "2500+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AC",
//     "expertise": ["Child counselling", "Work stress and burnout", "Relationship understanding"],
//     "help_tags": ["Anxiety and stress", "Trauma", "Depression", "Self esteem"],
//     "bio": "Sits with children, adolescents, and adults as a gentle facilitator, trusting that clients hold their own answers and that every person deserves compassionate, accessible mental health care.",
//     "about": "A Psychologist and Narrative Therapy practitioner with a Master's in Clinical Psychology and a Diploma in Community Mental Health from NIMHANS, bringing 7 years of experience supporting children, adolescents, and adults across diverse mental health concerns.",
//     "how_i_work": "Sessions are warm, collaborative, and story-centred, where we explore your experiences together, gently re-authoring the narratives that shape you, at a pace that feels safe and yours. There is no fixing involved but understanding and acceptance.",
//     "faqs": [
//       ["Do you only use narrative therapy?", "Narrative therapy is my core approach, but I blend it with my clinical psychology training to meet each client's needs. The thread throughout is my belief that you are the expert on your own life, I'm here to walk alongside you, not to impose answers."],
//       ["I'm not sure how to talk about what I'm going through. Is that okay?", "Completely. Many people arrive not knowing how to put things into words. We'll go at your pace, and the narrative approach gives us gentle ways to explore your story without pressure to have it all figured out."],
//       ["Do you work with children and adolescents too?", "Yes, I have experience across children, adolescents, and adults. With younger clients, I adapt the approach to their age and world, often using stories and creative expression to help them feel comfortable."],
//       ["What does a first session look like?", "We'll start by getting to know each other and understanding what brought you in with no pressure to have a clear problem or goal. It's a space to share as much or as little as you're comfortable with, and we'll decide together how to move forward."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "vanshika-vakharia": {
//     "name": "Vanshika Vakharia",
//     "title": "Counselling Psychologist",
//     "experience": "4+ yrs",
//     "sessions": "1500+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "VV",
//     "expertise": ["Emotional regulation", "Healthy coping", "Self understanding"],
//     "help_tags": ["Anxiety and stress", "Emotional regulation", "Self-esteem and confidence", "Life transitions and adjustment", "Relationship concerns"],
//     "bio": "Works with children, adolescents, and adults by helping them understand unhelpful patterns, build healthier coping, and reconnect.",
//     "about": "Counselling Psychologist with a MA in counseling and clinical psychology who works with children, adolescents, and adults through various modalities like mindfulness, and emotional regulation strategies.",
//     "how_i_work": "A warm, collaborative conversation where you feel safe enough to be vulnerable, make sense of your thoughts and emotions, and move towards healing, growth, and lasting change, at a pace that feels right for you.",
//     "faqs": [
//       ["What does a first session look like?", "A warm, collaborative conversation where you feel safe enough to be vulnerable. We'll start by understanding what brought you in and what you're hoping to work on with no pressure to have it all figured out. We'll take it at a pace that feels right for you."],
//       ["Do you only use one type of therapy?", "No I integrate several evidence-based approaches, including CBT, REBT, mindfulness-based interventions, psychoeducation, and emotional regulation strategies. I tailor the blend to your needs and what feels most useful to you."],
//       ["I'm not good at opening up. Is that a problem?", "Not at all. Many clients find it hard to open up at first, and that's completely normal. My job is to create a safe, accepting space where you can be vulnerable at your own pace, there's no rush and no judgment."],
//       ["Do you work with children and adolescents too?", "Yes, I work across children, adolescents, and adults. With younger clients, I adapt my approach to their age and world, using age-appropriate, engaging methods to help them feel comfortable and understood."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "hita-shah": {
//     "name": "Hita Shah",
//     "title": "Counselling Psychologist",
//     "experience": "3+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "HS",
//     "expertise": ["Self understanding", "Anxiety and stress", "Relationship issues", "Transitions"],
//     "help_tags": ["Emotional balance", "Overthinking", "Confidence & self-worth", "Feeling stuck", "Personal growth"],
//     "bio": "Works in a warm, understanding space to slow down, make sense of what you’re feeling, and find ways forward at your own pace.",
//     "about": "A Counselling Psychologist holding an MSc in Psychology of Mental Health and a Diploma in Guidance and Counselling; offers a warm, supportive space to understand yourself and what you’re going through.",
//     "how_i_work": "Sessions are a space to slow down, talk openly, and make sense of what you’re experiencing. Together, we explore your thoughts, feelings, and patterns, while finding practical ways forward. We work collaboratively and at your pace.",
//     "faqs": [
//       ["What can I talk about in therapy?", "You can talk about whatever feels important to you, your thoughts, feelings, relationships, work, everyday struggles, or things you may not fully understand yet. You don’t need to know exactly where to begin."],
//       ["What happens in the first session?", "The first session is usually about getting to know you, understanding what brings you to therapy, and discussing what you would like support with. There is no pressure to have everything figured out."],
//       ["Will I be given advice or told what to do?", "Therapy with Hita is collaborative. Rather than simply telling you what to do, she helps you understand yourself, explore different perspectives, and find approaches that feel right for you."],
//       ["How often do I need to have sessions?", "There is no one-size-fits-all answer. The frequency can depend on what you’re looking for and what feels comfortable for you. This can be discussed together as you begin."],
//       ["What if I don’t know how to explain what I’m feeling?", "That’s completely okay. You don’t need to come with the perfect words. Sessions can be a space to slowly make sense of what you’re experiencing together."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   }
// };
//     profileData.palak = profileData["palak-chhabra"];
//     profileData.arushi = profileData["arushi-raheja"];
//     profileData.mahita = profileData["mahita-kochhar"];
//     profileData.chavika = profileData["chavika-dudeja"];

//     // Parse Shopify Product Metafields JSON output by the Liquid template
//     const shopifyProfiles = {};
//     let firstShopifyHandle = '';
//     const shopifyJsonEl = document.getElementById('shopify-doctors-json');
//     if (shopifyJsonEl) {
//       try {
//         const rawShopify = JSON.parse(shopifyJsonEl.textContent);
//         Object.keys(rawShopify).forEach(handle => {
//           const normKey = normalizeId(handle);
//           if (!firstShopifyHandle) firstShopifyHandle = normKey;
//           const norm = therapistProfile(rawShopify[handle], paletteForId(normKey));
//           if (norm) {
//             shopifyProfiles[normKey] = norm;
//             // Also index by first-name alias (e.g., "palak" -> "palak-chhabra") if not already taken
//             const shortKey = normKey.split('-')[0];
//             if (shortKey && !shopifyProfiles[shortKey]) {
//               shopifyProfiles[shortKey] = norm;
//             }
//           }
//         });
//       } catch (err) {
//         console.warn('[DoctorBooking] Could not parse shopify-doctors-json:', err);
//       }
//     }

//     // Merge hardcoded defaults with Shopify Product Metafields (Shopify Metafields override defaults)
//     state.profileFallback = Object.assign({}, profileData);
//     Object.keys(shopifyProfiles).forEach(key => {
//       state.profileFallback[key] = Object.assign({}, state.profileFallback[key] || {}, shopifyProfiles[key]);
//     });

//     const defaultId = profile.dataset.doctorId && profile.dataset.doctorId !== 'palak-chhabra'
//       ? profile.dataset.doctorId
//       : (firstShopifyHandle || 'palak-chhabra');

//     const id = normalizeId(queryId || defaultId);
//     profile.dataset.doctorId = id;

//     // Keep the Liquid fallback hidden while loadTherapists() resolves. It is
//     // used only to supplement the live Sheet record after that record exists.
//     profile.hidden = true;
//     profile.setAttribute('aria-busy', 'true');
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = false;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = false;
//   }

//   function initialise() {
//     initProfilePage();
//     initCategoryTabs();
//     initSelectionEvents();
//     initBookingModal();
//     initVideoModal();
//     initFaqAccordion();
//     initCardNavigation();
//     loadTherapists().then(renderProfilePage).catch(() => { });
//     loadAvailability().catch(() => { });
//     initAutoRefresh();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
//   else initialise();
// })();

// (() => {
//   'use strict';

//   const DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbx4o7EeOP02BZVv5AwtiFGY-5uTiGalPiJzqIUu7r9hRPPNdasApH7wGxjNxwVRtrQdcA/exec';
//   const REFRESH_INTERVAL_MS = 45000;
//   const REQUEST_TIMEOUT_MS = 15000;
//   const state = {
//     doctors: new Map(),
//     therapists: new Map(),
//     bookedMap: new Map(),
//     pendingMap: new Map(),
//     profileFallback: null,
//     currentDoctorId: '',
//     modalDoctor: null,
//     loaded: false,
//     availabilityEnabled: false,
//     loadingPromise: null,
//     therapistsPromise: null,
//     requestController: null,
//     bookingRequestId: '',
//     otpChallengeId: '',
//     otpVerificationToken: '',
//     otpResendTimer: null,
//     checkoutPromise: null,
//     currentCheckout: null,
//     localBooked: [],
//     refreshTimer: null
//   };

//   const apiUrl = () => {
//     const configured = document.querySelector('[data-booking-api-url]')?.dataset.bookingApiUrl?.trim();
//     return configured || window.DoctorBookingConfig?.apiUrl || DEFAULT_API_URL;
//   };
//   const normalizeId = value => String(value ?? '').trim().toLowerCase();
//   const normalizeMode = value => {
//     const mode = String(value ?? 'online').toLowerCase();
//     return mode.includes('person') || mode.includes('clinic') ? 'in-person' : 'online';
//   };
//   const stringValue = value => String(value ?? '').trim();
//   const sheetKey = value => stringValue(value).toLowerCase()
//     .replace(/[\s-]+/g, '_')
//     .replace(/[^a-z0-9_]/g, '')
//     .replace(/_+/g, '_');
//   const normaliseSlotTime = value => {
//     const text = stringValue(value).toUpperCase();
//     const match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/);
//     if (!match) return text;
//     const hour = Number(match[1]);
//     if (Number(match[2]) > 59 || hour > (match[3] ? 12 : 23) || (match[3] && hour < 1)) return text;
//     return `${String(hour % 12 || 12).padStart(2, '0')}:${match[2]} ${match[3] || (hour >= 12 ? 'PM' : 'AM')}`;
//   };

//   /* ---------- Google Sheet therapist data ---------- */
//   const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
//   const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const DEFAULT_TIME_SLOTS = ['10:00 AM', '11:30 AM', '02:00 PM', '03:30 PM', '05:00 PM', '06:30 PM'];
//   const CARD_PALETTES = [
//     ['#EAD9DE', '#786C8A'],
//     ['#EFE7DA', '#EAD9DE'],
//     ['#786C8A', '#EFE7DA'],
//     ['#EAD9DE', '#EFE7DA'],
//     ['#EFE7DA', '#786C8A']
//   ];
//   const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
//   const safeUrl = value => /^https?:\/\//i.test(stringValue(value)) ? stringValue(value) : '';
//   const initialsOf = name => stringValue(name).split(/\s+/).slice(0, 2).map(word => word.slice(0, 1).toUpperCase()).join('') || '?';

//   function normaliseTherapist(record) {
//     if (!record || typeof record !== 'object') return null;
//     const row = {};
//     Object.keys(record).forEach(key => { row[sheetKey(key)] = record[key]; });
//     const id = normalizeId(row.id || row.handle || row.slug).replace(/\s+/g, '-');
//     if (!id) return null;
//     const active = !['no', 'false', '0', 'hidden'].includes(stringValue(row.active || 'yes').toLowerCase());
//     const slots = stringValue(row.time_slots).split(/[;,]/).map(normaliseSlotTime).filter(Boolean);
//     const rawPrice = stringValue(row.price || row.fee);
//     const days = stringValue(row.days).split(/[,;]/)
//       .map(day => day.trim().toUpperCase().slice(0, 3))
//       .filter(day => DAY_NAMES.includes(day));
//     return {
//       id,
//       name: stringValue(row.name) || 'Therapist',
//       role: stringValue(row.role || row.title) || 'Therapist',
//       rating: stringValue(row.rating),
//       price: /^\d+(\.\d+)?$/.test(rawPrice) ? `₹${Number(rawPrice).toLocaleString('en-IN')}` : rawPrice,
//       duration: stringValue(row.duration),
//       availability: stringValue(row.availability || row.next_slot),
//       image_url: safeUrl(row.image_url || row.image),
//       experience: stringValue(row.experience),
//       expertise: stringValue(row.expertise),
//       languages: stringValue(row.languages || row.speaks),
//       centre: stringValue(row.centre || row.format) || 'Online',
//       gender: stringValue(row.gender),
//       bio: stringValue(row.bio),
//       trust_line: stringValue(row.trust_line),
//       about: stringValue(row.about),
//       how_i_work: stringValue(row.how_i_work),
//       help_tags: stringValue(row.help_tags),
//       faqs: Array.isArray(row.faqs) ? row.faqs : [],
//       sessions: stringValue(row.sessions),
//       switch_policy: stringValue(row.switch_policy),
//       category: stringValue(row.category) || 'therapist',
//       days: days.length ? days : null,
//       time_slots: slots.length ? slots : DEFAULT_TIME_SLOTS.slice(),
//       active
//     };
//   }

//   function activeTherapists() {
//     return Array.from(state.therapists.values()).filter(therapist => therapist.active);
//   }

//   function therapistFee(therapist) {
//     if (!therapist?.price) return '';
//     return therapist.duration ? `${therapist.price} for ${therapist.duration}` : therapist.price;
//   }

//   function loadTherapists() {
//     if (state.therapistsPromise) return state.therapistsPromise;
//     const url = apiUrl();
//     const separator = url.includes('?') ? '&' : '?';
//     state.therapistsPromise = fetchJson(`${url}${separator}action=therapists&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (payload?.success === false) {
//         throw new Error(payload.message || 'The therapist service rejected the request.');
//       }
//       const records = Array.isArray(payload) ? payload : payload?.therapists || payload?.data;
//       if (!Array.isArray(records)) {
//         throw new Error('The therapist response does not contain a valid therapists list.');
//       }
//       const nextTherapists = new Map();
//       records.forEach(record => {
//         const therapist = normaliseTherapist(record);
//         if (therapist) nextTherapists.set(therapist.id, therapist);
//       });
//       state.therapists = nextTherapists;
//       if (state.therapists.size > 0) {
//         renderHomeCarousel();
//         renderListingCards();
//       } else {
//         renderHomeTherapistStatus('No therapists are available right now.');
//         renderListingStatus('No therapists are available right now.');
//         if (!state.profileFallback) {
//           renderProfileStatus('This therapist is not available right now.');
//         }
//       }
//     }).catch(error => {
//       console.warn('[DoctorBooking] Therapist sheet data could not be loaded.', error);
//       renderHomeTherapistStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderListingStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderProfileStatus('This therapist could not be loaded. Please try again shortly.', true);
//       throw error;
//     }).finally(() => { state.therapistsPromise = null; });
//     return state.therapistsPromise;
//   }

//   function renderHomeCarousel() {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     const bookLabel = stringValue(carousel.dataset.bookLabel) || 'Book Session';
//     const endLink = carousel.querySelector('.carousel-end');
//     carousel.innerHTML = therapists.map((therapist, index) => {
//       const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//       const media = therapist.image_url
//         ? `<img loading="lazy" src="${esc(therapist.image_url)}" alt="${esc(therapist.name)}">`
//         : `<div class="mini-initials">${esc(initialsOf(therapist.name))}</div>`;
//       const slot = therapist.availability
//         ? `<span class="mini-slot"><span class="dot"></span>${esc(therapist.availability)}</span>`
//         : '';
//       return `<article class="mini-card" data-therapist-id="${esc(therapist.id)}" style="cursor:pointer;">
//         <div class="mini-media" style="--card-a:${palette[0]};--card-b:${palette[1]}">${media}${slot}</div>
//         <div class="mini-body"><div class="mini-name-row"><h3>${esc(therapist.name)}</h3><span class="mini-verified" aria-label="Verified">&#10003;</span></div><div class="mini-role">${esc(therapist.role)}</div><div class="mini-meta"><span class="star">&#9733;</span> ${esc(therapist.rating)}</div><div class="mini-price">${esc(therapist.price)}</div><button type="button" class="mini-book db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">${esc(bookLabel)}</button></div>
//       </article>`;
//     }).join('');
//     if (endLink) {
//       endLink.hidden = false;
//       carousel.appendChild(endLink);
//     }
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderHomeTherapistStatus(message, isError = false) {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const status = document.createElement('div');
//     status.className = `mt-therapists-status${isError ? ' mt-therapists-status-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     carousel.replaceChildren(status);
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderListingStatus(message, isError = false) {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const status = document.createElement('div');
//     status.className = `db-list-status${isError ? ' db-list-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     listEl.replaceChildren(status);
//     listEl.setAttribute('aria-busy', 'false');
//   }

//   function renderProfileStatus(message, isError = false) {
//     const loader = document.getElementById('dbProfileLoading');
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!loader || !profile) return;
//     profile.hidden = true;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//     const status = document.createElement('div');
//     status.className = `db-profile-status${isError ? ' db-profile-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     loader.replaceChildren(status);
//     loader.hidden = false;
//   }

//   function revealProfilePage(profile) {
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = true;
//     profile.hidden = false;
//     profile.setAttribute('aria-busy', 'false');
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = false;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//   }

//   function listingCardHtml(therapist, index) {
//     const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//     const tags = therapist.expertise.split(',').map(tag => tag.trim()).filter(Boolean)
//       .map(tag => `<span class="tag">${esc(tag)}</span>`).join('');
//     const mediaStyle = therapist.image_url
//       ? `background:url('${esc(therapist.image_url)}') center/cover no-repeat, linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`
//       : `background:linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`;
//     const meta = [
//       `<span class="star">&#9733;</span>${esc(therapist.rating)}`,
//       therapist.role ? `<span class="sep">&middot;</span> ${esc(therapist.role)}` : '',
//       therapist.experience ? `<span class="sep">&middot;</span> ${esc(therapist.experience)}` : ''
//     ].join(' ');
//     return `<article class="t-card" data-id="${esc(therapist.id)}" data-category="${esc(therapist.category)}" data-open="${esc(therapist.id)}">
//       <div class="media" style="${mediaStyle}">
//         ${therapist.image_url ? '' : `<div class="media-initials">${esc(initialsOf(therapist.name))}</div>`}
//         ${therapist.availability ? `<span class="slot-badge"><span class="dot"></span>Next: ${esc(therapist.availability)}</span>` : ''}
//       </div>
//       <div class="t-body">
//         <div class="name-row"><h2>${esc(therapist.name)}</h2><span class="verified" title="Verified">&#10003;</span></div>
//         <div class="meta-line">${meta}</div>
//         ${tags ? `<div class="tags-row">${tags}</div>` : ''}
//         ${therapist.bio ? `<p class="bio-line">${esc(therapist.bio)}</p>` : ''}
//        ${String(therapist.trust_line || '')
//   .split('|')
//   .map(line => line.trim())
//   .filter(Boolean)
//   .map(line => `
//     <div class="trust-line">
//       <span class="ic">&#10003;</span>
//       <span>${esc(line)}</span>
//     </div>
//   `)
//   .join('')}
//         ${therapist.sessions ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.sessions)}</div>` : ''}
//         ${therapist.switch_policy ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.switch_policy)}</div>` : ''}
//         <div class="price-cta-row">
//           <div class="price-line">
//             <span class="p-label">${esc(therapist.centre)}${therapist.duration ? ` &middot; ${esc(therapist.duration)}` : ''}</span>
//             <span class="p-value">${esc(therapist.price)}</span>
//           </div>
//           <div class="cta-buttons-row">
//             <a href="/pages/doctor-profile?id=${encodeURIComponent(therapist.id)}" class="consult-btn" data-consult="${esc(therapist.id)}">Free 15-min call</a>
//             <button type="button" class="book-btn db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">Book Session</button>
//           </div>
//         </div>
//       </div>
//     </article>`;
//   }

//   function renderListingCards() {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     listEl.innerHTML = therapists.map((therapist, index) => listingCardHtml(therapist, index)).join('');
//     listEl.setAttribute('aria-busy', 'false');
//     updateDoctorCards();
//     filterDoctors();
//   }

//   function isoOf(day) {
//     return `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
//   }

//   function dateFromIso(iso) {
//     const match = stringValue(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
//     if (!match) return null;
//     const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
//     return Number.isNaN(date.getTime()) ? null : date;
//   }

//   function parseBooked(payload) {
//     const entries = Array.isArray(payload?.booked) ? payload.booked : [];
//     state.bookedMap = new Map();
//     state.pendingMap = new Map();
//     entries.forEach(entry => {
//       const docId = normalizeId(entry.doctor_id).replace(/\s+/g, '-');
//       const iso = stringValue(entry.date);
//       const time = normaliseSlotTime(entry.time);
//       if (!docId || !/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//       const key = `${docId}|${iso}`;
//       const pending = stringValue(entry.status).toLowerCase() === 'payment_pending';
//       const target = pending ? state.pendingMap : state.bookedMap;
//       if (!target.has(key)) target.set(key, new Set());
//       target.get(key).add(time);
//     });
//     state.localBooked = state.localBooked.filter(entry => !entry.expiresAt || Date.parse(entry.expiresAt) > Date.now());
//     state.localBooked.forEach(entry => {
//       const key = `${entry.doctorId}|${entry.date}`;
//       if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//       state.pendingMap.get(key).add(entry.time);
//     });
//   }

//   function activeDatePill() {
//     return document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill.active')
//       || document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill');
//   }

//   function modalSlots(iso = activeDatePill()?.dataset.iso || '') {
//     if (state.availabilityEnabled) {
//       return state.doctors.get(state.currentDoctorId)?.schedule?.[iso] || [];
//     }
//     const slots = state.modalDoctor?.time_slots;
//     return slots?.length ? slots : DEFAULT_TIME_SLOTS;
//   }

//   function markFullDatePills() {
//     document.querySelectorAll('#dbBookingModal .db-date-pill').forEach(pill => {
//       const slots = modalSlots(pill.dataset.iso);
//       const booked = state.bookedMap.get(`${state.currentDoctorId}|${pill.dataset.iso}`);
//       const isFull = slots.length > 0 && !!booked && slots.every(slot => booked.has(slot));
//       pill.classList.toggle('db-date-full', isFull);
//     });
//   }

//   function ensureDatePills(therapist) {
//     const row = document.querySelector('#dbBookingModal .db-date-picker-row');
//     if (!row) return;
//     const previousIso = activeDatePill()?.dataset.iso || '';
//     if (!state.loaded) {
//       setHiddenValue('dbBookingDate', '');
//       showLoading(row, 'Loading dates…');
//       return;
//     }

//     if (state.availabilityEnabled) {
//       const today = isoOf(new Date());
//       const schedule = state.doctors.get(state.currentDoctorId)?.schedule || {};
//       const dates = Object.keys(schedule)
//         .filter(iso => iso >= today && Array.isArray(schedule[iso]) && schedule[iso].length)
//         .sort();
//       if (!dates.length) {
//         setHiddenValue('dbBookingDate', '');
//         setHiddenValue('dbBookingTime', '');
//         renderMessage(row, 'No upcoming dates are available for this therapist.');
//         return;
//       }
//       row.innerHTML = dates.map(iso => {
//         const day = dateFromIso(iso);
//         const dayName = DAY_NAMES[day.getDay()];
//         const offset = Math.round((day.getTime() - dateFromIso(today).getTime()) / 86400000);
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         return `<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`;
//       }).join('');
//       markFullDatePills();
//       const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//       const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//       active?.classList.add('active');
//       setHiddenValue('dbBookingDate', active?.dataset.date || '');
//       return;
//     }

//     const build = useDayFilter => {
//       const pills = [];
//       const now = new Date();
//       for (let offset = 0; offset < 60 && pills.length < 30; offset++) {
//         const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
//         const dayName = DAY_NAMES[day.getDay()];
//         if (useDayFilter && therapist?.days && !therapist.days.includes(dayName)) continue;
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         const iso = isoOf(day);
//         pills.push(`<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`);
//       }
//       return pills;
//     };
//     let pills = build(true);
//     if (!pills.length) pills = build(false);
//     row.innerHTML = pills.join('');
//     markFullDatePills();
//     const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//     const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingDate', active?.dataset.date || '');
//   }

//   function renderTimePills() {
//     const grid = document.querySelector('#dbBookingModal .db-time-grid');
//     if (!grid) return;
//     if (!state.loaded) {
//       setHiddenValue('dbBookingTime', '');
//       showLoading(grid);
//       return;
//     }
//     const previous = stringValue(document.getElementById('dbBookingTime')?.value);
//     const iso = activeDatePill()?.dataset.iso || '';
//     const slots = modalSlots(iso);
//     if (!iso || !slots.length) {
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(grid, iso ? 'No times are available on this date.' : 'Select an available date first.');
//       return;
//     }
//     const booked = state.bookedMap.get(`${state.currentDoctorId}|${iso}`);
//     const pending = state.pendingMap.get(`${state.currentDoctorId}|${iso}`);
//     grid.innerHTML = slots.map(slot => {
//       if (booked?.has(slot)) {
//         return `<div class="db-time-pill db-time-booked" aria-disabled="true">${esc(slot)}<span class="db-booked-tag">Booked</span></div>`;
//       }
//       if (pending?.has(slot)) {
//         return `<div class="db-time-pill db-time-pending" title="Reserved. Select only to resume your existing payment.">${esc(slot)}<span class="db-booked-tag">Payment pending</span></div>`;
//       }
//       return `<div class="db-time-pill">${esc(slot)}</div>`;
//     }).join('');
//     const active = Array.from(grid.querySelectorAll('.db-time-pill:not(.db-time-booked)'))
//       .find(pill => slotText(pill) === previous)
//       || grid.querySelector('.db-time-pill:not(.db-time-booked):not(.db-time-pending)');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingTime', active ? slotText(active) : '');
//   }

//   const slotText = pill => pill?.querySelector('.db-booked-tag')
//     ? pill.textContent.replace(pill.querySelector('.db-booked-tag').textContent, '').trim()
//     : stringValue(pill?.textContent);

//   function safeUuid() {
//     if (window.crypto?.randomUUID) return window.crypto.randomUUID();
//     return `booking-${Date.now()}-${Math.random().toString(16).slice(2)}`;
//   }

//   function clearElement(element) {
//     if (element) element.replaceChildren();
//   }

//   function renderMessage(container, message, isError = false) {
//     if (!container) return;
//     clearElement(container);
//     const status = document.createElement('div');
//     status.className = `db-availability-message${isError ? ' db-availability-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     container.appendChild(status);
//   }

//   function showLoading(container, message = 'Loading availability…') {
//     if (!container) return;
//     clearElement(container);
//     const wrapper = document.createElement('div');
//     wrapper.className = 'db-loading-spinner-wrap';
//     wrapper.setAttribute('role', 'status');
//     const spinner = document.createElement('div');
//     spinner.className = 'db-loading-spinner';
//     spinner.setAttribute('aria-hidden', 'true');
//     const label = document.createElement('span');
//     label.textContent = message;
//     wrapper.append(spinner, label);
//     container.appendChild(wrapper);
//   }

//   function normaliseSchedule(value) {
//     const schedule = {};
//     if (Array.isArray(value)) {
//       value.forEach(entry => {
//         const iso = stringValue(entry?.date);
//         const slots = Array.isArray(entry?.slots) ? entry.slots : [];
//         if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
//           schedule[iso] = [...new Set(slots.map(normaliseSlotTime).filter(Boolean))];
//         }
//       });
//       return schedule;
//     }
//     if (!value || typeof value !== 'object') return schedule;
//     Object.keys(value).forEach(iso => {
//       if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !Array.isArray(value[iso])) return;
//       schedule[iso] = [...new Set(value[iso].map(normaliseSlotTime).filter(Boolean))];
//     });
//     return schedule;
//   }

//   function normaliseDoctor(record) {
//     if (!record || typeof record !== 'object') return null;
//     const id = normalizeId(record.doctor_id || record.doctorId || record.handle || record.id);
//     if (!id) return null;
//     const schedule = normaliseSchedule(record.schedule || record.availability_by_date);
//     return {
//       ...record,
//       doctor_id: id,
//       next_slot: stringValue(record.next_slot || record.nextSlot),
//       dates: Array.isArray(record.dates || record.available_dates)
//         ? (record.dates || record.available_dates).map(stringValue).filter(Boolean)
//         : Object.keys(schedule),
//       schedule
//     };
//   }

//   function normalisePayload(payload) {
//     if (payload && payload.success === false) {
//       throw new Error(payload.message || 'The booking service rejected the availability request.');
//     }
//     const records = Array.isArray(payload) ? payload : payload?.doctors || payload?.data || payload?.availability || [];
//     const map = new Map();
//     records.forEach(item => {
//       const doc = normaliseDoctor(item);
//       if (doc) map.set(doc.doctor_id, doc);
//     });
//     return map;
//   }

//   async function fetchJson(url, options = {}) {
//     const controller = new AbortController();
//     const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
//     try {
//       const response = await fetch(url, { ...options, signal: controller.signal });
//       const text = await response.text();
//       let data = null;
//       try { data = JSON.parse(text); } catch (_) { }
//       if (!response.ok) {
//         const error = new Error(data?.message || `Request failed with HTTP status ${response.status}`);
//         error.code = data?.code || `HTTP_${response.status}`;
//         throw error;
//       }
//       if (data === null) {
//         const error = new Error('The booking service returned an invalid response. Check the latest Apps Script execution log.');
//         error.code = 'INVALID_JSON_RESPONSE';
//         throw error;
//       }
//       return data;
//     } finally {
//       window.clearTimeout(timeout);
//     }
//   }

//   function setHiddenValue(id, value) {
//     const input = document.getElementById(id);
//     if (input && typeof value !== 'undefined') input.value = value;
//   }

//   function updateDoctorCards() {
//     document.querySelectorAll('.t-card, .db-doctor-card, .mini-card, .mt-therapist-skeleton').forEach(card => {
//       const id = normalizeId(card.dataset.id || card.dataset.open || card.dataset.therapistId || card.dataset.docId);
//       const doctor = state.doctors.get(id);
//       if (!doctor) return;
//       const badge = card.querySelector('.slot-badge, .db-next-slot, .mini-slot');
//       if (doctor.next_slot) {
//         if (badge) {
//           badge.style.display = '';
//           const dot = badge.querySelector('.dot, .db-status-dot');
//           if (dot) {
//             badge.innerHTML = `<span class="dot"></span>Next: ${esc(doctor.next_slot)}`;
//           } else {
//             badge.textContent = `Next: ${doctor.next_slot}`;
//           }
//         }
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     });

//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     const profileId = normalizeId(profile?.dataset.doctorId);
//     const profileDoctor = state.doctors.get(profileId);
//     if (profile && profileDoctor) {
//       const badge = profile.querySelector('.slot-badge');
//       const value = badge?.querySelector('[data-bind="next_slot"]');
//       if (profileDoctor.next_slot) {
//         if (value) value.textContent = profileDoctor.next_slot;
//         if (badge) badge.style.display = '';
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     }
//   }

//   async function loadAvailability() {
//     const url = apiUrl();
//     if (!url) return null;
//     if (state.loadingPromise) return state.loadingPromise;
//     const separator = url.includes('?') ? '&' : '?';
//     state.loadingPromise = fetchJson(`${url}${separator}action=availability&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (!Array.isArray(payload?.booked)) throw new Error('Availability response is missing booked slots.');
//       state.doctors = normalisePayload(payload);
//       state.availabilityEnabled = payload?.availability_enabled === true;
//       state.loaded = true;
//       parseBooked(payload);
//       updateDoctorCards();
//       if (document.getElementById('dbBookingModal')?.classList.contains('active')) {
//         ensureDatePills(state.modalDoctor);
//         renderTimePills();
//       }
//       return payload;
//     }).catch(error => {
//       state.loaded = false;
//       setHiddenValue('dbBookingDate', '');
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(document.querySelector('#dbBookingModal .db-date-picker-row'), 'Available dates could not be checked. Please try again.', true);
//       renderMessage(document.getElementById('dbTimeGrid'), 'Availability could not be checked. Please reopen the booking form to retry.', true);
//       console.warn('[DoctorBooking] Note on live availability:', error);
//     }).finally(() => { state.loadingPromise = null; });
//     return state.loadingPromise;
//   }

//   function initAutoRefresh() {
//     const refreshSheetData = () => {
//       loadTherapists().then(renderProfilePage).catch(() => { });
//       loadAvailability().catch(() => { });
//     };
//     state.refreshTimer = window.setInterval(() => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     }, REFRESH_INTERVAL_MS);
//     document.addEventListener('visibilitychange', () => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     });
//   }

//   /* ---------- Category Filter Tabs ---------- */
//   function initCategoryTabs() {
//     document.querySelectorAll('.db-tab-btn').forEach(tab => {
//       tab.addEventListener('click', () => {
//         document.querySelectorAll('.db-tab-btn').forEach(item => item.classList.remove('active'));
//         tab.classList.add('active');
//         filterDoctors();
//       });
//     });
//   }

//   function filterDoctors() {
//     const category = document.querySelector('.db-tab-btn.active')?.dataset.category || 'all';
//     document.querySelectorAll('.t-card, .db-doctor-card').forEach(card => {
//       const cardCat = stringValue(card.dataset.category).toLowerCase();
//       const visible = (category === 'all' || cardCat.includes(category.toLowerCase()));
//       card.style.display = visible ? '' : 'none';
//     });
//   }

//   /* ---------- Selection Events (Mode / Date / Time) ---------- */
//   function initSelectionEvents() {
//     document.addEventListener('click', event => {
//       const modeButton = event.target.closest('.db-mode-btn');
//       if (modeButton) {
//         const selector = modeButton.closest('.db-mode-selector');
//         selector?.querySelectorAll('.db-mode-btn').forEach(button => {
//           button.classList.toggle('active', button === modeButton);
//         });
//         const mode = normalizeMode(modeButton.dataset.mode || modeButton.textContent);
//         setHiddenValue('dbConsultationMode', mode);
//         return;
//       }

//       const datePill = event.target.closest('.db-date-pill');
//       if (datePill) {
//         if (datePill.classList.contains('db-date-full')) return;
//         const row = datePill.closest('.db-date-picker-row');
//         row?.querySelectorAll('.db-date-pill').forEach(pill => pill.classList.remove('active'));
//         datePill.classList.add('active');
//         setHiddenValue('dbBookingDate', datePill.dataset.date || '');
//         renderTimePills();
//         return;
//       }

//       const timePill = event.target.closest('.db-time-pill');
//       if (timePill) {
//         if (timePill.classList.contains('db-time-booked')) return;
//         const grid = timePill.closest('.db-time-grid');
//         grid?.querySelectorAll('.db-time-pill').forEach(pill => pill.classList.remove('active'));
//         timePill.classList.add('active');
//         setHiddenValue('dbBookingTime', slotText(timePill));
//         if (timePill.classList.contains('db-time-pending')) {
//           window.alert('This slot is reserved pending payment. Continue only to resume your booking using the same verified WhatsApp number.');
//         }
//       }
//     });
//   }

//   /* ---------- Booking Modal Functions ---------- */
//   function openBookingModal(button) {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     const card = button.closest('.t-card, .mini-card, .mt-therapist-skeleton, .profile-page, #profileContent');
//     const id = normalizeId(button.dataset.docId || card?.dataset.id || card?.dataset.open || card?.dataset.therapistId || state.currentDoctorId || 'palak-chhabra');
//     state.currentDoctorId = id;
//     state.bookingRequestId = '';
//     state.otpChallengeId = '';
//     state.otpVerificationToken = '';
//     state.currentCheckout = null;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;

//     const name = stringValue(button.dataset.docName)
//       || stringValue(card?.querySelector('.name-row h2, .mini-name-row h3, h1[data-bind="name"]')?.textContent)
//       || 'Therapist';
//     const fee = stringValue(button.dataset.docFee)
//       || stringValue(card?.querySelector('.price-line .p-value, .mini-price, [data-bind="fee"]')?.textContent)
//       || '₹2000';

//     const therapist = state.therapists.get(id);
//     const fallbackDoc = state.profileFallback?.[id];
//     let resolvedName = name;
//     let resolvedFee = fee;
//     if (therapist) {
//       resolvedName = therapist.name || name;
//       resolvedFee = therapistFee(therapist) || fee;
//     } else if (fallbackDoc) {
//       resolvedName = fallbackDoc.name || name;
//       resolvedFee = fallbackDoc.fee || fee;
//     }
//     state.modalDoctor = therapist || null;

//     const nameElement = document.getElementById('dbModalDocName');
//     const feeElement = document.getElementById('dbModalDocFee');
//     if (nameElement) nameElement.textContent = resolvedName;
//     if (feeElement) feeElement.textContent = resolvedFee;

//     setHiddenValue('dbDoctorId', id);
//     setHiddenValue('dbDoctorName', resolvedName);
//     setHiddenValue('dbDoctorFee', resolvedFee);

//     setHiddenValue('dbBookingTime', '');
//     ensureDatePills(therapist);
//     renderTimePills();

//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     if (paymentButtonContainer) {
//       paymentButtonContainer.style.display = 'none';
//       paymentButtonContainer.replaceChildren();
//     }

//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'block';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'none';
//     const otpInput = document.getElementById('dbOtpCode');
//     if (otpInput) otpInput.value = '';
//     const otpStatus = document.getElementById('dbOtpStatus');
//     if (otpStatus) otpStatus.textContent = '';

//     modal.classList.add('active');
//     loadAvailability().catch(() => {});
//   }

//   const closeBookingModal = () => {
//     document.getElementById('dbBookingModal')?.classList.remove('active');
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//   };

//   function markSlotBookedLocally(iso, time, expiresAt) {
//     if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//     state.localBooked.push({ doctorId: state.currentDoctorId, date: iso, time, expiresAt });
//     const key = `${state.currentDoctorId}|${iso}`;
//     if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//     state.pendingMap.get(key).add(time);
//     markFullDatePills();
//     renderTimePills();
//     loadAvailability().catch(() => { });
//   }

//   function loadRazorpayCheckout() {
//     if (window.Razorpay) return Promise.resolve();
//     if (state.checkoutPromise) return state.checkoutPromise;
//     state.checkoutPromise = new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;
//       script.onload = () => resolve();
//       script.onerror = () => reject(new Error('Razorpay Checkout could not be loaded.'));
//       document.head.appendChild(script);
//     }).finally(() => { state.checkoutPromise = null; });
//     return state.checkoutPromise;
//   }

//   async function verifyRazorpayPayment(response) {
//     let lastResult = null;
//     for (let attempt = 0; attempt < 3; attempt++) {
//       if (attempt > 0) await new Promise(resolve => window.setTimeout(resolve, 1500));
//       lastResult = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_payment',
//           request_id: state.bookingRequestId,
//           razorpay_payment_id: response.razorpay_payment_id,
//           razorpay_order_id: response.razorpay_order_id,
//           razorpay_signature: response.razorpay_signature
//         })
//       });
//       if (lastResult?.success === true && stringValue(lastResult?.status).toLowerCase() === 'confirmed') return lastResult;
//       if (lastResult?.code !== 'PAYMENT_NOT_CAPTURED') break;
//     }
//     const error = new Error(lastResult?.message || 'Payment verification is still pending.');
//     error.code = lastResult?.code || 'PAYMENT_VERIFICATION_FAILED';
//     throw error;
//   }

//   async function startRazorpayCheckout(checkout) {
//     if (!checkout?.key_id || !checkout?.order_id || !checkout?.amount) return;
//     try {
//       await loadRazorpayCheckout();
//       const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//       const patientEmail = stringValue(document.getElementById('dbPatientEmail')?.value);
//       const rawPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//       const phoneDigits = rawPhone.replace(/\D/g, '');
//       const patientPhone = rawPhone.startsWith('+')
//         ? `+${phoneDigits}`
//         : phoneDigits.length === 10
//           ? `+91${phoneDigits}`
//           : `+${phoneDigits}`;
//       const razorpay = new window.Razorpay({
//         key: checkout.key_id,
//         order_id: checkout.order_id,
//         amount: checkout.amount,
//         currency: checkout.currency || 'INR',
//         name: 'MushinTalks',
//         description: `Therapy session with ${stringValue(document.getElementById('dbDoctorName')?.value)}`,
//         prefill: {
//           name: patientName,
//           email: patientEmail,
//           contact: patientPhone
//         },
//         readonly: { name: true, contact: true, email: Boolean(patientEmail) },
//         hidden: { contact: true, email: Boolean(patientEmail) },
//         theme: { color: '#786c8a' },
//         handler: async response => {
//           const successTitle = document.getElementById('dbSuccessTitle');
//           const successText = document.getElementById('dbSuccessText');
//           if (successTitle) successTitle.textContent = 'Verifying Payment…';
//           if (successText) successText.textContent = 'Please wait while we securely confirm your payment.';
//           try {
//             const verified = await verifyRazorpayPayment(response);
//             state.bookingRequestId = '';
//             state.currentCheckout = null;
//             showBookingSuccess(verified.payment_status, verified.status, null);
//           } catch (error) {
//             showBookingSuccess('pending', 'payment_pending', checkout);
//             window.alert(error?.message || 'Payment verification is pending. Please contact us with your payment ID.');
//           }
//         }
//       });
//       razorpay.on('payment.failed', response => {
//         const description = response?.error?.description || 'Payment failed. You can retry using the same reserved slot.';
//         window.alert(description);
//       });
//       razorpay.open();
//     } catch (error) {
//       window.alert(error?.message || 'Payment could not be opened. Please try again.');
//     }
//   }

//   function renderCheckoutButton(container, checkout) {
//     container.replaceChildren();
//     const button = document.createElement('button');
//     button.type = 'button';
//     button.className = 'db-btn-primary db-pay-now-btn';
//     button.textContent = 'Pay Now →';
//     button.addEventListener('click', () => startRazorpayCheckout(checkout));
//     container.appendChild(button);
//   }

//   function showBookingSuccess(paymentStatus, bookingStatus, checkout) {
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'none';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'block';
//     const normalizedPaymentStatus = stringValue(paymentStatus).toLowerCase();
//     const normalizedBookingStatus = stringValue(bookingStatus).toLowerCase();
//     const paymentConfirmed = ['paid', 'captured', 'success'].includes(normalizedPaymentStatus)
//       || normalizedBookingStatus === 'confirmed';
//     const successTitle = document.getElementById('dbSuccessTitle');
//     const successText = document.getElementById('dbSuccessText');
//     if (successTitle) successTitle.textContent = paymentConfirmed ? 'Booking Confirmed!' : 'Slot Reserved';
//     if (successText) {
//       successText.textContent = paymentConfirmed
//         ? 'Your payment is confirmed and your consultation has been booked.'
//         : 'Your slot is reserved pending payment. Complete the payment below to confirm your booking.';
//     }
//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     const resolvedCheckout = checkout?.order_id ? checkout : state.currentCheckout;
//     if (paymentButtonContainer) {
//       if (!paymentConfirmed && resolvedCheckout) {
//         state.currentCheckout = resolvedCheckout;
//         paymentButtonContainer.style.display = 'block';
//         renderCheckoutButton(paymentButtonContainer, resolvedCheckout);
//       } else {
//         paymentButtonContainer.style.display = 'none';
//         paymentButtonContainer.replaceChildren();
//         if (!paymentConfirmed && successText) {
//           successText.textContent = 'The payment session could not be prepared. Close this window and retry the same slot with the same phone number.';
//         }
//       }
//     }
//   }

//   function setOtpStatus(message, isError = false) {
//     const status = document.getElementById('dbOtpStatus');
//     if (!status) return;
//     status.textContent = message || '';
//     status.classList.toggle('db-otp-status-error', Boolean(isError));
//   }

//   function validateOtpRequestForm() {
//     if (!state.loaded) {
//       window.alert('Please wait until availability has been checked.');
//       return null;
//     }
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return null;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');
//     const localDigits = phoneDigits.length === 12 && phoneDigits.startsWith('91')
//       ? phoneDigits.slice(2)
//       : phoneDigits.length === 11 && phoneDigits.startsWith('0')
//         ? phoneDigits.slice(1)
//         : phoneDigits;
//     if (!patientName || !/^[6-9]\d{9}$/.test(localDigits)) {
//       window.alert('Please enter your full name and a valid 10-digit Indian WhatsApp number.');
//       return null;
//     }
//     if (!stringValue(document.getElementById('dbBookingTime')?.value)) {
//       window.alert('Please select an available time slot first.');
//       return null;
//     }
//     return { patientName, patientPhone };
//   }

//   function startOtpResendCountdown(seconds) {
//     const button = document.getElementById('dbOtpResendBtn');
//     if (!button) return;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     let remaining = Math.max(1, Number(seconds) || 60);
//     const render = () => {
//       button.disabled = remaining > 0;
//       button.textContent = remaining > 0 ? `Resend in ${remaining}s` : 'Resend code';
//     };
//     render();
//     state.otpResendTimer = window.setInterval(() => {
//       remaining -= 1;
//       render();
//       if (remaining <= 0) {
//         window.clearInterval(state.otpResendTimer);
//         state.otpResendTimer = null;
//       }
//     }, 1000);
//   }

//   async function requestBookingOtp(button) {
//     const details = validateOtpRequestForm();
//     if (!details) return;
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'SENDING CODE…';
//     setOtpStatus('');
//     let result = null;
//     try {
//       result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({ action: 'send_otp', patient_phone: details.patientPhone })
//       });
//       if (result?.success !== true || !result?.challenge_id) {
//         const unknownOtpAction = result?.code === 'UNKNOWN_ACTION' ||
//           /^Unknown action:\s*send_otp$/i.test(stringValue(result?.message));
//         const error = new Error(unknownOtpAction
//           ? 'The booking service is using an older Apps Script deployment. Publish the latest Code.gs as a new version of the existing web app deployment, then try again.'
//           : result?.message || 'The verification code could not be sent.');
//         error.code = result?.code || 'OTP_SEND_FAILED';
//         throw error;
//       }
//       state.otpChallengeId = stringValue(result.challenge_id);
//       state.otpVerificationToken = '';
//       const stepOne = document.getElementById('dbModalStep1');
//       const otpStep = document.getElementById('dbModalStepOtp');
//       if (stepOne) stepOne.style.display = 'none';
//       if (otpStep) otpStep.style.display = 'block';
//       const masked = document.getElementById('dbOtpMaskedPhone');
//       if (masked) masked.textContent = stringValue(result.masked_phone) || 'your WhatsApp number';
//       const input = document.getElementById('dbOtpCode');
//       if (input) {
//         input.value = '';
//         input.focus();
//       }
//       setOtpStatus('Code sent. It expires in 5 minutes.');
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP could not be sent.', error);
//       setOtpStatus(error?.message || 'The verification code could not be sent.', true);
//       window.alert(error?.message || 'The verification code could not be sent.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//     if (result?.success === true) startOtpResendCountdown(result.retry_after);
//   }

//   async function verifyBookingOtp(button) {
//     const otp = stringValue(document.getElementById('dbOtpCode')?.value).replace(/\D/g, '');
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     if (!state.otpChallengeId || !/^\d{6}$/.test(otp)) {
//       setOtpStatus('Enter the 6-digit code sent on WhatsApp.', true);
//       return;
//     }
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'VERIFYING…';
//     setOtpStatus('Verifying code…');
//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_otp',
//           patient_phone: patientPhone,
//           challenge_id: state.otpChallengeId,
//           otp
//         })
//       });
//       if (result?.success !== true || !result?.verification_token) {
//         const error = new Error(result?.message || 'The verification code is incorrect.');
//         error.code = result?.code || 'OTP_INCORRECT';
//         throw error;
//       }
//       state.otpVerificationToken = stringValue(result.verification_token);
//       setOtpStatus('WhatsApp number verified. Reserving your slot…');
//       await submitBooking(button);
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP verification failed.', error);
//       setOtpStatus(error?.message || 'The verification code could not be verified.', true);
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   async function submitBooking(button) {
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');

//     if (!patientName || phoneDigits.length < 7 || phoneDigits.length > 15) {
//       window.alert('Please enter your full name and a valid phone number.');
//       return;
//     }

//     const mode = stringValue(document.getElementById('dbConsultationMode')?.value) || 'Online Video';
//     const datePill = activeDatePill();
//     const date = datePill?.dataset.iso || stringValue(document.getElementById('dbBookingDate')?.value) || 'Today';
//     const time = stringValue(document.getElementById('dbBookingTime')?.value);
//     if (!time) {
//       window.alert('No slots are left on this date — please pick another day.');
//       return;
//     }

//     if (!state.bookingRequestId) state.bookingRequestId = safeUuid();
//     const payload = {
//       action: 'book',
//       request_id: state.bookingRequestId,
//       doctor_id: state.currentDoctorId,
//       doctor_name: stringValue(document.getElementById('dbDoctorName')?.value),
//       doctor_fee: stringValue(document.getElementById('dbDoctorFee')?.value),
//       patient_name: patientName,
//       patient_phone: patientPhone,
//       patient_email: stringValue(document.getElementById('dbPatientEmail')?.value),
//       otp_verification_token: state.otpVerificationToken,
//       mode: mode,
//       date: date,
//       date_label: stringValue(datePill?.dataset.date),
//       time: time,
//       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       source: 'shopify-storefront'
//     };

//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'CONFIRMING…';

//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const resultStatus = stringValue(result?.status || 'booked').toLowerCase();
//       const confirmed = result?.success === true && ['booked', 'confirmed', 'payment_pending', 'reserved'].includes(resultStatus);
//       if (!confirmed) {
//         const bookingError = new Error(result?.message || 'The slot could not be booked.');
//         bookingError.code = result?.code || 'BOOKING_REJECTED';
//         throw bookingError;
//       }
//       showBookingSuccess(
//         result?.payment_status,
//         result?.status,
//         result?.checkout
//       );
//       state.bookingRequestId = stringValue(result?.request_id) || state.bookingRequestId;
//       markSlotBookedLocally(date, time, result?.payment_expires_at);
//     } catch (error) {
//       console.error('[DoctorBooking] Booking was not confirmed.', error);
//       if (error?.code === 'SLOT_ALREADY_BOOKED') state.bookingRequestId = '';
//       if (['OTP_REQUIRED', 'OTP_EXPIRED', 'OTP_INVALID', 'OTP_ALREADY_USED'].includes(error?.code)) {
//         state.otpVerificationToken = '';
//         setOtpStatus(error?.message || 'Verify your WhatsApp number again.', true);
//         const otpStep = document.getElementById('dbModalStepOtp');
//         if (otpStep) otpStep.style.display = 'block';
//       }
//       await loadAvailability().catch(() => { });
//       window.alert(error?.message || 'The booking could not be confirmed. Please try again.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   function initBookingModal() {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     document.addEventListener('click', event => {
//       const bookButton = event.target.closest('.book-btn, .buy-btn, .db-btn-book');
//       if (bookButton) {
//         event.preventDefault();
//         event.stopPropagation();
//         openBookingModal(bookButton);
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.closest('.db-modal-close, .db-modal-cancel')) closeBookingModal();
//     });

//     document.addEventListener('keydown', event => {
//       if (event.key === 'Escape' && modal.classList.contains('active')) closeBookingModal();
//     });

//     modal.querySelector('.db-date-prev')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: -160, behavior: 'smooth' });
//     });
//     modal.querySelector('.db-date-next')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: 160, behavior: 'smooth' });
//     });

//     document.getElementById('dbConfirmBookingBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbVerifyOtpBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       verifyBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpResendBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpBackBtn')?.addEventListener('click', () => {
//       if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//       state.otpResendTimer = null;
//       state.otpChallengeId = '';
//       state.otpVerificationToken = '';
//       const otpStep = document.getElementById('dbModalStepOtp');
//       const stepOne = document.getElementById('dbModalStep1');
//       if (otpStep) otpStep.style.display = 'none';
//       if (stepOne) stepOne.style.display = 'block';
//     });
//     document.getElementById('dbOtpCode')?.addEventListener('keydown', event => {
//       if (event.key === 'Enter') {
//         event.preventDefault();
//         const verifyButton = document.getElementById('dbVerifyOtpBtn');
//         if (verifyButton && !verifyButton.disabled) verifyButton.click();
//       }
//     });
//   }

//   /* ---------- Video Modal ---------- */
//   function initVideoModal() {
//     const modal = document.getElementById('videoModal');
//     const box = document.getElementById('videoBox');
//     if (!modal || !box) return;

//     document.addEventListener('click', event => {
//       const playBtn = event.target.closest('.play-btn, [data-play]');
//       if (playBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//         const card = playBtn.closest('.t-card, .profile-page, #profileContent');
//         const docName = card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent?.trim() || 'this therapist';
//         box.innerHTML = `
//           <div class="vb-fill">A short intro from ${docName} would play here &mdash; 20&ndash;30 seconds, just enough to get a feel for them before you book.</div>
//           <button class="vb-close" id="videoClose">&times;</button>
//         `;
//         modal.classList.add('open');
//         document.getElementById('videoClose')?.addEventListener('click', () => modal.classList.remove('open'));
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.id === 'videoClose') {
//         modal.classList.remove('open');
//       }
//     });
//   }

//   /* ---------- FAQ Accordion ---------- */
//   function initFaqAccordion() {
//     document.addEventListener('click', event => {
//       const faqQ = event.target.closest('.p-faq-q');
//       if (faqQ) {
//         event.preventDefault();
//         const item = faqQ.closest('.p-faq-item');
//         if (item) item.classList.toggle('open');
//       }
//     });
//   }

//   /* ---------- Card Navigation to Profile ---------- */
//   function initCardNavigation() {
//     document.addEventListener('click', event => {
//       const card = event.target.closest('.t-card, .mini-card, .mt-therapist-skeleton');
//       if (!card) return;
//       if (event.target.closest('.play-btn, .book-btn, .consult-btn, .mini-book, .db-btn-book, a, button')) return;
//       const docId = normalizeId(
//         card.dataset.open ||
//         card.dataset.id ||
//         card.dataset.therapistId ||
//         card.dataset.docId ||
//         card.querySelector('[data-doc-id]')?.dataset.docId
//       ).replace(/\s+/g, '-');
//       if (docId) {
//         window.location.href = `/pages/doctor-profile?id=${encodeURIComponent(docId)}`;
//       }
//     });
//   }

//   /* ---------- Profile Page Data (Shopify Metafields + Google Sheet) ---------- */
//   function paletteForId(id) {
//     const hash = Array.from(normalizeId(id)).reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 997, 7);
//     return CARD_PALETTES[hash % CARD_PALETTES.length];
//   }

//   function splitList(text) {
//     if (Array.isArray(text)) return text.map(item => stringValue(item)).filter(Boolean);
//     return stringValue(text).split(',').map(item => item.trim()).filter(Boolean);
//   }

//   function normaliseFaqs(value) {
//     return (Array.isArray(value) ? value : []).map(entry => {
//       if (Array.isArray(entry)) return [stringValue(entry[0]), stringValue(entry[1])];
//       if (entry && typeof entry === 'object') return [stringValue(entry.question ?? entry.q), stringValue(entry.answer ?? entry.a)];
//       return ['', ''];
//     }).filter(pair => pair[0] || pair[1]);
//   }

//   function therapistProfile(therapist, palette) {
//     if (!therapist) return null;
//     const data = {
//       name: stringValue(therapist.name),
//       title: stringValue(therapist.role || therapist.title),
//       experience: stringValue(therapist.experience),
//       rating: stringValue(therapist.rating),
//       fee: stringValue(therapist.price || therapist.fee),
//       modes: stringValue(therapist.centre || therapist.modes),
//       duration: stringValue(therapist.duration),
//       speaks: stringValue(therapist.languages || therapist.speaks),
//       initials: initialsOf(therapist.name),
//       next_slot: stringValue(therapist.availability || therapist.next_slot),
//       bio: stringValue(therapist.bio),
//       about: stringValue(therapist.about),
//       how_i_work: stringValue(therapist.how_i_work),
//       sessions: stringValue(therapist.sessions),
//       switch_policy: stringValue(therapist.switch_policy),
//       image_url: safeUrl(therapist.image_url)
//     };
//     const expertise = splitList(therapist.expertise);
//     const helpTags = splitList(therapist.help_tags);
//     const faqs = normaliseFaqs(therapist.faqs);
//     if (expertise.length) data.expertise = expertise;
//     if (helpTags.length) data.help_tags = helpTags;
//     if (faqs.length) data.faqs = faqs;
//     if (palette) data.palette = palette;
//     Object.keys(data).forEach(key => {
//       if (data[key] === '' || data[key] === null || typeof data[key] === 'undefined') {
//         delete data[key];
//       }
//     });
//     return data;
//   }

//   function findTherapistForId(id) {
//     if (!id) return null;
//     const direct = state.therapists.get(id);
//     if (direct) return direct;
//     const fallback = state.profileFallback?.[id];
//     if (!fallback) return null;
//     return state.therapists.get(normalizeId(fallback.name).replace(/\s+/g, '-')) || null;
//   }

//   function applyProfileData(profile, doctor) {
//     if (!profile || !doctor) return;
//     const root = profile.closest('.db-page-wrapper') || profile;

//     ['title', 'experience', 'fee', 'rating', 'speaks', 'about', 'modes', 'duration', 'sessions', 'how_i_work', 'initials', 'next_slot', 'switch_policy'].forEach(field => {
//       root.querySelectorAll(`[data-bind="${field}"]`).forEach(element => {
//         if (doctor[field]) element.textContent = doctor[field];
//       });
//     });

//     root.querySelectorAll('[data-bind="name"]:not(.db-btn-book)').forEach(element => {
//       if (doctor.name) element.textContent = doctor.name;
//     });

//     const slotBadge = root.querySelector('.slot-badge');
//     if (slotBadge) slotBadge.style.display = doctor.next_slot ? '' : 'none';

//     const pMedia = document.getElementById('pMedia');
//     if (pMedia) {
//       const initials = pMedia.querySelector('.media-initials');
//       if (doctor.image_url) {
//         pMedia.style.background = `url("${doctor.image_url.replace(/["'()]/g, '')}") center/cover no-repeat`;
//         if (initials) initials.style.display = 'none';
//       } else if (Array.isArray(doctor.palette)) {
//         pMedia.style.background = `linear-gradient(150deg, ${doctor.palette[0]}, ${doctor.palette[1]} 120%)`;
//         if (initials) initials.style.display = '';
//       }
//     }

//     const tags = root.querySelector('[data-bind="expertise-tags"]');
//     if (tags && Array.isArray(doctor.expertise)) {
//       clearElement(tags);
//       doctor.expertise.forEach(expertise => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = expertise;
//         tags.appendChild(tag);
//       });
//     }

//     const helpTags = root.querySelector('[data-bind="help_tags"]');
//     if (helpTags && Array.isArray(doctor.help_tags)) {
//       clearElement(helpTags);
//       doctor.help_tags.forEach(htag => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = htag;
//         helpTags.appendChild(tag);
//       });
//     }

//     const faqsContainer = document.getElementById('pFAQs');
//     if (faqsContainer && Array.isArray(doctor.faqs)) {
//       clearElement(faqsContainer);
//       doctor.faqs.forEach(([question, answer], index) => {
//         const item = document.createElement('div');
//         item.className = `p-faq-item${index === 0 ? ' open' : ''}`;
//         item.innerHTML = `
//           <button type="button" class="p-faq-q">
//             <span>${esc(question)}</span>
//             <span class="plus">+</span>
//           </button>
//           <div class="p-faq-a">
//             <p>${esc(answer)}</p>
//           </div>
//         `;
//         faqsContainer.appendChild(item);
//       });
//     }
//   }

//   function updateProfileButtons(profile, id, doctor) {
//     const root = profile.closest('.db-page-wrapper') || profile;
//     const displayedName = stringValue(root.querySelector('[data-bind="name"]')?.textContent) || doctor.name || 'Therapist';
//     const price = stringValue(root.querySelector('.p-value[data-bind="fee"]')?.textContent) || doctor.fee || '₹2000';
//     const displayedFee = doctor.duration && !price.includes(doctor.duration) ? `${price} for ${doctor.duration}` : price;

//     root.querySelectorAll('.db-btn-book, .buy-btn, .consult-btn').forEach(button => {
//       button.dataset.docId = id;
//       button.dataset.docName = displayedName;
//       const isFreeCall = button.classList.contains('consult-btn') || /^free\b/i.test(stringValue(button.textContent));
//       if (!isFreeCall) {
//         button.dataset.docFee = displayedFee;
//       }
//     });
//   }

//   function mergeProfileData(sheetDoctor, fallbackDoctor) {
//     const merged = Object.assign({}, sheetDoctor || {}, fallbackDoctor || {});
//     if (sheetDoctor?.fee) merged.fee = sheetDoctor.fee;
//     if (sheetDoctor?.duration) merged.duration = sheetDoctor.duration;
//     return merged;
//   }

//   function renderProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const requested = normalizeId(profile.dataset.doctorId);
//     const therapist = findTherapistForId(requested);
//     const fallbackDoctor = state.profileFallback?.[requested] || null;

//     // Do not reveal a hard-coded/Shopify-only profile. The Sheet record must
//     // resolve first so visitors never see stale data flash before replacement.
//     if (!therapist) {
//       renderProfileStatus('This therapist was not found in the Google Sheet.', true);
//       return;
//     }

//     const sheetDoctor = therapistProfile(therapist, paletteForId(therapist.id));
//     // Shopify may supply richer profile copy, but the Sheet is the source of
//     // truth for live commercial fields. Without these explicit overrides, the
//     // hard-coded fallback fee (usually ₹2000) masks every Sheet price update.
//     const doctor = mergeProfileData(sheetDoctor, fallbackDoctor);
//     if (sheetDoctor?.faqs?.length && !fallbackDoctor?.faqs?.length) {
//       doctor.faqs = sheetDoctor.faqs;
//     }
//     if (sheetDoctor?.next_slot && !fallbackDoctor?.next_slot) {
//       doctor.next_slot = sheetDoctor.next_slot;
//     }

//     if (state.loaded && state.availabilityEnabled) {
//       doctor.next_slot = state.doctors.get(therapist.id)?.next_slot || '';
//     }

//     applyProfileData(profile, doctor);

//     const id = therapist?.id || requested;
//     profile.dataset.doctorId = id;
//     updateProfileButtons(profile, id, doctor);
//     revealProfilePage(profile);
//   }

//   /* ---------- Profile Page Initialization ---------- */
//   function initProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const queryId = new URLSearchParams(window.location.search).get('id')
//       || new URLSearchParams(window.location.search).get('doctor')
//       || new URLSearchParams(window.location.search).get('handle');

//    const profileData = {
//   "palak-chhabra": {
//     "name": "Palak Chhabra",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "PC",
//     "expertise": ["Emotional concerns", "Life transitions", "Grief and loss", "Self esteem"],
//     "help_tags": ["Relationship concerns", "Self and body image", "Burnout", "Confidence and growth"],
//     "bio": "Helping adults navigate their feelings and finding their way through life’s tough moments.",
//     "about": "Trauma-informed, queer-affirmative Counselling Psychologist supporting adults through emotions and transitions, with an M.A. in Lifespan Counselling, B.A. in Psychology & Philosophy, and a Diploma in Narrative Therapy.",
//     "how_i_work": "Warm, collaborative, non-pathologising sessions without having the pressure to figure it out. We explore your story together, your context, the meaning you make of your experiences and a range of emotions with empathy and understanding.",
//     "faqs": [
//       ["I'm part of the LGBTQ+ community. Is your practice queer-affirmative?", "Yes, absolutely. I work from a queer-affirmative and trauma-informed lens, and my practice is grounded in creating a safe, inclusive, non-judgmental space where you can come as you are without labels or the pressure to have everything figured out. I work in both English and Hindi."],
//       ["I don't know exactly what's wrong I just feel stuck or disconnected. Can I still come?", "Yes. You don't need to have a clear problem or everything figured out before you start. Many people come feeling stuck, lost, or disconnected from themselves, and we can explore that together at your pace, without forcing a diagnosis or a fixed way of working."],
//       ["Will I have homework or need to do things between sessions?", "Only if it feels useful to you. I may offer reflections, questions, or exercises between sessions when they seem helpful, but I don't believe therapy needs to be done perfectly curiosity, honesty, and engagement matter far more to me than getting everything \"right.\""],
//       ["Can I disagree with you or change what we talk about?", "Absolutely, in fact, I encourage it. You can call me by my first name, tell me something isn't working, change your mind about what you want to discuss, or simply show up on a day when you don't know what to say. I believe therapy works best when there's room for all of that."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "arushi-raheja": {
//     "name": "Arushi Raheja",
//     "title": "Child Psychologist",
//     "experience": "9+ yrs",
//     "sessions": "4000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AR",
//     "expertise": ["Parenting support", "Anxiety", "Attention and focus difficulties", "Autism"],
//     "help_tags": ["Trauma and grief", "Thoughts of self-harm or deep distress", "Emotional and behavioural difficulties", "Building self-confidence"],
//     "bio": "Helps in guiding children, adolescents, and parents through emotional hurdles, behavioural challenges, and parenting struggles in a safe environment.",
//     "about": "A Child Psychologist with a Master's degree in Clinical Psychology and NCERT- PG Diploma in Child Guidance, using a Gestalt-informed lens and experience helping children, young adults, and families thrive.",
//     "how_i_work": "Through compassionate conversations, creative activities, and practical guidance, we work together to help you understand your feelings, build strength, and make lasting progress to achieve a better sense of self.",
//     "faqs": [
//       ["My child has been diagnosed with ADHD or Autism — how do you approach that?", "I hold a Master's degree and a PG Diploma in Child Guidance and Counselling, and my practice focuses on supporting children and adolescents with ADHD, autism, learning disabilities, and related concerns. I tailor my approach to each child's unique needs, using a Gestalt-informed lens alongside practical, structured strategies that work for them."],
//       ["Do you work with adults too, or only children?", "While my core focus is children, adolescents, and young adults, I also work with parents and families. I facilitate workshops and training for parents, educators, and organisations on emotional well-being, positive parenting, and mental health topics."],
//       ["I'm worried about my child's self-harm or deep distress — how do you handle that?", "I have clinical experience supporting individuals experiencing self-harm or suicidal ideation. My approach is to create a safe, compassionate space where your child feels heard, assess the level of risk carefully, and work collaboratively with you to ensure they get the right support — including involving a psychiatrist or crisis support if needed."],
//       ["What does a session with you look like?", "Sessions are warm and tailored to your child's age and needs. I use compassionate conversations, creative activities, and practical guidance — drawing on Gestalt therapy and other modalities including dance movement therapy where appropriate — so therapy feels engaging rather than clinical."],
//       ["Do you only do individual therapy, or also workshops?", "I do both. Alongside individual sessions, I facilitate workshops and training programmes for schools, educators, parents, and organisations on emotional well-being, positive parenting, resilience, trauma, grief, and suicide prevention."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "mahita-kochhar": {
//     "name": "Mahita Kochhar",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "MK",
//     "expertise": ["Children and adolescent concerns", "Parenting support", "Emotional regulation", "School-related concerns"],
//     "help_tags": ["Behavioural concerns", "Self-esteem and confidence", "Social and relationship skills", "Adjustment and life transitions"],
//     "bio": "Sits with emotional, behavioural, and school-related difficulties with children, teens and parents to work through them with art based approaches.",
//     "about": "A Counselling Psychologist with a Masters in Clinical Psychology and a PG Diploma in Guidance and counselling and experience in school counselling and Special Educational Needs (SEN) settings.",
//     "how_i_work": "Sessions are warm, empathetic, and conversational. Through engaging activities and creative art-based techniques, we work together to build self-awareness, emotional regulation and develop healthy coping habits.",
//     "faqs": [
//       ["I'm an adult — do you only work with children?", "No — while my core focus is children and adolescents, I also work with adults, especially parents and those navigating emotional regulation, anxiety, self-esteem, and life transitions. My art-based approach can be adapted to adults too, if that feels helpful."],
//       ["I'm not great at talking about my feelings — will therapy still work for me?", "Absolutely. I use creative and art-based techniques alongside conversation, so you can express yourself in ways beyond words — through drawing, colours, and activities — at a pace that feels comfortable for you."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, in Hindi or English. We'll begin by understanding your story and goals, then build a warm, personalised rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your concerns and goals — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["I'm a parent — can you help me support my child better?", "Yes — parenting support is one of my focus areas. I work with parents to help them understand and support their child's emotional and behavioural needs, through separate parent sessions or joint check-ins where helpful."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   },
//   "chavika-dudeja": {
//     "name": "Chavika Dudeja",
//     "title": "Counselling Psychologist | RCI Licensed Rehabilitation Counselor",
//     "experience": "2 yrs",
//     "sessions": "1300+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "CD",
//     "expertise": ["Child counselling", "Family concerns", "Adjustment issues", "Emotional well being"],
//     "help_tags": ["Child counselling and rehabilitation", "Special needs children", "Personal growth", "Self-esteem challenges"],
//     "bio": "Works with individuals and children navigating emotions and transitions to build clarity and self-connection.",
//     "about": "A Counselling Psychologist with a B.A. in Human Development & Family Empowerment and an M.A. in Psychology specializing in Child and Adolescent Guidance.",
//     "how_i_work": "Sessions are warm, grounded, and structured yet flexible. Through compassionate conversations, clear understanding and practical strategies, we work together to help you gain insight and growth.",
//     "faqs": [
//       ["Do you take couples counselling?", "I work primarily with individuals, but if you're navigating relational concerns, we can explore those together in individual sessions."],
//       ["Do you provide medication?", "No — I'm a counselling psychologist, not a psychiatrist, so I don't prescribe medication. If it feels relevant, I can work alongside a psychiatrist or help you connect with one while we continue therapy together."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, and conducted in Hindi or English. We'll start with understanding your story and goals, then build a warm, structured yet flexible rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your goals and what you're navigating — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["Do you work with children and adolescents?", "Yes — I'm specializing in Child and Adolescent Guidance and Counselling, so I work with young people as well as adults, tailoring the approach to their age and needs."]
//     ],
//     "palette": ["#EAD9DE", "#EFE7DA"]
//   },
//   "alisha-crasto": {
//     "name": "Alisha Crasto",
//     "title": "Counselling Psychologist",
//     "experience": "7+ yrs",
//     "sessions": "2500+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AC",
//     "expertise": ["Child counselling", "Work stress and burnout", "Relationship understanding"],
//     "help_tags": ["Anxiety and stress", "Trauma", "Depression", "Self esteem"],
//     "bio": "Sits with children, adolescents, and adults as a gentle facilitator, trusting that clients hold their own answers and that every person deserves compassionate, accessible mental health care.",
//     "about": "A Psychologist and Narrative Therapy practitioner with a Master's in Clinical Psychology and a Diploma in Community Mental Health from NIMHANS, bringing 7 years of experience supporting children, adolescents, and adults across diverse mental health concerns.",
//     "how_i_work": "Sessions are warm, collaborative, and story-centred, where we explore your experiences together, gently re-authoring the narratives that shape you, at a pace that feels safe and yours. There is no fixing involved but understanding and acceptance.",
//     "faqs": [
//       ["Do you only use narrative therapy?", "Narrative therapy is my core approach, but I blend it with my clinical psychology training to meet each client's needs. The thread throughout is my belief that you are the expert on your own life, I'm here to walk alongside you, not to impose answers."],
//       ["I'm not sure how to talk about what I'm going through. Is that okay?", "Completely. Many people arrive not knowing how to put things into words. We'll go at your pace, and the narrative approach gives us gentle ways to explore your story without pressure to have it all figured out."],
//       ["Do you work with children and adolescents too?", "Yes, I have experience across children, adolescents, and adults. With younger clients, I adapt the approach to their age and world, often using stories and creative expression to help them feel comfortable."],
//       ["What does a first session look like?", "We'll start by getting to know each other and understanding what brought you in with no pressure to have a clear problem or goal. It's a space to share as much or as little as you're comfortable with, and we'll decide together how to move forward."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "vanshika-vakharia": {
//     "name": "Vanshika Vakharia",
//     "title": "Counselling Psychologist",
//     "experience": "4+ yrs",
//     "sessions": "1500+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "VV",
//     "expertise": ["Emotional regulation", "Healthy coping", "Self understanding"],
//     "help_tags": ["Anxiety and stress", "Emotional regulation", "Self-esteem and confidence", "Life transitions and adjustment", "Relationship concerns"],
//     "bio": "Works with children, adolescents, and adults by helping them understand unhelpful patterns, build healthier coping, and reconnect.",
//     "about": "Counselling Psychologist with a MA in counseling and clinical psychology who works with children, adolescents, and adults through various modalities like mindfulness, and emotional regulation strategies.",
//     "how_i_work": "A warm, collaborative conversation where you feel safe enough to be vulnerable, make sense of your thoughts and emotions, and move towards healing, growth, and lasting change, at a pace that feels right for you.",
//     "faqs": [
//       ["What does a first session look like?", "A warm, collaborative conversation where you feel safe enough to be vulnerable. We'll start by understanding what brought you in and what you're hoping to work on with no pressure to have it all figured out. We'll take it at a pace that feels right for you."],
//       ["Do you only use one type of therapy?", "No I integrate several evidence-based approaches, including CBT, REBT, mindfulness-based interventions, psychoeducation, and emotional regulation strategies. I tailor the blend to your needs and what feels most useful to you."],
//       ["I'm not good at opening up. Is that a problem?", "Not at all. Many clients find it hard to open up at first, and that's completely normal. My job is to create a safe, accepting space where you can be vulnerable at your own pace, there's no rush and no judgment."],
//       ["Do you work with children and adolescents too?", "Yes, I work across children, adolescents, and adults. With younger clients, I adapt my approach to their age and world, using age-appropriate, engaging methods to help them feel comfortable and understood."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "hita-shah": {
//     "name": "Hita Shah",
//     "title": "Counselling Psychologist",
//     "experience": "3+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "HS",
//     "expertise": ["Self understanding", "Anxiety and stress", "Relationship issues", "Transitions"],
//     "help_tags": ["Emotional balance", "Overthinking", "Confidence & self-worth", "Feeling stuck", "Personal growth"],
//     "bio": "Works in a warm, understanding space to slow down, make sense of what you’re feeling, and find ways forward at your own pace.",
//     "about": "A Counselling Psychologist holding an MSc in Psychology of Mental Health and a Diploma in Guidance and Counselling; offers a warm, supportive space to understand yourself and what you’re going through.",
//     "how_i_work": "Sessions are a space to slow down, talk openly, and make sense of what you’re experiencing. Together, we explore your thoughts, feelings, and patterns, while finding practical ways forward. We work collaboratively and at your pace.",
//     "faqs": [
//       ["What can I talk about in therapy?", "You can talk about whatever feels important to you, your thoughts, feelings, relationships, work, everyday struggles, or things you may not fully understand yet. You don’t need to know exactly where to begin."],
//       ["What happens in the first session?", "The first session is usually about getting to know you, understanding what brings you to therapy, and discussing what you would like support with. There is no pressure to have everything figured out."],
//       ["Will I be given advice or told what to do?", "Therapy with Hita is collaborative. Rather than simply telling you what to do, she helps you understand yourself, explore different perspectives, and find approaches that feel right for you."],
//       ["How often do I need to have sessions?", "There is no one-size-fits-all answer. The frequency can depend on what you’re looking for and what feels comfortable for you. This can be discussed together as you begin."],
//       ["What if I don’t know how to explain what I’m feeling?", "That’s completely okay. You don’t need to come with the perfect words. Sessions can be a space to slowly make sense of what you’re experiencing together."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   }
// };
//     profileData.palak = profileData["palak-chhabra"];
//     profileData.arushi = profileData["arushi-raheja"];
//     profileData.mahita = profileData["mahita-kochhar"];
//     profileData.chavika = profileData["chavika-dudeja"];

//     // Parse Shopify Product Metafields JSON output by the Liquid template
//     const shopifyProfiles = {};
//     let firstShopifyHandle = '';
//     const shopifyJsonEl = document.getElementById('shopify-doctors-json');
//     if (shopifyJsonEl) {
//       try {
//         const rawShopify = JSON.parse(shopifyJsonEl.textContent);
//         Object.keys(rawShopify).forEach(handle => {
//           const normKey = normalizeId(handle);
//           if (!firstShopifyHandle) firstShopifyHandle = normKey;
//           const norm = therapistProfile(rawShopify[handle], paletteForId(normKey));
//           if (norm) {
//             shopifyProfiles[normKey] = norm;
//             // Also index by first-name alias (e.g., "palak" -> "palak-chhabra") if not already taken
//             const shortKey = normKey.split('-')[0];
//             if (shortKey && !shopifyProfiles[shortKey]) {
//               shopifyProfiles[shortKey] = norm;
//             }
//           }
//         });
//       } catch (err) {
//         console.warn('[DoctorBooking] Could not parse shopify-doctors-json:', err);
//       }
//     }

//     // Merge hardcoded defaults with Shopify Product Metafields (Shopify Metafields override defaults)
//     state.profileFallback = Object.assign({}, profileData);
//     Object.keys(shopifyProfiles).forEach(key => {
//       state.profileFallback[key] = Object.assign({}, state.profileFallback[key] || {}, shopifyProfiles[key]);
//     });

//     const defaultId = profile.dataset.doctorId && profile.dataset.doctorId !== 'palak-chhabra'
//       ? profile.dataset.doctorId
//       : (firstShopifyHandle || 'palak-chhabra');

//     const id = normalizeId(queryId || defaultId);
//     profile.dataset.doctorId = id;

//     // Keep the Liquid fallback hidden while loadTherapists() resolves. It is
//     // used only to supplement the live Sheet record after that record exists.
//     profile.hidden = true;
//     profile.setAttribute('aria-busy', 'true');
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = false;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = false;
//   }

//   function initialise() {
//     initProfilePage();
//     initCategoryTabs();
//     initSelectionEvents();
//     initBookingModal();
//     initVideoModal();
//     initFaqAccordion();
//     initCardNavigation();
//     loadTherapists().then(renderProfilePage).catch(() => { });
//     loadAvailability().catch(() => { });
//     initAutoRefresh();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
//   else initialise();
// })();


// (() => {
//   'use strict';

//   const DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbx4o7EeOP02BZVv5AwtiFGY-5uTiGalPiJzqIUu7r9hRPPNdasApH7wGxjNxwVRtrQdcA/exec';
//   const REFRESH_INTERVAL_MS = 45000;
//   const REQUEST_TIMEOUT_MS = 15000;
//   const state = {
//     doctors: new Map(),
//     therapists: new Map(),
//     bookedMap: new Map(),
//     pendingMap: new Map(),
//     profileFallback: null,
//     currentDoctorId: '',
//     modalDoctor: null,
//     loaded: false,
//     availabilityEnabled: false,
//     loadingPromise: null,
//     therapistsPromise: null,
//     requestController: null,
//     bookingRequestId: '',
//     otpChallengeId: '',
//     otpVerificationToken: '',
//     otpResendTimer: null,
//     checkoutPromise: null,
//     currentCheckout: null,
//     localBooked: [],
//     refreshTimer: null
//   };

//   const apiUrl = () => {
//     const configured = document.querySelector('[data-booking-api-url]')?.dataset.bookingApiUrl?.trim();
//     return configured || window.DoctorBookingConfig?.apiUrl || DEFAULT_API_URL;
//   };
//   const normalizeId = value => String(value ?? '').trim().toLowerCase();
//   const normalizeMode = value => {
//     const mode = String(value ?? 'online').toLowerCase();
//     return mode.includes('person') || mode.includes('clinic') ? 'in-person' : 'online';
//   };
//   const stringValue = value => String(value ?? '').trim();
//   const sheetKey = value => stringValue(value).toLowerCase()
//     .replace(/[\s-]+/g, '_')
//     .replace(/[^a-z0-9_]/g, '')
//     .replace(/_+/g, '_');
//   const normaliseSlotTime = value => {
//     const text = stringValue(value).toUpperCase();
//     const match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/);
//     if (!match) return text;
//     const hour = Number(match[1]);
//     if (Number(match[2]) > 59 || hour > (match[3] ? 12 : 23) || (match[3] && hour < 1)) return text;
//     return `${String(hour % 12 || 12).padStart(2, '0')}:${match[2]} ${match[3] || (hour >= 12 ? 'PM' : 'AM')}`;
//   };

//   /* ---------- Google Sheet therapist data ---------- */
//   const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
//   const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const DEFAULT_TIME_SLOTS = ['10:00 AM', '11:30 AM', '02:00 PM', '03:30 PM', '05:00 PM', '06:30 PM'];
//   const CARD_PALETTES = [
//     ['#EAD9DE', '#786C8A'],
//     ['#EFE7DA', '#EAD9DE'],
//     ['#786C8A', '#EFE7DA'],
//     ['#EAD9DE', '#EFE7DA'],
//     ['#EFE7DA', '#786C8A']
//   ];
//   const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
//   const safeUrl = value => /^https?:\/\//i.test(stringValue(value)) ? stringValue(value) : '';
//   const initialsOf = name => stringValue(name).split(/\s+/).slice(0, 2).map(word => word.slice(0, 1).toUpperCase()).join('') || '?';

//   function normaliseTherapist(record) {
//     if (!record || typeof record !== 'object') return null;
//     const row = {};
//     Object.keys(record).forEach(key => { row[sheetKey(key)] = record[key]; });
//     const id = normalizeId(row.id || row.handle || row.slug).replace(/\s+/g, '-');
//     if (!id) return null;
//     const active = !['no', 'false', '0', 'hidden'].includes(stringValue(row.active || 'yes').toLowerCase());
//     const slots = stringValue(row.time_slots).split(/[;,]/).map(normaliseSlotTime).filter(Boolean);
//     const rawPrice = stringValue(row.price || row.fee);
//     const days = stringValue(row.days).split(/[,;]/)
//       .map(day => day.trim().toUpperCase().slice(0, 3))
//       .filter(day => DAY_NAMES.includes(day));
//     return {
//       id,
//       name: stringValue(row.name) || 'Therapist',
//       role: stringValue(row.role || row.title) || 'Therapist',
//       rating: stringValue(row.rating),
//       price: /^\d+(\.\d+)?$/.test(rawPrice) ? `₹${Number(rawPrice).toLocaleString('en-IN')}` : rawPrice,
//       duration: stringValue(row.duration),
//       availability: stringValue(row.availability || row.next_slot),
//       image_url: safeUrl(row.image_url || row.image),
//       experience: stringValue(row.experience),
//       expertise: stringValue(row.expertise),
//       languages: stringValue(row.languages || row.speaks),
//       centre: stringValue(row.centre || row.format) || 'Online',
//       gender: stringValue(row.gender),
//       bio: stringValue(row.bio),
//       trust_line: stringValue(row.trust_line),
//       about: stringValue(row.about),
//       how_i_work: stringValue(row.how_i_work),
//       help_tags: stringValue(row.help_tags),
//       faqs: Array.isArray(row.faqs) ? row.faqs : [],
//       sessions: stringValue(row.sessions),
//       switch_policy: stringValue(row.switch_policy),
//       category: stringValue(row.category) || 'therapist',
//       days: days.length ? days : null,
//       time_slots: slots.length ? slots : DEFAULT_TIME_SLOTS.slice(),
//       active
//     };
//   }

//   function activeTherapists() {
//     return Array.from(state.therapists.values()).filter(therapist => therapist.active);
//   }

//   function therapistFee(therapist) {
//     if (!therapist?.price) return '';
//     return therapist.duration ? `${therapist.price} for ${therapist.duration}` : therapist.price;
//   }

//   function loadTherapists() {
//     if (state.therapistsPromise) return state.therapistsPromise;
//     const url = apiUrl();
//     const separator = url.includes('?') ? '&' : '?';
//     state.therapistsPromise = fetchJson(`${url}${separator}action=therapists&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (payload?.success === false) {
//         throw new Error(payload.message || 'The therapist service rejected the request.');
//       }
//       const records = Array.isArray(payload) ? payload : payload?.therapists || payload?.data;
//       if (!Array.isArray(records)) {
//         throw new Error('The therapist response does not contain a valid therapists list.');
//       }
//       const nextTherapists = new Map();
//       records.forEach(record => {
//         const therapist = normaliseTherapist(record);
//         if (therapist) nextTherapists.set(therapist.id, therapist);
//       });
//       state.therapists = nextTherapists;
//       if (state.therapists.size > 0) {
//         renderHomeCarousel();
//         renderListingCards();
//       } else {
//         renderHomeTherapistStatus('No therapists are available right now.');
//         renderListingStatus('No therapists are available right now.');
//         if (!state.profileFallback) {
//           renderProfileStatus('This therapist is not available right now.');
//         }
//       }
//     }).catch(error => {
//       console.warn('[DoctorBooking] Therapist sheet data could not be loaded.', error);
//       renderHomeTherapistStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderListingStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderProfileStatus('This therapist could not be loaded. Please try again shortly.', true);
//       throw error;
//     }).finally(() => { state.therapistsPromise = null; });
//     return state.therapistsPromise;
//   }

//   function renderHomeCarousel() {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     const bookLabel = stringValue(carousel.dataset.bookLabel) || 'Book Session';
//     const endLink = carousel.querySelector('.carousel-end');
//     carousel.innerHTML = therapists.map((therapist, index) => {
//       const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//       const media = therapist.image_url
//         ? `<img loading="lazy" src="${esc(therapist.image_url)}" alt="${esc(therapist.name)}">`
//         : `<div class="mini-initials">${esc(initialsOf(therapist.name))}</div>`;
//       const slot = therapist.availability
//         ? `<span class="mini-slot"><span class="dot"></span>${esc(therapist.availability)}</span>`
//         : '';
//       return `<article class="mini-card" data-therapist-id="${esc(therapist.id)}">
//         <div class="mini-media" style="--card-a:${palette[0]};--card-b:${palette[1]}">${media}${slot}</div>
//         <div class="mini-body"><div class="mini-name-row"><h3>${esc(therapist.name)}</h3><span class="mini-verified" aria-label="Verified">&#10003;</span></div><div class="mini-role">${esc(therapist.role)}</div><div class="mini-meta"><span class="star">&#9733;</span> ${esc(therapist.rating)}</div><div class="mini-price">${esc(therapist.price)}</div><button type="button" class="mini-book db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">${esc(bookLabel)}</button></div>
//       </article>`;
//     }).join('');
//     if (endLink) {
//       endLink.hidden = false;
//       carousel.appendChild(endLink);
//     }
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderHomeTherapistStatus(message, isError = false) {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const status = document.createElement('div');
//     status.className = `mt-therapists-status${isError ? ' mt-therapists-status-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     carousel.replaceChildren(status);
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderListingStatus(message, isError = false) {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const status = document.createElement('div');
//     status.className = `db-list-status${isError ? ' db-list-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     listEl.replaceChildren(status);
//     listEl.setAttribute('aria-busy', 'false');
//   }

//   function renderProfileStatus(message, isError = false) {
//     const loader = document.getElementById('dbProfileLoading');
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!loader || !profile) return;
//     profile.hidden = true;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//     const status = document.createElement('div');
//     status.className = `db-profile-status${isError ? ' db-profile-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     loader.replaceChildren(status);
//     loader.hidden = false;
//   }

//   function revealProfilePage(profile) {
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = true;
//     profile.hidden = false;
//     profile.setAttribute('aria-busy', 'false');
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = false;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//   }

//   function listingCardHtml(therapist, index) {
//     const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//     const tags = therapist.expertise.split(',').map(tag => tag.trim()).filter(Boolean)
//       .map(tag => `<span class="tag">${esc(tag)}</span>`).join('');
//     const mediaStyle = therapist.image_url
//       ? `background:url('${esc(therapist.image_url)}') center/cover no-repeat, linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`
//       : `background:linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`;
//     const meta = [
//       `<span class="star">&#9733;</span>${esc(therapist.rating)}`,
//       therapist.role ? `<span class="sep">&middot;</span> ${esc(therapist.role)}` : '',
//       therapist.experience ? `<span class="sep">&middot;</span> ${esc(therapist.experience)}` : ''
//     ].join(' ');
//     return `<article class="t-card" data-id="${esc(therapist.id)}" data-category="${esc(therapist.category)}" data-open="${esc(therapist.id)}">
//       <div class="media" style="${mediaStyle}">
//         ${therapist.image_url ? '' : `<div class="media-initials">${esc(initialsOf(therapist.name))}</div>`}
//         ${therapist.availability ? `<span class="slot-badge"><span class="dot"></span>Next: ${esc(therapist.availability)}</span>` : ''}
//       </div>
//       <div class="t-body">
//         <div class="name-row"><h2>${esc(therapist.name)}</h2><span class="verified" title="Verified">&#10003;</span></div>
//         <div class="meta-line">${meta}</div>
//         ${tags ? `<div class="tags-row">${tags}</div>` : ''}
//         ${therapist.bio ? `<p class="bio-line">${esc(therapist.bio)}</p>` : ''}
//        ${String(therapist.trust_line || '')
//   .split('|')
//   .map(line => line.trim())
//   .filter(Boolean)
//   .map(line => `
//     <div class="trust-line">
//       <span class="ic">&#10003;</span>
//       <span>${esc(line)}</span>
//     </div>
//   `)
//   .join('')}
//         ${therapist.sessions ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.sessions)}</div>` : ''}
//         ${therapist.switch_policy ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.switch_policy)}</div>` : ''}
//         <div class="price-cta-row">
//           <div class="price-line">
//             <span class="p-label">${esc(therapist.centre)}${therapist.duration ? ` &middot; ${esc(therapist.duration)}` : ''}</span>
//             <span class="p-value">${esc(therapist.price)}</span>
//           </div>
//           <div class="cta-buttons-row">
//             <a href="/pages/doctor-profile?id=${encodeURIComponent(therapist.id)}" class="consult-btn" data-consult="${esc(therapist.id)}">Free 15-min call</a>
//             <button type="button" class="book-btn db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">Book Session</button>
//           </div>
//         </div>
//       </div>
//     </article>`;
//   }

//   function renderListingCards() {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     listEl.innerHTML = therapists.map((therapist, index) => listingCardHtml(therapist, index)).join('');
//     listEl.setAttribute('aria-busy', 'false');
//     updateDoctorCards();
//     filterDoctors();
//   }

//   function isoOf(day) {
//     return `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
//   }

//   function dateFromIso(iso) {
//     const match = stringValue(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
//     if (!match) return null;
//     const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
//     return Number.isNaN(date.getTime()) ? null : date;
//   }

//   function parseBooked(payload) {
//     const entries = Array.isArray(payload?.booked) ? payload.booked : [];
//     state.bookedMap = new Map();
//     state.pendingMap = new Map();
//     entries.forEach(entry => {
//       const docId = normalizeId(entry.doctor_id).replace(/\s+/g, '-');
//       const iso = stringValue(entry.date);
//       const time = normaliseSlotTime(entry.time);
//       if (!docId || !/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//       const key = `${docId}|${iso}`;
//       const pending = stringValue(entry.status).toLowerCase() === 'payment_pending';
//       const target = pending ? state.pendingMap : state.bookedMap;
//       if (!target.has(key)) target.set(key, new Set());
//       target.get(key).add(time);
//     });
//     state.localBooked = state.localBooked.filter(entry => !entry.expiresAt || Date.parse(entry.expiresAt) > Date.now());
//     state.localBooked.forEach(entry => {
//       const key = `${entry.doctorId}|${entry.date}`;
//       if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//       state.pendingMap.get(key).add(entry.time);
//     });
//   }

//   function activeDatePill() {
//     return document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill.active')
//       || document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill');
//   }

//   function modalSlots(iso = activeDatePill()?.dataset.iso || '') {
//     if (state.availabilityEnabled) {
//       return state.doctors.get(state.currentDoctorId)?.schedule?.[iso] || [];
//     }
//     const slots = state.modalDoctor?.time_slots;
//     return slots?.length ? slots : DEFAULT_TIME_SLOTS;
//   }

//   function markFullDatePills() {
//     document.querySelectorAll('#dbBookingModal .db-date-pill').forEach(pill => {
//       const slots = modalSlots(pill.dataset.iso);
//       const booked = state.bookedMap.get(`${state.currentDoctorId}|${pill.dataset.iso}`);
//       const isFull = slots.length > 0 && !!booked && slots.every(slot => booked.has(slot));
//       pill.classList.toggle('db-date-full', isFull);
//     });
//   }

//   function ensureDatePills(therapist) {
//     const row = document.querySelector('#dbBookingModal .db-date-picker-row');
//     if (!row) return;
//     const previousIso = activeDatePill()?.dataset.iso || '';
//     if (!state.loaded) {
//       setHiddenValue('dbBookingDate', '');
//       showLoading(row, 'Loading dates…');
//       return;
//     }

//     if (state.availabilityEnabled) {
//       const today = isoOf(new Date());
//       const schedule = state.doctors.get(state.currentDoctorId)?.schedule || {};
//       const dates = Object.keys(schedule)
//         .filter(iso => iso >= today && Array.isArray(schedule[iso]) && schedule[iso].length)
//         .sort();
//       if (!dates.length) {
//         setHiddenValue('dbBookingDate', '');
//         setHiddenValue('dbBookingTime', '');
//         renderMessage(row, 'No upcoming dates are available for this therapist.');
//         return;
//       }
//       row.innerHTML = dates.map(iso => {
//         const day = dateFromIso(iso);
//         const dayName = DAY_NAMES[day.getDay()];
//         const offset = Math.round((day.getTime() - dateFromIso(today).getTime()) / 86400000);
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         return `<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`;
//       }).join('');
//       markFullDatePills();
//       const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//       const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//       active?.classList.add('active');
//       setHiddenValue('dbBookingDate', active?.dataset.date || '');
//       return;
//     }

//     const build = useDayFilter => {
//       const pills = [];
//       const now = new Date();
//       for (let offset = 0; offset < 60 && pills.length < 30; offset++) {
//         const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
//         const dayName = DAY_NAMES[day.getDay()];
//         if (useDayFilter && therapist?.days && !therapist.days.includes(dayName)) continue;
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         const iso = isoOf(day);
//         pills.push(`<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`);
//       }
//       return pills;
//     };
//     let pills = build(true);
//     if (!pills.length) pills = build(false);
//     row.innerHTML = pills.join('');
//     markFullDatePills();
//     const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//     const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingDate', active?.dataset.date || '');
//   }

//   function renderTimePills() {
//     const grid = document.querySelector('#dbBookingModal .db-time-grid');
//     if (!grid) return;
//     if (!state.loaded) {
//       setHiddenValue('dbBookingTime', '');
//       showLoading(grid);
//       return;
//     }
//     const previous = stringValue(document.getElementById('dbBookingTime')?.value);
//     const iso = activeDatePill()?.dataset.iso || '';
//     const slots = modalSlots(iso);
//     if (!iso || !slots.length) {
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(grid, iso ? 'No times are available on this date.' : 'Select an available date first.');
//       return;
//     }
//     const booked = state.bookedMap.get(`${state.currentDoctorId}|${iso}`);
//     const pending = state.pendingMap.get(`${state.currentDoctorId}|${iso}`);
//     grid.innerHTML = slots.map(slot => {
//       if (booked?.has(slot)) {
//         return `<div class="db-time-pill db-time-booked" aria-disabled="true">${esc(slot)}<span class="db-booked-tag">Booked</span></div>`;
//       }
//       if (pending?.has(slot)) {
//         return `<div class="db-time-pill db-time-pending" title="Reserved. Select only to resume your existing payment.">${esc(slot)}<span class="db-booked-tag">Payment pending</span></div>`;
//       }
//       return `<div class="db-time-pill">${esc(slot)}</div>`;
//     }).join('');
//     const active = Array.from(grid.querySelectorAll('.db-time-pill:not(.db-time-booked)'))
//       .find(pill => slotText(pill) === previous)
//       || grid.querySelector('.db-time-pill:not(.db-time-booked):not(.db-time-pending)');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingTime', active ? slotText(active) : '');
//   }

//   const slotText = pill => pill?.querySelector('.db-booked-tag')
//     ? pill.textContent.replace(pill.querySelector('.db-booked-tag').textContent, '').trim()
//     : stringValue(pill?.textContent);

//   function safeUuid() {
//     if (window.crypto?.randomUUID) return window.crypto.randomUUID();
//     return `booking-${Date.now()}-${Math.random().toString(16).slice(2)}`;
//   }

//   function clearElement(element) {
//     if (element) element.replaceChildren();
//   }

//   function renderMessage(container, message, isError = false) {
//     if (!container) return;
//     clearElement(container);
//     const status = document.createElement('div');
//     status.className = `db-availability-message${isError ? ' db-availability-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     container.appendChild(status);
//   }

//   function showLoading(container, message = 'Loading availability…') {
//     if (!container) return;
//     clearElement(container);
//     const wrapper = document.createElement('div');
//     wrapper.className = 'db-loading-spinner-wrap';
//     wrapper.setAttribute('role', 'status');
//     const spinner = document.createElement('div');
//     spinner.className = 'db-loading-spinner';
//     spinner.setAttribute('aria-hidden', 'true');
//     const label = document.createElement('span');
//     label.textContent = message;
//     wrapper.append(spinner, label);
//     container.appendChild(wrapper);
//   }

//   function normaliseSchedule(value) {
//     const schedule = {};
//     if (Array.isArray(value)) {
//       value.forEach(entry => {
//         const iso = stringValue(entry?.date);
//         const slots = Array.isArray(entry?.slots) ? entry.slots : [];
//         if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
//           schedule[iso] = [...new Set(slots.map(normaliseSlotTime).filter(Boolean))];
//         }
//       });
//       return schedule;
//     }
//     if (!value || typeof value !== 'object') return schedule;
//     Object.keys(value).forEach(iso => {
//       if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !Array.isArray(value[iso])) return;
//       schedule[iso] = [...new Set(value[iso].map(normaliseSlotTime).filter(Boolean))];
//     });
//     return schedule;
//   }

//   function normaliseDoctor(record) {
//     if (!record || typeof record !== 'object') return null;
//     const id = normalizeId(record.doctor_id || record.doctorId || record.handle || record.id);
//     if (!id) return null;
//     const schedule = normaliseSchedule(record.schedule || record.availability_by_date);
//     return {
//       ...record,
//       doctor_id: id,
//       next_slot: stringValue(record.next_slot || record.nextSlot),
//       dates: Array.isArray(record.dates || record.available_dates)
//         ? (record.dates || record.available_dates).map(stringValue).filter(Boolean)
//         : Object.keys(schedule),
//       schedule
//     };
//   }

//   function normalisePayload(payload) {
//     if (payload && payload.success === false) {
//       throw new Error(payload.message || 'The booking service rejected the availability request.');
//     }
//     const records = Array.isArray(payload) ? payload : payload?.doctors || payload?.data || payload?.availability || [];
//     const map = new Map();
//     records.forEach(item => {
//       const doc = normaliseDoctor(item);
//       if (doc) map.set(doc.doctor_id, doc);
//     });
//     return map;
//   }

//   async function fetchJson(url, options = {}) {
//     const controller = new AbortController();
//     const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
//     try {
//       const response = await fetch(url, { ...options, signal: controller.signal });
//       const text = await response.text();
//       let data = null;
//       try { data = JSON.parse(text); } catch (_) { }
//       if (!response.ok) {
//         const error = new Error(data?.message || `Request failed with HTTP status ${response.status}`);
//         error.code = data?.code || `HTTP_${response.status}`;
//         throw error;
//       }
//       if (data === null) {
//         const error = new Error('The booking service returned an invalid response. Check the latest Apps Script execution log.');
//         error.code = 'INVALID_JSON_RESPONSE';
//         throw error;
//       }
//       return data;
//     } finally {
//       window.clearTimeout(timeout);
//     }
//   }

//   function setHiddenValue(id, value) {
//     const input = document.getElementById(id);
//     if (input && typeof value !== 'undefined') input.value = value;
//   }

//   function updateDoctorCards() {
//     document.querySelectorAll('.t-card, .db-doctor-card, .mini-card').forEach(card => {
//       const id = normalizeId(card.dataset.id || card.dataset.open || card.dataset.therapistId);
//       const doctor = state.doctors.get(id);
//       if (!doctor) return;
//       const badge = card.querySelector('.slot-badge, .db-next-slot, .mini-slot');
//       if (doctor.next_slot) {
//         if (badge) {
//           badge.style.display = '';
//           const dot = badge.querySelector('.dot, .db-status-dot');
//           if (dot) {
//             badge.innerHTML = `<span class="dot"></span>Next: ${esc(doctor.next_slot)}`;
//           } else {
//             badge.textContent = `Next: ${doctor.next_slot}`;
//           }
//         }
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     });

//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     const profileId = normalizeId(profile?.dataset.doctorId);
//     const profileDoctor = state.doctors.get(profileId);
//     if (profile && profileDoctor) {
//       const badge = profile.querySelector('.slot-badge');
//       const value = badge?.querySelector('[data-bind="next_slot"]');
//       if (profileDoctor.next_slot) {
//         if (value) value.textContent = profileDoctor.next_slot;
//         if (badge) badge.style.display = '';
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     }
//   }

//   async function loadAvailability() {
//     const url = apiUrl();
//     if (!url) return null;
//     if (state.loadingPromise) return state.loadingPromise;
//     const separator = url.includes('?') ? '&' : '?';
//     state.loadingPromise = fetchJson(`${url}${separator}action=availability&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (!Array.isArray(payload?.booked)) throw new Error('Availability response is missing booked slots.');
//       state.doctors = normalisePayload(payload);
//       state.availabilityEnabled = payload?.availability_enabled === true;
//       state.loaded = true;
//       parseBooked(payload);
//       updateDoctorCards();
//       if (document.getElementById('dbBookingModal')?.classList.contains('active')) {
//         ensureDatePills(state.modalDoctor);
//         renderTimePills();
//       }
//       return payload;
//     }).catch(error => {
//       state.loaded = false;
//       setHiddenValue('dbBookingDate', '');
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(document.querySelector('#dbBookingModal .db-date-picker-row'), 'Available dates could not be checked. Please try again.', true);
//       renderMessage(document.getElementById('dbTimeGrid'), 'Availability could not be checked. Please reopen the booking form to retry.', true);
//       console.warn('[DoctorBooking] Note on live availability:', error);
//     }).finally(() => { state.loadingPromise = null; });
//     return state.loadingPromise;
//   }

//   function initAutoRefresh() {
//     const refreshSheetData = () => {
//       loadTherapists().then(renderProfilePage).catch(() => { });
//       loadAvailability().catch(() => { });
//     };
//     state.refreshTimer = window.setInterval(() => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     }, REFRESH_INTERVAL_MS);
//     document.addEventListener('visibilitychange', () => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     });
//   }

//   /* ---------- Category Filter Tabs ---------- */
//   function initCategoryTabs() {
//     document.querySelectorAll('.db-tab-btn').forEach(tab => {
//       tab.addEventListener('click', () => {
//         document.querySelectorAll('.db-tab-btn').forEach(item => item.classList.remove('active'));
//         tab.classList.add('active');
//         filterDoctors();
//       });
//     });
//   }

//   function filterDoctors() {
//     const category = document.querySelector('.db-tab-btn.active')?.dataset.category || 'all';
//     document.querySelectorAll('.t-card, .db-doctor-card').forEach(card => {
//       const cardCat = stringValue(card.dataset.category).toLowerCase();
//       const visible = (category === 'all' || cardCat.includes(category.toLowerCase()));
//       card.style.display = visible ? '' : 'none';
//     });
//   }

//   /* ---------- Selection Events (Mode / Date / Time) ---------- */
//   function initSelectionEvents() {
//     document.addEventListener('click', event => {
//       const modeButton = event.target.closest('.db-mode-btn');
//       if (modeButton) {
//         const selector = modeButton.closest('.db-mode-selector');
//         selector?.querySelectorAll('.db-mode-btn').forEach(button => {
//           button.classList.toggle('active', button === modeButton);
//         });
//         const mode = normalizeMode(modeButton.dataset.mode || modeButton.textContent);
//         setHiddenValue('dbConsultationMode', mode);
//         return;
//       }

//       const datePill = event.target.closest('.db-date-pill');
//       if (datePill) {
//         if (datePill.classList.contains('db-date-full')) return;
//         const row = datePill.closest('.db-date-picker-row');
//         row?.querySelectorAll('.db-date-pill').forEach(pill => pill.classList.remove('active'));
//         datePill.classList.add('active');
//         setHiddenValue('dbBookingDate', datePill.dataset.date || '');
//         renderTimePills();
//         return;
//       }

//       const timePill = event.target.closest('.db-time-pill');
//       if (timePill) {
//         if (timePill.classList.contains('db-time-booked')) return;
//         const grid = timePill.closest('.db-time-grid');
//         grid?.querySelectorAll('.db-time-pill').forEach(pill => pill.classList.remove('active'));
//         timePill.classList.add('active');
//         setHiddenValue('dbBookingTime', slotText(timePill));
//         if (timePill.classList.contains('db-time-pending')) {
//           window.alert('This slot is reserved pending payment. Continue only to resume your booking using the same verified WhatsApp number.');
//         }
//       }
//     });
//   }

//   /* ---------- Booking Modal Functions ---------- */
//   function openBookingModal(button) {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     const card = button.closest('.t-card, .profile-page, #profileContent');
//     const id = normalizeId(button.dataset.docId || card?.dataset.id || card?.dataset.open || state.currentDoctorId || 'palak-chhabra');
//     state.currentDoctorId = id;
//     state.bookingRequestId = '';
//     state.otpChallengeId = '';
//     state.otpVerificationToken = '';
//     state.currentCheckout = null;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;

//     const name = stringValue(button.dataset.docName)
//       || stringValue(card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent)
//       || 'Therapist';
//     const fee = stringValue(button.dataset.docFee)
//       || stringValue(card?.querySelector('.price-line .p-value, [data-bind="fee"]')?.textContent)
//       || '₹2000';

//     const therapist = state.therapists.get(id);
//     const fallbackDoc = state.profileFallback?.[id];
//     let resolvedName = name;
//     let resolvedFee = fee;
//     if (therapist) {
//       resolvedName = therapist.name || name;
//       resolvedFee = therapistFee(therapist) || fee;
//     } else if (fallbackDoc) {
//       resolvedName = fallbackDoc.name || name;
//       resolvedFee = fallbackDoc.fee || fee;
//     }
//     state.modalDoctor = therapist || null;

//     const nameElement = document.getElementById('dbModalDocName');
//     const feeElement = document.getElementById('dbModalDocFee');
//     if (nameElement) nameElement.textContent = resolvedName;
//     if (feeElement) feeElement.textContent = resolvedFee;

//     setHiddenValue('dbDoctorId', id);
//     setHiddenValue('dbDoctorName', resolvedName);
//     setHiddenValue('dbDoctorFee', resolvedFee);

//     setHiddenValue('dbBookingTime', '');
//     ensureDatePills(therapist);
//     renderTimePills();

//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     if (paymentButtonContainer) {
//       paymentButtonContainer.style.display = 'none';
//       paymentButtonContainer.replaceChildren();
//     }

//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'block';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'none';
//     const otpInput = document.getElementById('dbOtpCode');
//     if (otpInput) otpInput.value = '';
//     const otpStatus = document.getElementById('dbOtpStatus');
//     if (otpStatus) otpStatus.textContent = '';

//     modal.classList.add('active');
//     loadAvailability().catch(() => {});
//   }

//   const closeBookingModal = () => {
//     document.getElementById('dbBookingModal')?.classList.remove('active');
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//   };

//   function markSlotBookedLocally(iso, time, expiresAt) {
//     if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//     state.localBooked.push({ doctorId: state.currentDoctorId, date: iso, time, expiresAt });
//     const key = `${state.currentDoctorId}|${iso}`;
//     if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//     state.pendingMap.get(key).add(time);
//     markFullDatePills();
//     renderTimePills();
//     loadAvailability().catch(() => { });
//   }

//   function loadRazorpayCheckout() {
//     if (window.Razorpay) return Promise.resolve();
//     if (state.checkoutPromise) return state.checkoutPromise;
//     state.checkoutPromise = new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;
//       script.onload = () => resolve();
//       script.onerror = () => reject(new Error('Razorpay Checkout could not be loaded.'));
//       document.head.appendChild(script);
//     }).finally(() => { state.checkoutPromise = null; });
//     return state.checkoutPromise;
//   }

//   async function verifyRazorpayPayment(response) {
//     let lastResult = null;
//     for (let attempt = 0; attempt < 3; attempt++) {
//       if (attempt > 0) await new Promise(resolve => window.setTimeout(resolve, 1500));
//       lastResult = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_payment',
//           request_id: state.bookingRequestId,
//           razorpay_payment_id: response.razorpay_payment_id,
//           razorpay_order_id: response.razorpay_order_id,
//           razorpay_signature: response.razorpay_signature
//         })
//       });
//       if (lastResult?.success === true && stringValue(lastResult?.status).toLowerCase() === 'confirmed') return lastResult;
//       if (lastResult?.code !== 'PAYMENT_NOT_CAPTURED') break;
//     }
//     const error = new Error(lastResult?.message || 'Payment verification is still pending.');
//     error.code = lastResult?.code || 'PAYMENT_VERIFICATION_FAILED';
//     throw error;
//   }

//   async function startRazorpayCheckout(checkout) {
//     if (!checkout?.key_id || !checkout?.order_id || !checkout?.amount) return;
//     try {
//       await loadRazorpayCheckout();
//       const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//       const patientEmail = stringValue(document.getElementById('dbPatientEmail')?.value);
//       const rawPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//       const phoneDigits = rawPhone.replace(/\D/g, '');
//       const patientPhone = rawPhone.startsWith('+')
//         ? `+${phoneDigits}`
//         : phoneDigits.length === 10
//           ? `+91${phoneDigits}`
//           : `+${phoneDigits}`;
//       const razorpay = new window.Razorpay({
//         key: checkout.key_id,
//         order_id: checkout.order_id,
//         amount: checkout.amount,
//         currency: checkout.currency || 'INR',
//         name: 'MushinTalks',
//         description: `Therapy session with ${stringValue(document.getElementById('dbDoctorName')?.value)}`,
//         prefill: {
//           name: patientName,
//           email: patientEmail,
//           contact: patientPhone
//         },
//         readonly: { name: true, contact: true, email: Boolean(patientEmail) },
//         hidden: { contact: true, email: Boolean(patientEmail) },
//         theme: { color: '#786c8a' },
//         handler: async response => {
//           const successTitle = document.getElementById('dbSuccessTitle');
//           const successText = document.getElementById('dbSuccessText');
//           if (successTitle) successTitle.textContent = 'Verifying Payment…';
//           if (successText) successText.textContent = 'Please wait while we securely confirm your payment.';
//           try {
//             const verified = await verifyRazorpayPayment(response);
//             state.bookingRequestId = '';
//             state.currentCheckout = null;
//             showBookingSuccess(verified.payment_status, verified.status, null);
//           } catch (error) {
//             showBookingSuccess('pending', 'payment_pending', checkout);
//             window.alert(error?.message || 'Payment verification is pending. Please contact us with your payment ID.');
//           }
//         }
//       });
//       razorpay.on('payment.failed', response => {
//         const description = response?.error?.description || 'Payment failed. You can retry using the same reserved slot.';
//         window.alert(description);
//       });
//       razorpay.open();
//     } catch (error) {
//       window.alert(error?.message || 'Payment could not be opened. Please try again.');
//     }
//   }

//   function renderCheckoutButton(container, checkout) {
//     container.replaceChildren();
//     const button = document.createElement('button');
//     button.type = 'button';
//     button.className = 'db-btn-primary db-pay-now-btn';
//     button.textContent = 'Pay Now →';
//     button.addEventListener('click', () => startRazorpayCheckout(checkout));
//     container.appendChild(button);
//   }

//   function showBookingSuccess(paymentStatus, bookingStatus, checkout) {
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'none';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'block';
//     const normalizedPaymentStatus = stringValue(paymentStatus).toLowerCase();
//     const normalizedBookingStatus = stringValue(bookingStatus).toLowerCase();
//     const paymentConfirmed = ['paid', 'captured', 'success'].includes(normalizedPaymentStatus)
//       || normalizedBookingStatus === 'confirmed';
//     const successTitle = document.getElementById('dbSuccessTitle');
//     const successText = document.getElementById('dbSuccessText');
//     if (successTitle) successTitle.textContent = paymentConfirmed ? 'Booking Confirmed!' : 'Slot Reserved';
//     if (successText) {
//       successText.textContent = paymentConfirmed
//         ? 'Your payment is confirmed and your consultation has been booked.'
//         : 'Your slot is reserved pending payment. Complete the payment below to confirm your booking.';
//     }
//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     const resolvedCheckout = checkout?.order_id ? checkout : state.currentCheckout;
//     if (paymentButtonContainer) {
//       if (!paymentConfirmed && resolvedCheckout) {
//         state.currentCheckout = resolvedCheckout;
//         paymentButtonContainer.style.display = 'block';
//         renderCheckoutButton(paymentButtonContainer, resolvedCheckout);
//       } else {
//         paymentButtonContainer.style.display = 'none';
//         paymentButtonContainer.replaceChildren();
//         if (!paymentConfirmed && successText) {
//           successText.textContent = 'The payment session could not be prepared. Close this window and retry the same slot with the same phone number.';
//         }
//       }
//     }
//   }

//   function setOtpStatus(message, isError = false) {
//     const status = document.getElementById('dbOtpStatus');
//     if (!status) return;
//     status.textContent = message || '';
//     status.classList.toggle('db-otp-status-error', Boolean(isError));
//   }

//   function validateOtpRequestForm() {
//     if (!state.loaded) {
//       window.alert('Please wait until availability has been checked.');
//       return null;
//     }
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return null;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');
//     const localDigits = phoneDigits.length === 12 && phoneDigits.startsWith('91')
//       ? phoneDigits.slice(2)
//       : phoneDigits.length === 11 && phoneDigits.startsWith('0')
//         ? phoneDigits.slice(1)
//         : phoneDigits;
//     if (!patientName || !/^[6-9]\d{9}$/.test(localDigits)) {
//       window.alert('Please enter your full name and a valid 10-digit Indian WhatsApp number.');
//       return null;
//     }
//     if (!stringValue(document.getElementById('dbBookingTime')?.value)) {
//       window.alert('Please select an available time slot first.');
//       return null;
//     }
//     return { patientName, patientPhone };
//   }

//   function startOtpResendCountdown(seconds) {
//     const button = document.getElementById('dbOtpResendBtn');
//     if (!button) return;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     let remaining = Math.max(1, Number(seconds) || 60);
//     const render = () => {
//       button.disabled = remaining > 0;
//       button.textContent = remaining > 0 ? `Resend in ${remaining}s` : 'Resend code';
//     };
//     render();
//     state.otpResendTimer = window.setInterval(() => {
//       remaining -= 1;
//       render();
//       if (remaining <= 0) {
//         window.clearInterval(state.otpResendTimer);
//         state.otpResendTimer = null;
//       }
//     }, 1000);
//   }

//   async function requestBookingOtp(button) {
//     const details = validateOtpRequestForm();
//     if (!details) return;
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'SENDING CODE…';
//     setOtpStatus('');
//     let result = null;
//     try {
//       result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({ action: 'send_otp', patient_phone: details.patientPhone })
//       });
//       if (result?.success !== true || !result?.challenge_id) {
//         const unknownOtpAction = result?.code === 'UNKNOWN_ACTION' ||
//           /^Unknown action:\s*send_otp$/i.test(stringValue(result?.message));
//         const error = new Error(unknownOtpAction
//           ? 'The booking service is using an older Apps Script deployment. Publish the latest Code.gs as a new version of the existing web app deployment, then try again.'
//           : result?.message || 'The verification code could not be sent.');
//         error.code = result?.code || 'OTP_SEND_FAILED';
//         throw error;
//       }
//       state.otpChallengeId = stringValue(result.challenge_id);
//       state.otpVerificationToken = '';
//       const stepOne = document.getElementById('dbModalStep1');
//       const otpStep = document.getElementById('dbModalStepOtp');
//       if (stepOne) stepOne.style.display = 'none';
//       if (otpStep) otpStep.style.display = 'block';
//       const masked = document.getElementById('dbOtpMaskedPhone');
//       if (masked) masked.textContent = stringValue(result.masked_phone) || 'your WhatsApp number';
//       const input = document.getElementById('dbOtpCode');
//       if (input) {
//         input.value = '';
//         input.focus();
//       }
//       setOtpStatus('Code sent. It expires in 5 minutes.');
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP could not be sent.', error);
//       setOtpStatus(error?.message || 'The verification code could not be sent.', true);
//       window.alert(error?.message || 'The verification code could not be sent.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//     if (result?.success === true) startOtpResendCountdown(result.retry_after);
//   }

//   async function verifyBookingOtp(button) {
//     const otp = stringValue(document.getElementById('dbOtpCode')?.value).replace(/\D/g, '');
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     if (!state.otpChallengeId || !/^\d{6}$/.test(otp)) {
//       setOtpStatus('Enter the 6-digit code sent on WhatsApp.', true);
//       return;
//     }
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'VERIFYING…';
//     setOtpStatus('Verifying code…');
//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_otp',
//           patient_phone: patientPhone,
//           challenge_id: state.otpChallengeId,
//           otp
//         })
//       });
//       if (result?.success !== true || !result?.verification_token) {
//         const error = new Error(result?.message || 'The verification code is incorrect.');
//         error.code = result?.code || 'OTP_INCORRECT';
//         throw error;
//       }
//       state.otpVerificationToken = stringValue(result.verification_token);
//       setOtpStatus('WhatsApp number verified. Reserving your slot…');
//       await submitBooking(button);
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP verification failed.', error);
//       setOtpStatus(error?.message || 'The verification code could not be verified.', true);
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   async function submitBooking(button) {
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');

//     if (!patientName || phoneDigits.length < 7 || phoneDigits.length > 15) {
//       window.alert('Please enter your full name and a valid phone number.');
//       return;
//     }

//     const mode = stringValue(document.getElementById('dbConsultationMode')?.value) || 'Online Video';
//     const datePill = activeDatePill();
//     const date = datePill?.dataset.iso || stringValue(document.getElementById('dbBookingDate')?.value) || 'Today';
//     const time = stringValue(document.getElementById('dbBookingTime')?.value);
//     if (!time) {
//       window.alert('No slots are left on this date — please pick another day.');
//       return;
//     }

//     if (!state.bookingRequestId) state.bookingRequestId = safeUuid();
//     const payload = {
//       action: 'book',
//       request_id: state.bookingRequestId,
//       doctor_id: state.currentDoctorId,
//       doctor_name: stringValue(document.getElementById('dbDoctorName')?.value),
//       doctor_fee: stringValue(document.getElementById('dbDoctorFee')?.value),
//       patient_name: patientName,
//       patient_phone: patientPhone,
//       patient_email: stringValue(document.getElementById('dbPatientEmail')?.value),
//       otp_verification_token: state.otpVerificationToken,
//       mode: mode,
//       date: date,
//       date_label: stringValue(datePill?.dataset.date),
//       time: time,
//       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       source: 'shopify-storefront'
//     };

//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'CONFIRMING…';

//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const resultStatus = stringValue(result?.status || 'booked').toLowerCase();
//       const confirmed = result?.success === true && ['booked', 'confirmed', 'payment_pending', 'reserved'].includes(resultStatus);
//       if (!confirmed) {
//         const bookingError = new Error(result?.message || 'The slot could not be booked.');
//         bookingError.code = result?.code || 'BOOKING_REJECTED';
//         throw bookingError;
//       }
//       showBookingSuccess(
//         result?.payment_status,
//         result?.status,
//         result?.checkout
//       );
//       state.bookingRequestId = stringValue(result?.request_id) || state.bookingRequestId;
//       markSlotBookedLocally(date, time, result?.payment_expires_at);
//     } catch (error) {
//       console.error('[DoctorBooking] Booking was not confirmed.', error);
//       if (error?.code === 'SLOT_ALREADY_BOOKED') state.bookingRequestId = '';
//       if (['OTP_REQUIRED', 'OTP_EXPIRED', 'OTP_INVALID', 'OTP_ALREADY_USED'].includes(error?.code)) {
//         state.otpVerificationToken = '';
//         setOtpStatus(error?.message || 'Verify your WhatsApp number again.', true);
//         const otpStep = document.getElementById('dbModalStepOtp');
//         if (otpStep) otpStep.style.display = 'block';
//       }
//       await loadAvailability().catch(() => { });
//       window.alert(error?.message || 'The booking could not be confirmed. Please try again.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   function initBookingModal() {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     document.addEventListener('click', event => {
//       const bookButton = event.target.closest('.book-btn, .buy-btn, .db-btn-book');
//       if (bookButton) {
//         event.preventDefault();
//         event.stopPropagation();
//         openBookingModal(bookButton);
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.closest('.db-modal-close, .db-modal-cancel')) closeBookingModal();
//     });

//     document.addEventListener('keydown', event => {
//       if (event.key === 'Escape' && modal.classList.contains('active')) closeBookingModal();
//     });

//     modal.querySelector('.db-date-prev')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: -160, behavior: 'smooth' });
//     });
//     modal.querySelector('.db-date-next')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: 160, behavior: 'smooth' });
//     });

//     document.getElementById('dbConfirmBookingBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbVerifyOtpBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       verifyBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpResendBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpBackBtn')?.addEventListener('click', () => {
//       if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//       state.otpResendTimer = null;
//       state.otpChallengeId = '';
//       state.otpVerificationToken = '';
//       const otpStep = document.getElementById('dbModalStepOtp');
//       const stepOne = document.getElementById('dbModalStep1');
//       if (otpStep) otpStep.style.display = 'none';
//       if (stepOne) stepOne.style.display = 'block';
//     });
//     document.getElementById('dbOtpCode')?.addEventListener('keydown', event => {
//       if (event.key === 'Enter') {
//         event.preventDefault();
//         const verifyButton = document.getElementById('dbVerifyOtpBtn');
//         if (verifyButton && !verifyButton.disabled) verifyButton.click();
//       }
//     });
//   }

//   /* ---------- Video Modal ---------- */
//   function initVideoModal() {
//     const modal = document.getElementById('videoModal');
//     const box = document.getElementById('videoBox');
//     if (!modal || !box) return;

//     document.addEventListener('click', event => {
//       const playBtn = event.target.closest('.play-btn, [data-play]');
//       if (playBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//         const card = playBtn.closest('.t-card, .profile-page, #profileContent');
//         const docName = card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent?.trim() || 'this therapist';
//         box.innerHTML = `
//           <div class="vb-fill">A short intro from ${docName} would play here &mdash; 20&ndash;30 seconds, just enough to get a feel for them before you book.</div>
//           <button class="vb-close" id="videoClose">&times;</button>
//         `;
//         modal.classList.add('open');
//         document.getElementById('videoClose')?.addEventListener('click', () => modal.classList.remove('open'));
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.id === 'videoClose') {
//         modal.classList.remove('open');
//       }
//     });
//   }

//   /* ---------- FAQ Accordion ---------- */
//   function initFaqAccordion() {
//     document.addEventListener('click', event => {
//       const faqQ = event.target.closest('.p-faq-q');
//       if (faqQ) {
//         event.preventDefault();
//         const item = faqQ.closest('.p-faq-item');
//         if (item) item.classList.toggle('open');
//       }
//     });
//   }

//   /* ---------- Card Navigation to Profile ---------- */
//   function initCardNavigation() {
//     document.addEventListener('click', event => {
//       const card = event.target.closest('.t-card');
//       if (!card) return;
//       if (event.target.closest('.play-btn, .book-btn, .consult-btn, .db-btn-book, a, button')) return;
//       const docId = card.dataset.open || card.dataset.id;
//       if (docId) {
//         window.location.href = `/pages/doctor-profile?id=${encodeURIComponent(docId)}`;
//       }
//     });
//   }

//   /* ---------- Profile Page Data (Shopify Metafields + Google Sheet) ---------- */
//   function paletteForId(id) {
//     const hash = Array.from(normalizeId(id)).reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 997, 7);
//     return CARD_PALETTES[hash % CARD_PALETTES.length];
//   }

//   function splitList(text) {
//     if (Array.isArray(text)) return text.map(item => stringValue(item)).filter(Boolean);
//     return stringValue(text).split(',').map(item => item.trim()).filter(Boolean);
//   }

//   function normaliseFaqs(value) {
//     return (Array.isArray(value) ? value : []).map(entry => {
//       if (Array.isArray(entry)) return [stringValue(entry[0]), stringValue(entry[1])];
//       if (entry && typeof entry === 'object') return [stringValue(entry.question ?? entry.q), stringValue(entry.answer ?? entry.a)];
//       return ['', ''];
//     }).filter(pair => pair[0] || pair[1]);
//   }

//   function therapistProfile(therapist, palette) {
//     if (!therapist) return null;
//     const data = {
//       name: stringValue(therapist.name),
//       title: stringValue(therapist.role || therapist.title),
//       experience: stringValue(therapist.experience),
//       rating: stringValue(therapist.rating),
//       fee: stringValue(therapist.price || therapist.fee),
//       modes: stringValue(therapist.centre || therapist.modes),
//       duration: stringValue(therapist.duration),
//       speaks: stringValue(therapist.languages || therapist.speaks),
//       initials: initialsOf(therapist.name),
//       next_slot: stringValue(therapist.availability || therapist.next_slot),
//       bio: stringValue(therapist.bio),
//       about: stringValue(therapist.about),
//       how_i_work: stringValue(therapist.how_i_work),
//       sessions: stringValue(therapist.sessions),
//       switch_policy: stringValue(therapist.switch_policy),
//       image_url: safeUrl(therapist.image_url)
//     };
//     const expertise = splitList(therapist.expertise);
//     const helpTags = splitList(therapist.help_tags);
//     const faqs = normaliseFaqs(therapist.faqs);
//     if (expertise.length) data.expertise = expertise;
//     if (helpTags.length) data.help_tags = helpTags;
//     if (faqs.length) data.faqs = faqs;
//     if (palette) data.palette = palette;
//     Object.keys(data).forEach(key => {
//       if (data[key] === '' || data[key] === null || typeof data[key] === 'undefined') {
//         delete data[key];
//       }
//     });
//     return data;
//   }

//   function findTherapistForId(id) {
//     if (!id) return null;
//     const direct = state.therapists.get(id);
//     if (direct) return direct;
//     const fallback = state.profileFallback?.[id];
//     if (!fallback) return null;
//     return state.therapists.get(normalizeId(fallback.name).replace(/\s+/g, '-')) || null;
//   }

//   function applyProfileData(profile, doctor) {
//     if (!profile || !doctor) return;
//     const root = profile.closest('.db-page-wrapper') || profile;

//     ['title', 'experience', 'fee', 'rating', 'speaks', 'about', 'modes', 'duration', 'sessions', 'how_i_work', 'initials', 'next_slot', 'switch_policy'].forEach(field => {
//       root.querySelectorAll(`[data-bind="${field}"]`).forEach(element => {
//         if (doctor[field]) element.textContent = doctor[field];
//       });
//     });

//     root.querySelectorAll('[data-bind="name"]:not(.db-btn-book)').forEach(element => {
//       if (doctor.name) element.textContent = doctor.name;
//     });

//     const slotBadge = root.querySelector('.slot-badge');
//     if (slotBadge) slotBadge.style.display = doctor.next_slot ? '' : 'none';

//     const pMedia = document.getElementById('pMedia');
//     if (pMedia) {
//       const initials = pMedia.querySelector('.media-initials');
//       if (doctor.image_url) {
//         pMedia.style.background = `url("${doctor.image_url.replace(/["'()]/g, '')}") center/cover no-repeat`;
//         if (initials) initials.style.display = 'none';
//       } else if (Array.isArray(doctor.palette)) {
//         pMedia.style.background = `linear-gradient(150deg, ${doctor.palette[0]}, ${doctor.palette[1]} 120%)`;
//         if (initials) initials.style.display = '';
//       }
//     }

//     const tags = root.querySelector('[data-bind="expertise-tags"]');
//     if (tags && Array.isArray(doctor.expertise)) {
//       clearElement(tags);
//       doctor.expertise.forEach(expertise => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = expertise;
//         tags.appendChild(tag);
//       });
//     }

//     const helpTags = root.querySelector('[data-bind="help_tags"]');
//     if (helpTags && Array.isArray(doctor.help_tags)) {
//       clearElement(helpTags);
//       doctor.help_tags.forEach(htag => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = htag;
//         helpTags.appendChild(tag);
//       });
//     }

//     const faqsContainer = document.getElementById('pFAQs');
//     if (faqsContainer && Array.isArray(doctor.faqs)) {
//       clearElement(faqsContainer);
//       doctor.faqs.forEach(([question, answer], index) => {
//         const item = document.createElement('div');
//         item.className = `p-faq-item${index === 0 ? ' open' : ''}`;
//         item.innerHTML = `
//           <button type="button" class="p-faq-q">
//             <span>${esc(question)}</span>
//             <span class="plus">+</span>
//           </button>
//           <div class="p-faq-a">
//             <p>${esc(answer)}</p>
//           </div>
//         `;
//         faqsContainer.appendChild(item);
//       });
//     }
//   }

//   function updateProfileButtons(profile, id, doctor) {
//     const root = profile.closest('.db-page-wrapper') || profile;
//     const displayedName = stringValue(root.querySelector('[data-bind="name"]')?.textContent) || doctor.name || 'Therapist';
//     const price = stringValue(root.querySelector('.p-value[data-bind="fee"]')?.textContent) || doctor.fee || '₹2000';
//     const displayedFee = doctor.duration && !price.includes(doctor.duration) ? `${price} for ${doctor.duration}` : price;

//     root.querySelectorAll('.db-btn-book, .buy-btn, .consult-btn').forEach(button => {
//       button.dataset.docId = id;
//       button.dataset.docName = displayedName;
//       const isFreeCall = button.classList.contains('consult-btn') || /^free\b/i.test(stringValue(button.textContent));
//       if (!isFreeCall) {
//         button.dataset.docFee = displayedFee;
//       }
//     });
//   }

//   function mergeProfileData(sheetDoctor, fallbackDoctor) {
//     const merged = Object.assign({}, sheetDoctor || {}, fallbackDoctor || {});
//     if (sheetDoctor?.fee) merged.fee = sheetDoctor.fee;
//     if (sheetDoctor?.duration) merged.duration = sheetDoctor.duration;
//     return merged;
//   }

//   function renderProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const requested = normalizeId(profile.dataset.doctorId);
//     const therapist = findTherapistForId(requested);
//     const fallbackDoctor = state.profileFallback?.[requested] || null;

//     // Do not reveal a hard-coded/Shopify-only profile. The Sheet record must
//     // resolve first so visitors never see stale data flash before replacement.
//     if (!therapist) {
//       renderProfileStatus('This therapist was not found in the Google Sheet.', true);
//       return;
//     }

//     const sheetDoctor = therapistProfile(therapist, paletteForId(therapist.id));
//     // Shopify may supply richer profile copy, but the Sheet is the source of
//     // truth for live commercial fields. Without these explicit overrides, the
//     // hard-coded fallback fee (usually ₹2000) masks every Sheet price update.
//     const doctor = mergeProfileData(sheetDoctor, fallbackDoctor);
//     if (sheetDoctor?.faqs?.length && !fallbackDoctor?.faqs?.length) {
//       doctor.faqs = sheetDoctor.faqs;
//     }
//     if (sheetDoctor?.next_slot && !fallbackDoctor?.next_slot) {
//       doctor.next_slot = sheetDoctor.next_slot;
//     }

//     if (state.loaded && state.availabilityEnabled) {
//       doctor.next_slot = state.doctors.get(therapist.id)?.next_slot || '';
//     }

//     applyProfileData(profile, doctor);

//     const id = therapist?.id || requested;
//     profile.dataset.doctorId = id;
//     updateProfileButtons(profile, id, doctor);
//     revealProfilePage(profile);
//   }

//   /* ---------- Profile Page Initialization ---------- */
//   function initProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const queryId = new URLSearchParams(window.location.search).get('id')
//       || new URLSearchParams(window.location.search).get('doctor')
//       || new URLSearchParams(window.location.search).get('handle');

//    const profileData = {
//   "palak-chhabra": {
//     "name": "Palak Chhabra",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "PC",
//     "expertise": ["Emotional concerns", "Life transitions", "Grief and loss", "Self esteem"],
//     "help_tags": ["Relationship concerns", "Self and body image", "Burnout", "Confidence and growth"],
//     "bio": "Helping adults navigate their feelings and finding their way through life’s tough moments.",
//     "about": "Trauma-informed, queer-affirmative Counselling Psychologist supporting adults through emotions and transitions, with an M.A. in Lifespan Counselling, B.A. in Psychology & Philosophy, and a Diploma in Narrative Therapy.",
//     "how_i_work": "Warm, collaborative, non-pathologising sessions without having the pressure to figure it out. We explore your story together, your context, the meaning you make of your experiences and a range of emotions with empathy and understanding.",
//     "faqs": [
//       ["I'm part of the LGBTQ+ community. Is your practice queer-affirmative?", "Yes, absolutely. I work from a queer-affirmative and trauma-informed lens, and my practice is grounded in creating a safe, inclusive, non-judgmental space where you can come as you are without labels or the pressure to have everything figured out. I work in both English and Hindi."],
//       ["I don't know exactly what's wrong I just feel stuck or disconnected. Can I still come?", "Yes. You don't need to have a clear problem or everything figured out before you start. Many people come feeling stuck, lost, or disconnected from themselves, and we can explore that together at your pace, without forcing a diagnosis or a fixed way of working."],
//       ["Will I have homework or need to do things between sessions?", "Only if it feels useful to you. I may offer reflections, questions, or exercises between sessions when they seem helpful, but I don't believe therapy needs to be done perfectly curiosity, honesty, and engagement matter far more to me than getting everything \"right.\""],
//       ["Can I disagree with you or change what we talk about?", "Absolutely, in fact, I encourage it. You can call me by my first name, tell me something isn't working, change your mind about what you want to discuss, or simply show up on a day when you don't know what to say. I believe therapy works best when there's room for all of that."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "arushi-raheja": {
//     "name": "Arushi Raheja",
//     "title": "Child Psychologist",
//     "experience": "9+ yrs",
//     "sessions": "4000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AR",
//     "expertise": ["Parenting support", "Anxiety", "Attention and focus difficulties", "Autism"],
//     "help_tags": ["Trauma and grief", "Thoughts of self-harm or deep distress", "Emotional and behavioural difficulties", "Building self-confidence"],
//     "bio": "Helps in guiding children, adolescents, and parents through emotional hurdles, behavioural challenges, and parenting struggles in a safe environment.",
//     "about": "A Child Psychologist with a Master's degree in Clinical Psychology and NCERT- PG Diploma in Child Guidance, using a Gestalt-informed lens and experience helping children, young adults, and families thrive.",
//     "how_i_work": "Through compassionate conversations, creative activities, and practical guidance, we work together to help you understand your feelings, build strength, and make lasting progress to achieve a better sense of self.",
//     "faqs": [
//       ["My child has been diagnosed with ADHD or Autism — how do you approach that?", "I hold a Master's degree and a PG Diploma in Child Guidance and Counselling, and my practice focuses on supporting children and adolescents with ADHD, autism, learning disabilities, and related concerns. I tailor my approach to each child's unique needs, using a Gestalt-informed lens alongside practical, structured strategies that work for them."],
//       ["Do you work with adults too, or only children?", "While my core focus is children, adolescents, and young adults, I also work with parents and families. I facilitate workshops and training for parents, educators, and organisations on emotional well-being, positive parenting, and mental health topics."],
//       ["I'm worried about my child's self-harm or deep distress — how do you handle that?", "I have clinical experience supporting individuals experiencing self-harm or suicidal ideation. My approach is to create a safe, compassionate space where your child feels heard, assess the level of risk carefully, and work collaboratively with you to ensure they get the right support — including involving a psychiatrist or crisis support if needed."],
//       ["What does a session with you look like?", "Sessions are warm and tailored to your child's age and needs. I use compassionate conversations, creative activities, and practical guidance — drawing on Gestalt therapy and other modalities including dance movement therapy where appropriate — so therapy feels engaging rather than clinical."],
//       ["Do you only do individual therapy, or also workshops?", "I do both. Alongside individual sessions, I facilitate workshops and training programmes for schools, educators, parents, and organisations on emotional well-being, positive parenting, resilience, trauma, grief, and suicide prevention."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "mahita-kochhar": {
//     "name": "Mahita Kochhar",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "MK",
//     "expertise": ["Children and adolescent concerns", "Parenting support", "Emotional regulation", "School-related concerns"],
//     "help_tags": ["Behavioural concerns", "Self-esteem and confidence", "Social and relationship skills", "Adjustment and life transitions"],
//     "bio": "Sits with emotional, behavioural, and school-related difficulties with children, teens and parents to work through them with art based approaches.",
//     "about": "A Counselling Psychologist with a Masters in Clinical Psychology and a PG Diploma in Guidance and counselling and experience in school counselling and Special Educational Needs (SEN) settings.",
//     "how_i_work": "Sessions are warm, empathetic, and conversational. Through engaging activities and creative art-based techniques, we work together to build self-awareness, emotional regulation and develop healthy coping habits.",
//     "faqs": [
//       ["I'm an adult — do you only work with children?", "No — while my core focus is children and adolescents, I also work with adults, especially parents and those navigating emotional regulation, anxiety, self-esteem, and life transitions. My art-based approach can be adapted to adults too, if that feels helpful."],
//       ["I'm not great at talking about my feelings — will therapy still work for me?", "Absolutely. I use creative and art-based techniques alongside conversation, so you can express yourself in ways beyond words — through drawing, colours, and activities — at a pace that feels comfortable for you."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, in Hindi or English. We'll begin by understanding your story and goals, then build a warm, personalised rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your concerns and goals — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["I'm a parent — can you help me support my child better?", "Yes — parenting support is one of my focus areas. I work with parents to help them understand and support their child's emotional and behavioural needs, through separate parent sessions or joint check-ins where helpful."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   },
//   "chavika-dudeja": {
//     "name": "Chavika Dudeja",
//     "title": "Counselling Psychologist | RCI Licensed Rehabilitation Counselor",
//     "experience": "2 yrs",
//     "sessions": "1300+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "CD",
//     "expertise": ["Child counselling", "Family concerns", "Adjustment issues", "Emotional well being"],
//     "help_tags": ["Child counselling and rehabilitation", "Special needs children", "Personal growth", "Self-esteem challenges"],
//     "bio": "Works with individuals and children navigating emotions and transitions to build clarity and self-connection.",
//     "about": "A Counselling Psychologist with a B.A. in Human Development & Family Empowerment and an M.A. in Psychology specializing in Child and Adolescent Guidance.",
//     "how_i_work": "Sessions are warm, grounded, and structured yet flexible. Through compassionate conversations, clear understanding and practical strategies, we work together to help you gain insight and growth.",
//     "faqs": [
//       ["Do you take couples counselling?", "I work primarily with individuals, but if you're navigating relational concerns, we can explore those together in individual sessions."],
//       ["Do you provide medication?", "No — I'm a counselling psychologist, not a psychiatrist, so I don't prescribe medication. If it feels relevant, I can work alongside a psychiatrist or help you connect with one while we continue therapy together."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, and conducted in Hindi or English. We'll start with understanding your story and goals, then build a warm, structured yet flexible rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your goals and what you're navigating — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["Do you work with children and adolescents?", "Yes — I'm specializing in Child and Adolescent Guidance and Counselling, so I work with young people as well as adults, tailoring the approach to their age and needs."]
//     ],
//     "palette": ["#EAD9DE", "#EFE7DA"]
//   },
//   "alisha-crasto": {
//     "name": "Alisha Crasto",
//     "title": "Counselling Psychologist",
//     "experience": "7+ yrs",
//     "sessions": "2500+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AC",
//     "expertise": ["Child counselling", "Work stress and burnout", "Relationship understanding"],
//     "help_tags": ["Anxiety and stress", "Trauma", "Depression", "Self esteem"],
//     "bio": "Sits with children, adolescents, and adults as a gentle facilitator, trusting that clients hold their own answers and that every person deserves compassionate, accessible mental health care.",
//     "about": "A Psychologist and Narrative Therapy practitioner with a Master's in Clinical Psychology and a Diploma in Community Mental Health from NIMHANS, bringing 7 years of experience supporting children, adolescents, and adults across diverse mental health concerns.",
//     "how_i_work": "Sessions are warm, collaborative, and story-centred, where we explore your experiences together, gently re-authoring the narratives that shape you, at a pace that feels safe and yours. There is no fixing involved but understanding and acceptance.",
//     "faqs": [
//       ["Do you only use narrative therapy?", "Narrative therapy is my core approach, but I blend it with my clinical psychology training to meet each client's needs. The thread throughout is my belief that you are the expert on your own life, I'm here to walk alongside you, not to impose answers."],
//       ["I'm not sure how to talk about what I'm going through. Is that okay?", "Completely. Many people arrive not knowing how to put things into words. We'll go at your pace, and the narrative approach gives us gentle ways to explore your story without pressure to have it all figured out."],
//       ["Do you work with children and adolescents too?", "Yes, I have experience across children, adolescents, and adults. With younger clients, I adapt the approach to their age and world, often using stories and creative expression to help them feel comfortable."],
//       ["What does a first session look like?", "We'll start by getting to know each other and understanding what brought you in with no pressure to have a clear problem or goal. It's a space to share as much or as little as you're comfortable with, and we'll decide together how to move forward."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "vanshika-vakharia": {
//     "name": "Vanshika Vakharia",
//     "title": "Counselling Psychologist",
//     "experience": "4+ yrs",
//     "sessions": "1500+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "VV",
//     "expertise": ["Emotional regulation", "Healthy coping", "Self understanding"],
//     "help_tags": ["Anxiety and stress", "Emotional regulation", "Self-esteem and confidence", "Life transitions and adjustment", "Relationship concerns"],
//     "bio": "Works with children, adolescents, and adults by helping them understand unhelpful patterns, build healthier coping, and reconnect.",
//     "about": "Counselling Psychologist with a MA in counseling and clinical psychology who works with children, adolescents, and adults through various modalities like mindfulness, and emotional regulation strategies.",
//     "how_i_work": "A warm, collaborative conversation where you feel safe enough to be vulnerable, make sense of your thoughts and emotions, and move towards healing, growth, and lasting change, at a pace that feels right for you.",
//     "faqs": [
//       ["What does a first session look like?", "A warm, collaborative conversation where you feel safe enough to be vulnerable. We'll start by understanding what brought you in and what you're hoping to work on with no pressure to have it all figured out. We'll take it at a pace that feels right for you."],
//       ["Do you only use one type of therapy?", "No I integrate several evidence-based approaches, including CBT, REBT, mindfulness-based interventions, psychoeducation, and emotional regulation strategies. I tailor the blend to your needs and what feels most useful to you."],
//       ["I'm not good at opening up. Is that a problem?", "Not at all. Many clients find it hard to open up at first, and that's completely normal. My job is to create a safe, accepting space where you can be vulnerable at your own pace, there's no rush and no judgment."],
//       ["Do you work with children and adolescents too?", "Yes, I work across children, adolescents, and adults. With younger clients, I adapt my approach to their age and world, using age-appropriate, engaging methods to help them feel comfortable and understood."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "hita-shah": {
//     "name": "Hita Shah",
//     "title": "Counselling Psychologist",
//     "experience": "3+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "HS",
//     "expertise": ["Self understanding", "Anxiety and stress", "Relationship issues", "Transitions"],
//     "help_tags": ["Emotional balance", "Overthinking", "Confidence & self-worth", "Feeling stuck", "Personal growth"],
//     "bio": "Works in a warm, understanding space to slow down, make sense of what you’re feeling, and find ways forward at your own pace.",
//     "about": "A Counselling Psychologist holding an MSc in Psychology of Mental Health and a Diploma in Guidance and Counselling; offers a warm, supportive space to understand yourself and what you’re going through.",
//     "how_i_work": "Sessions are a space to slow down, talk openly, and make sense of what you’re experiencing. Together, we explore your thoughts, feelings, and patterns, while finding practical ways forward. We work collaboratively and at your pace.",
//     "faqs": [
//       ["What can I talk about in therapy?", "You can talk about whatever feels important to you, your thoughts, feelings, relationships, work, everyday struggles, or things you may not fully understand yet. You don’t need to know exactly where to begin."],
//       ["What happens in the first session?", "The first session is usually about getting to know you, understanding what brings you to therapy, and discussing what you would like support with. There is no pressure to have everything figured out."],
//       ["Will I be given advice or told what to do?", "Therapy with Hita is collaborative. Rather than simply telling you what to do, she helps you understand yourself, explore different perspectives, and find approaches that feel right for you."],
//       ["How often do I need to have sessions?", "There is no one-size-fits-all answer. The frequency can depend on what you’re looking for and what feels comfortable for you. This can be discussed together as you begin."],
//       ["What if I don’t know how to explain what I’m feeling?", "That’s completely okay. You don’t need to come with the perfect words. Sessions can be a space to slowly make sense of what you’re experiencing together."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   }
// };
//     profileData.palak = profileData["palak-chhabra"];
//     profileData.arushi = profileData["arushi-raheja"];
//     profileData.mahita = profileData["mahita-kochhar"];
//     profileData.chavika = profileData["chavika-dudeja"];

//     // Parse Shopify Product Metafields JSON output by the Liquid template
//     const shopifyProfiles = {};
//     let firstShopifyHandle = '';
//     const shopifyJsonEl = document.getElementById('shopify-doctors-json');
//     if (shopifyJsonEl) {
//       try {
//         const rawShopify = JSON.parse(shopifyJsonEl.textContent);
//         Object.keys(rawShopify).forEach(handle => {
//           const normKey = normalizeId(handle);
//           if (!firstShopifyHandle) firstShopifyHandle = normKey;
//           const norm = therapistProfile(rawShopify[handle], paletteForId(normKey));
//           if (norm) {
//             shopifyProfiles[normKey] = norm;
//             // Also index by first-name alias (e.g., "palak" -> "palak-chhabra") if not already taken
//             const shortKey = normKey.split('-')[0];
//             if (shortKey && !shopifyProfiles[shortKey]) {
//               shopifyProfiles[shortKey] = norm;
//             }
//           }
//         });
//       } catch (err) {
//         console.warn('[DoctorBooking] Could not parse shopify-doctors-json:', err);
//       }
//     }

//     // Merge hardcoded defaults with Shopify Product Metafields (Shopify Metafields override defaults)
//     state.profileFallback = Object.assign({}, profileData);
//     Object.keys(shopifyProfiles).forEach(key => {
//       state.profileFallback[key] = Object.assign({}, state.profileFallback[key] || {}, shopifyProfiles[key]);
//     });

//     const defaultId = profile.dataset.doctorId && profile.dataset.doctorId !== 'palak-chhabra'
//       ? profile.dataset.doctorId
//       : (firstShopifyHandle || 'palak-chhabra');

//     const id = normalizeId(queryId || defaultId);
//     profile.dataset.doctorId = id;

//     // Keep the Liquid fallback hidden while loadTherapists() resolves. It is
//     // used only to supplement the live Sheet record after that record exists.
//     profile.hidden = true;
//     profile.setAttribute('aria-busy', 'true');
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = false;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = false;
//   }

//   function initialise() {
//     initProfilePage();
//     initCategoryTabs();
//     initSelectionEvents();
//     initBookingModal();
//     initVideoModal();
//     initFaqAccordion();
//     initCardNavigation();
//     loadTherapists().then(renderProfilePage).catch(() => { });
//     loadAvailability().catch(() => { });
//     initAutoRefresh();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
//   else initialise();
// })();

// (() => {
//   'use strict';

//   const DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbx4o7EeOP02BZVv5AwtiFGY-5uTiGalPiJzqIUu7r9hRPPNdasApH7wGxjNxwVRtrQdcA/exec';
//   const REFRESH_INTERVAL_MS = 45000;
//   const REQUEST_TIMEOUT_MS = 15000;
//   const state = {
//     doctors: new Map(),
//     therapists: new Map(),
//     bookedMap: new Map(),
//     pendingMap: new Map(),
//     profileFallback: null,
//     currentDoctorId: '',
//     modalDoctor: null,
//     loaded: false,
//     availabilityEnabled: false,
//     loadingPromise: null,
//     therapistsPromise: null,
//     requestController: null,
//     bookingRequestId: '',
//     otpChallengeId: '',
//     otpVerificationToken: '',
//     otpResendTimer: null,
//     checkoutPromise: null,
//     currentCheckout: null,
//     localBooked: [],
//     refreshTimer: null
//   };

//   const apiUrl = () => {
//     const configured = document.querySelector('[data-booking-api-url]')?.dataset.bookingApiUrl?.trim();
//     return configured || window.DoctorBookingConfig?.apiUrl || DEFAULT_API_URL;
//   };
//   const normalizeId = value => String(value ?? '').trim().toLowerCase();
//   const normalizeMode = value => {
//     const mode = String(value ?? 'online').toLowerCase();
//     return mode.includes('person') || mode.includes('clinic') ? 'in-person' : 'online';
//   };
//   const stringValue = value => String(value ?? '').trim();
//   const sheetKey = value => stringValue(value).toLowerCase()
//     .replace(/[\s-]+/g, '_')
//     .replace(/[^a-z0-9_]/g, '')
//     .replace(/_+/g, '_');
//   const normaliseSlotTime = value => {
//     const text = stringValue(value).toUpperCase();
//     const match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/);
//     if (!match) return text;
//     const hour = Number(match[1]);
//     if (Number(match[2]) > 59 || hour > (match[3] ? 12 : 23) || (match[3] && hour < 1)) return text;
//     return `${String(hour % 12 || 12).padStart(2, '0')}:${match[2]} ${match[3] || (hour >= 12 ? 'PM' : 'AM')}`;
//   };

//   /* ---------- Google Sheet therapist data ---------- */
//   const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
//   const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const DEFAULT_TIME_SLOTS = ['10:00 AM', '11:30 AM', '02:00 PM', '03:30 PM', '05:00 PM', '06:30 PM'];
//   const CARD_PALETTES = [
//     ['#EAD9DE', '#786C8A'],
//     ['#EFE7DA', '#EAD9DE'],
//     ['#786C8A', '#EFE7DA'],
//     ['#EAD9DE', '#EFE7DA'],
//     ['#EFE7DA', '#786C8A']
//   ];
//   const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
//   const safeUrl = value => /^https?:\/\//i.test(stringValue(value)) ? stringValue(value) : '';
//   const initialsOf = name => stringValue(name).split(/\s+/).slice(0, 2).map(word => word.slice(0, 1).toUpperCase()).join('') || '?';

//   function normaliseTherapist(record) {
//     if (!record || typeof record !== 'object') return null;
//     const row = {};
//     Object.keys(record).forEach(key => { row[sheetKey(key)] = record[key]; });
//     const id = normalizeId(row.id || row.handle || row.slug).replace(/\s+/g, '-');
//     if (!id) return null;
//     const active = !['no', 'false', '0', 'hidden'].includes(stringValue(row.active || 'yes').toLowerCase());
//     const slots = stringValue(row.time_slots).split(/[;,]/).map(normaliseSlotTime).filter(Boolean);
//     const rawPrice = stringValue(row.price || row.fee);
//     const days = stringValue(row.days).split(/[,;]/)
//       .map(day => day.trim().toUpperCase().slice(0, 3))
//       .filter(day => DAY_NAMES.includes(day));
//     return {
//       id,
//       name: stringValue(row.name) || 'Therapist',
//       role: stringValue(row.role || row.title) || 'Therapist',
//       rating: stringValue(row.rating),
//       price: /^\d+(\.\d+)?$/.test(rawPrice) ? `₹${Number(rawPrice).toLocaleString('en-IN')}` : rawPrice,
//       duration: stringValue(row.duration),
//       availability: stringValue(row.availability || row.next_slot),
//       image_url: safeUrl(row.image_url || row.image),
//       experience: stringValue(row.experience),
//       expertise: stringValue(row.expertise),
//       languages: stringValue(row.languages || row.speaks),
//       centre: stringValue(row.centre || row.format) || 'Online',
//       gender: stringValue(row.gender),
//       bio: stringValue(row.bio),
//       trust_line: stringValue(row.trust_line),
//       about: stringValue(row.about),
//       how_i_work: stringValue(row.how_i_work),
//       help_tags: stringValue(row.help_tags),
//       faqs: Array.isArray(row.faqs) ? row.faqs : [],
//       sessions: stringValue(row.sessions),
//       switch_policy: stringValue(row.switch_policy),
//       category: stringValue(row.category) || 'therapist',
//       days: days.length ? days : null,
//       time_slots: slots.length ? slots : DEFAULT_TIME_SLOTS.slice(),
//       active
//     };
//   }

//   function activeTherapists() {
//     return Array.from(state.therapists.values()).filter(therapist => therapist.active);
//   }

//   function therapistFee(therapist) {
//     if (!therapist?.price) return '';
//     return therapist.duration ? `${therapist.price} for ${therapist.duration}` : therapist.price;
//   }

//   function loadTherapists() {
//     if (state.therapistsPromise) return state.therapistsPromise;
//     const url = apiUrl();
//     const separator = url.includes('?') ? '&' : '?';
//     state.therapistsPromise = fetchJson(`${url}${separator}action=therapists&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (payload?.success === false) {
//         throw new Error(payload.message || 'The therapist service rejected the request.');
//       }
//       const records = Array.isArray(payload) ? payload : payload?.therapists || payload?.data;
//       if (!Array.isArray(records)) {
//         throw new Error('The therapist response does not contain a valid therapists list.');
//       }
//       const nextTherapists = new Map();
//       records.forEach(record => {
//         const therapist = normaliseTherapist(record);
//         if (therapist) nextTherapists.set(therapist.id, therapist);
//       });
//       state.therapists = nextTherapists;
//       if (state.therapists.size > 0) {
//         renderHomeCarousel();
//         renderListingCards();
//       } else {
//         renderHomeTherapistStatus('No therapists are available right now.');
//         renderListingStatus('No therapists are available right now.');
//         if (!state.profileFallback) {
//           renderProfileStatus('This therapist is not available right now.');
//         }
//       }
//     }).catch(error => {
//       console.warn('[DoctorBooking] Therapist sheet data could not be loaded.', error);
//       renderHomeTherapistStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderListingStatus('Therapists could not be loaded. Please try again shortly.', true);
//       renderProfileStatus('This therapist could not be loaded. Please try again shortly.', true);
//       throw error;
//     }).finally(() => { state.therapistsPromise = null; });
//     return state.therapistsPromise;
//   }

//   function renderHomeCarousel() {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     const bookLabel = stringValue(carousel.dataset.bookLabel) || 'Book Session';
//     const endLink = carousel.querySelector('.carousel-end');
//     carousel.innerHTML = therapists.map((therapist, index) => {
//       const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//       const media = therapist.image_url
//         ? `<img loading="lazy" src="${esc(therapist.image_url)}" alt="${esc(therapist.name)}">`
//         : `<div class="mini-initials">${esc(initialsOf(therapist.name))}</div>`;
//       const slot = therapist.availability
//         ? `<span class="mini-slot"><span class="dot"></span>${esc(therapist.availability)}</span>`
//         : '';
//       return `<article class="mini-card" data-therapist-id="${esc(therapist.id)}">
//         <div class="mini-media" style="--card-a:${palette[0]};--card-b:${palette[1]}">${media}${slot}</div>
//         <div class="mini-body"><div class="mini-name-row"><h3>${esc(therapist.name)}</h3><span class="mini-verified" aria-label="Verified">&#10003;</span></div><div class="mini-role">${esc(therapist.role)}</div><div class="mini-meta"><span class="star">&#9733;</span> ${esc(therapist.rating)}</div><div class="mini-price">${esc(therapist.price)}</div><button type="button" class="mini-book db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">${esc(bookLabel)}</button></div>
//       </article>`;
//     }).join('');
//     if (endLink) {
//       endLink.hidden = false;
//       carousel.appendChild(endLink);
//     }
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderHomeTherapistStatus(message, isError = false) {
//     const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
//     if (!carousel) return;
//     const status = document.createElement('div');
//     status.className = `mt-therapists-status${isError ? ' mt-therapists-status-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     carousel.replaceChildren(status);
//     carousel.setAttribute('aria-busy', 'false');
//   }

//   function renderListingStatus(message, isError = false) {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const status = document.createElement('div');
//     status.className = `db-list-status${isError ? ' db-list-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     listEl.replaceChildren(status);
//     listEl.setAttribute('aria-busy', 'false');
//   }

//   function renderProfileStatus(message, isError = false) {
//     const loader = document.getElementById('dbProfileLoading');
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!loader || !profile) return;
//     profile.hidden = true;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//     const status = document.createElement('div');
//     status.className = `db-profile-status${isError ? ' db-profile-status-error' : ''}`;
//     status.setAttribute('role', isError ? 'alert' : 'status');
//     status.textContent = message;
//     loader.replaceChildren(status);
//     loader.hidden = false;
//   }

//   function revealProfilePage(profile) {
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = true;
//     profile.hidden = false;
//     profile.setAttribute('aria-busy', 'false');
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = false;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = true;
//   }

//   function listingCardHtml(therapist, index) {
//     const palette = CARD_PALETTES[index % CARD_PALETTES.length];
//     const tags = therapist.expertise.split(',').map(tag => tag.trim()).filter(Boolean)
//       .map(tag => `<span class="tag">${esc(tag)}</span>`).join('');
//     const mediaStyle = therapist.image_url
//       ? `background:url('${esc(therapist.image_url)}') center/cover no-repeat, linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`
//       : `background:linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`;
//     const meta = [
//       `<span class="star">&#9733;</span>${esc(therapist.rating)}`,
//       therapist.role ? `<span class="sep">&middot;</span> ${esc(therapist.role)}` : '',
//       therapist.experience ? `<span class="sep">&middot;</span> ${esc(therapist.experience)}` : ''
//     ].join(' ');
//     return `<article class="t-card" data-id="${esc(therapist.id)}" data-category="${esc(therapist.category)}" data-open="${esc(therapist.id)}">
//       <div class="media" style="${mediaStyle}">
//         ${therapist.image_url ? '' : `<div class="media-initials">${esc(initialsOf(therapist.name))}</div>`}
//         ${therapist.availability ? `<span class="slot-badge"><span class="dot"></span>Next: ${esc(therapist.availability)}</span>` : ''}
//       </div>
//       <div class="t-body">
//         <div class="name-row"><h2>${esc(therapist.name)}</h2><span class="verified" title="Verified">&#10003;</span></div>
//         <div class="meta-line">${meta}</div>
//         ${tags ? `<div class="tags-row">${tags}</div>` : ''}
//         ${therapist.bio ? `<p class="bio-line">${esc(therapist.bio)}</p>` : ''}
//        ${String(therapist.trust_line || '')
//   .split('|')
//   .map(line => line.trim())
//   .filter(Boolean)
//   .map(line => `
//     <div class="trust-line">
//       <span class="ic">&#10003;</span>
//       <span>${esc(line)}</span>
//     </div>
//   `)
//   .join('')}
//         ${therapist.sessions ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.sessions)}</div>` : ''}
//         ${therapist.switch_policy ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.switch_policy)}</div>` : ''}
//         <div class="price-cta-row">
//           <div class="price-line">
//             <span class="p-label">${esc(therapist.centre)}${therapist.duration ? ` &middot; ${esc(therapist.duration)}` : ''}</span>
//             <span class="p-value">${esc(therapist.price)}</span>
//           </div>
//           <div class="cta-buttons-row">
//             <a href="/pages/doctor-profile?id=${encodeURIComponent(therapist.id)}" class="consult-btn" data-consult="${esc(therapist.id)}">Free 15-min call</a>
//             <button type="button" class="book-btn db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">Book Session</button>
//           </div>
//         </div>
//       </div>
//     </article>`;
//   }

//   function renderListingCards() {
//     const listEl = document.getElementById('cardList');
//     if (!listEl) return;
//     const therapists = activeTherapists();
//     if (!therapists.length) return;
//     listEl.innerHTML = therapists.map((therapist, index) => listingCardHtml(therapist, index)).join('');
//     listEl.setAttribute('aria-busy', 'false');
//     updateDoctorCards();
//     filterDoctors();
//   }

//   function isoOf(day) {
//     return `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
//   }

//   function dateFromIso(iso) {
//     const match = stringValue(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
//     if (!match) return null;
//     const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
//     return Number.isNaN(date.getTime()) ? null : date;
//   }

//   function parseBooked(payload) {
//     const entries = Array.isArray(payload?.booked) ? payload.booked : [];
//     state.bookedMap = new Map();
//     state.pendingMap = new Map();
//     entries.forEach(entry => {
//       const docId = normalizeId(entry.doctor_id).replace(/\s+/g, '-');
//       const iso = stringValue(entry.date);
//       const time = normaliseSlotTime(entry.time);
//       if (!docId || !/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//       const key = `${docId}|${iso}`;
//       const pending = stringValue(entry.status).toLowerCase() === 'payment_pending';
//       const target = pending ? state.pendingMap : state.bookedMap;
//       if (!target.has(key)) target.set(key, new Set());
//       target.get(key).add(time);
//     });
//     state.localBooked = state.localBooked.filter(entry => !entry.expiresAt || Date.parse(entry.expiresAt) > Date.now());
//     state.localBooked.forEach(entry => {
//       const key = `${entry.doctorId}|${entry.date}`;
//       if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//       state.pendingMap.get(key).add(entry.time);
//     });
//   }

//   function activeDatePill() {
//     return document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill.active')
//       || document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill');
//   }

//   function modalSlots(iso = activeDatePill()?.dataset.iso || '') {
//     if (state.availabilityEnabled) {
//       return state.doctors.get(state.currentDoctorId)?.schedule?.[iso] || [];
//     }
//     const slots = state.modalDoctor?.time_slots;
//     return slots?.length ? slots : DEFAULT_TIME_SLOTS;
//   }

//   function markFullDatePills() {
//     document.querySelectorAll('#dbBookingModal .db-date-pill').forEach(pill => {
//       const slots = modalSlots(pill.dataset.iso);
//       const booked = state.bookedMap.get(`${state.currentDoctorId}|${pill.dataset.iso}`);
//       const isFull = slots.length > 0 && !!booked && slots.every(slot => booked.has(slot));
//       pill.classList.toggle('db-date-full', isFull);
//     });
//   }

//   function ensureDatePills(therapist) {
//     const row = document.querySelector('#dbBookingModal .db-date-picker-row');
//     if (!row) return;
//     const previousIso = activeDatePill()?.dataset.iso || '';
//     if (!state.loaded) {
//       setHiddenValue('dbBookingDate', '');
//       showLoading(row, 'Loading dates…');
//       return;
//     }

//     if (state.availabilityEnabled) {
//       const today = isoOf(new Date());
//       const schedule = state.doctors.get(state.currentDoctorId)?.schedule || {};
//       const dates = Object.keys(schedule)
//         .filter(iso => iso >= today && Array.isArray(schedule[iso]) && schedule[iso].length)
//         .sort();
//       if (!dates.length) {
//         setHiddenValue('dbBookingDate', '');
//         setHiddenValue('dbBookingTime', '');
//         renderMessage(row, 'No upcoming dates are available for this therapist.');
//         return;
//       }
//       row.innerHTML = dates.map(iso => {
//         const day = dateFromIso(iso);
//         const dayName = DAY_NAMES[day.getDay()];
//         const offset = Math.round((day.getTime() - dateFromIso(today).getTime()) / 86400000);
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         return `<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`;
//       }).join('');
//       markFullDatePills();
//       const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//       const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//       active?.classList.add('active');
//       setHiddenValue('dbBookingDate', active?.dataset.date || '');
//       return;
//     }

//     const build = useDayFilter => {
//       const pills = [];
//       const now = new Date();
//       for (let offset = 0; offset < 60 && pills.length < 30; offset++) {
//         const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
//         const dayName = DAY_NAMES[day.getDay()];
//         if (useDayFilter && therapist?.days && !therapist.days.includes(dayName)) continue;
//         const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
//         const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
//         const iso = isoOf(day);
//         pills.push(`<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`);
//       }
//       return pills;
//     };
//     let pills = build(true);
//     if (!pills.length) pills = build(false);
//     row.innerHTML = pills.join('');
//     markFullDatePills();
//     const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
//     const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingDate', active?.dataset.date || '');
//   }

//   function renderTimePills() {
//     const grid = document.querySelector('#dbBookingModal .db-time-grid');
//     if (!grid) return;
//     if (!state.loaded) {
//       setHiddenValue('dbBookingTime', '');
//       showLoading(grid);
//       return;
//     }
//     const previous = stringValue(document.getElementById('dbBookingTime')?.value);
//     const iso = activeDatePill()?.dataset.iso || '';
//     const slots = modalSlots(iso);
//     if (!iso || !slots.length) {
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(grid, iso ? 'No times are available on this date.' : 'Select an available date first.');
//       return;
//     }
//     const booked = state.bookedMap.get(`${state.currentDoctorId}|${iso}`);
//     const pending = state.pendingMap.get(`${state.currentDoctorId}|${iso}`);
//     grid.innerHTML = slots.map(slot => {
//       if (booked?.has(slot)) {
//         return `<div class="db-time-pill db-time-booked" aria-disabled="true">${esc(slot)}<span class="db-booked-tag">Booked</span></div>`;
//       }
//       if (pending?.has(slot)) {
//         return `<div class="db-time-pill db-time-pending" title="Reserved. Select only to resume your existing payment.">${esc(slot)}<span class="db-booked-tag">Payment pending</span></div>`;
//       }
//       return `<div class="db-time-pill">${esc(slot)}</div>`;
//     }).join('');
//     const active = Array.from(grid.querySelectorAll('.db-time-pill:not(.db-time-booked)'))
//       .find(pill => slotText(pill) === previous)
//       || grid.querySelector('.db-time-pill:not(.db-time-booked):not(.db-time-pending)');
//     active?.classList.add('active');
//     setHiddenValue('dbBookingTime', active ? slotText(active) : '');
//   }

//   const slotText = pill => pill?.querySelector('.db-booked-tag')
//     ? pill.textContent.replace(pill.querySelector('.db-booked-tag').textContent, '').trim()
//     : stringValue(pill?.textContent);

//   function safeUuid() {
//     if (window.crypto?.randomUUID) return window.crypto.randomUUID();
//     return `booking-${Date.now()}-${Math.random().toString(16).slice(2)}`;
//   }

//   function clearElement(element) {
//     if (element) element.replaceChildren();
//   }

//   function renderMessage(container, message, isError = false) {
//     if (!container) return;
//     clearElement(container);
//     const status = document.createElement('div');
//     status.className = `db-availability-message${isError ? ' db-availability-error' : ''}`;
//     status.setAttribute('role', 'status');
//     status.textContent = message;
//     container.appendChild(status);
//   }

//   function showLoading(container, message = 'Loading availability…') {
//     if (!container) return;
//     clearElement(container);
//     const wrapper = document.createElement('div');
//     wrapper.className = 'db-loading-spinner-wrap';
//     wrapper.setAttribute('role', 'status');
//     const spinner = document.createElement('div');
//     spinner.className = 'db-loading-spinner';
//     spinner.setAttribute('aria-hidden', 'true');
//     const label = document.createElement('span');
//     label.textContent = message;
//     wrapper.append(spinner, label);
//     container.appendChild(wrapper);
//   }

//   function normaliseSchedule(value) {
//     const schedule = {};
//     if (Array.isArray(value)) {
//       value.forEach(entry => {
//         const iso = stringValue(entry?.date);
//         const slots = Array.isArray(entry?.slots) ? entry.slots : [];
//         if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
//           schedule[iso] = [...new Set(slots.map(normaliseSlotTime).filter(Boolean))];
//         }
//       });
//       return schedule;
//     }
//     if (!value || typeof value !== 'object') return schedule;
//     Object.keys(value).forEach(iso => {
//       if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !Array.isArray(value[iso])) return;
//       schedule[iso] = [...new Set(value[iso].map(normaliseSlotTime).filter(Boolean))];
//     });
//     return schedule;
//   }

//   function normaliseDoctor(record) {
//     if (!record || typeof record !== 'object') return null;
//     const id = normalizeId(record.doctor_id || record.doctorId || record.handle || record.id);
//     if (!id) return null;
//     const schedule = normaliseSchedule(record.schedule || record.availability_by_date);
//     return {
//       ...record,
//       doctor_id: id,
//       next_slot: stringValue(record.next_slot || record.nextSlot),
//       dates: Array.isArray(record.dates || record.available_dates)
//         ? (record.dates || record.available_dates).map(stringValue).filter(Boolean)
//         : Object.keys(schedule),
//       schedule
//     };
//   }

//   function normalisePayload(payload) {
//     if (payload && payload.success === false) {
//       throw new Error(payload.message || 'The booking service rejected the availability request.');
//     }
//     const records = Array.isArray(payload) ? payload : payload?.doctors || payload?.data || payload?.availability || [];
//     const map = new Map();
//     records.forEach(item => {
//       const doc = normaliseDoctor(item);
//       if (doc) map.set(doc.doctor_id, doc);
//     });
//     return map;
//   }

//   async function fetchJson(url, options = {}) {
//     const controller = new AbortController();
//     const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
//     try {
//       const response = await fetch(url, { ...options, signal: controller.signal });
//       const text = await response.text();
//       let data = null;
//       try { data = JSON.parse(text); } catch (_) { }
//       if (!response.ok) {
//         const error = new Error(data?.message || `Request failed with HTTP status ${response.status}`);
//         error.code = data?.code || `HTTP_${response.status}`;
//         throw error;
//       }
//       if (data === null) {
//         const error = new Error('The booking service returned an invalid response. Check the latest Apps Script execution log.');
//         error.code = 'INVALID_JSON_RESPONSE';
//         throw error;
//       }
//       return data;
//     } finally {
//       window.clearTimeout(timeout);
//     }
//   }

//   function setHiddenValue(id, value) {
//     const input = document.getElementById(id);
//     if (input && typeof value !== 'undefined') input.value = value;
//   }

//   function updateDoctorCards() {
//     document.querySelectorAll('.t-card, .db-doctor-card, .mini-card').forEach(card => {
//       const id = normalizeId(card.dataset.id || card.dataset.open || card.dataset.therapistId);
//       const doctor = state.doctors.get(id);
//       if (!doctor) return;
//       const badge = card.querySelector('.slot-badge, .db-next-slot, .mini-slot');
//       if (doctor.next_slot) {
//         if (badge) {
//           badge.style.display = '';
//           const dot = badge.querySelector('.dot, .db-status-dot');
//           if (dot) {
//             badge.innerHTML = `<span class="dot"></span>Next: ${esc(doctor.next_slot)}`;
//           } else {
//             badge.textContent = `Next: ${doctor.next_slot}`;
//           }
//         }
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     });

//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     const profileId = normalizeId(profile?.dataset.doctorId);
//     const profileDoctor = state.doctors.get(profileId);
//     if (profile && profileDoctor) {
//       const badge = profile.querySelector('.slot-badge');
//       const value = badge?.querySelector('[data-bind="next_slot"]');
//       if (profileDoctor.next_slot) {
//         if (value) value.textContent = profileDoctor.next_slot;
//         if (badge) badge.style.display = '';
//       } else if (state.availabilityEnabled && badge) {
//         badge.style.display = 'none';
//       }
//     }
//   }

//   async function loadAvailability() {
//     const url = apiUrl();
//     if (!url) return null;
//     if (state.loadingPromise) return state.loadingPromise;
//     const separator = url.includes('?') ? '&' : '?';
//     state.loadingPromise = fetchJson(`${url}${separator}action=availability&_=${Date.now()}`, {
//       method: 'GET',
//       cache: 'no-store',
//       credentials: 'omit',
//       headers: { Accept: 'application/json' }
//     }).then(payload => {
//       if (!Array.isArray(payload?.booked)) throw new Error('Availability response is missing booked slots.');
//       state.doctors = normalisePayload(payload);
//       state.availabilityEnabled = payload?.availability_enabled === true;
//       state.loaded = true;
//       parseBooked(payload);
//       updateDoctorCards();
//       if (document.getElementById('dbBookingModal')?.classList.contains('active')) {
//         ensureDatePills(state.modalDoctor);
//         renderTimePills();
//       }
//       return payload;
//     }).catch(error => {
//       state.loaded = false;
//       setHiddenValue('dbBookingDate', '');
//       setHiddenValue('dbBookingTime', '');
//       renderMessage(document.querySelector('#dbBookingModal .db-date-picker-row'), 'Available dates could not be checked. Please try again.', true);
//       renderMessage(document.getElementById('dbTimeGrid'), 'Availability could not be checked. Please reopen the booking form to retry.', true);
//       console.warn('[DoctorBooking] Note on live availability:', error);
//     }).finally(() => { state.loadingPromise = null; });
//     return state.loadingPromise;
//   }

//   function initAutoRefresh() {
//     const refreshSheetData = () => {
//       loadTherapists().then(renderProfilePage).catch(() => { });
//       loadAvailability().catch(() => { });
//     };
//     state.refreshTimer = window.setInterval(() => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     }, REFRESH_INTERVAL_MS);
//     document.addEventListener('visibilitychange', () => {
//       if (document.visibilityState === 'visible') refreshSheetData();
//     });
//   }

//   /* ---------- Category Filter Tabs ---------- */
//   function initCategoryTabs() {
//     document.querySelectorAll('.db-tab-btn').forEach(tab => {
//       tab.addEventListener('click', () => {
//         document.querySelectorAll('.db-tab-btn').forEach(item => item.classList.remove('active'));
//         tab.classList.add('active');
//         filterDoctors();
//       });
//     });
//   }

//   function filterDoctors() {
//     const category = document.querySelector('.db-tab-btn.active')?.dataset.category || 'all';
//     document.querySelectorAll('.t-card, .db-doctor-card').forEach(card => {
//       const cardCat = stringValue(card.dataset.category).toLowerCase();
//       const visible = (category === 'all' || cardCat.includes(category.toLowerCase()));
//       card.style.display = visible ? '' : 'none';
//     });
//   }

//   /* ---------- Selection Events (Mode / Date / Time) ---------- */
//   function initSelectionEvents() {
//     document.addEventListener('click', event => {
//       const modeButton = event.target.closest('.db-mode-btn');
//       if (modeButton) {
//         const selector = modeButton.closest('.db-mode-selector');
//         selector?.querySelectorAll('.db-mode-btn').forEach(button => {
//           button.classList.toggle('active', button === modeButton);
//         });
//         const mode = normalizeMode(modeButton.dataset.mode || modeButton.textContent);
//         setHiddenValue('dbConsultationMode', mode);
//         return;
//       }

//       const datePill = event.target.closest('.db-date-pill');
//       if (datePill) {
//         if (datePill.classList.contains('db-date-full')) return;
//         const row = datePill.closest('.db-date-picker-row');
//         row?.querySelectorAll('.db-date-pill').forEach(pill => pill.classList.remove('active'));
//         datePill.classList.add('active');
//         setHiddenValue('dbBookingDate', datePill.dataset.date || '');
//         renderTimePills();
//         return;
//       }

//       const timePill = event.target.closest('.db-time-pill');
//       if (timePill) {
//         if (timePill.classList.contains('db-time-booked')) return;
//         const grid = timePill.closest('.db-time-grid');
//         grid?.querySelectorAll('.db-time-pill').forEach(pill => pill.classList.remove('active'));
//         timePill.classList.add('active');
//         setHiddenValue('dbBookingTime', slotText(timePill));
//         if (timePill.classList.contains('db-time-pending')) {
//           window.alert('This slot is reserved pending payment. Continue only to resume your booking using the same verified WhatsApp number.');
//         }
//       }
//     });
//   }

//   /* ---------- Booking Modal Functions ---------- */
//   function openBookingModal(button) {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     const card = button.closest('.t-card, .profile-page, #profileContent');
//     const id = normalizeId(button.dataset.docId || card?.dataset.id || card?.dataset.open || state.currentDoctorId || 'palak-chhabra');
//     state.currentDoctorId = id;
//     state.bookingRequestId = '';
//     state.otpChallengeId = '';
//     state.otpVerificationToken = '';
//     state.currentCheckout = null;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;

//     const name = stringValue(button.dataset.docName)
//       || stringValue(card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent)
//       || 'Therapist';
//     const fee = stringValue(button.dataset.docFee)
//       || stringValue(card?.querySelector('.price-line .p-value, [data-bind="fee"]')?.textContent)
//       || '₹2000';

//     const therapist = state.therapists.get(id);
//     const fallbackDoc = state.profileFallback?.[id];
//     let resolvedName = name;
//     let resolvedFee = fee;
//     if (therapist) {
//       resolvedName = therapist.name || name;
//       resolvedFee = therapistFee(therapist) || fee;
//     } else if (fallbackDoc) {
//       resolvedName = fallbackDoc.name || name;
//       resolvedFee = fallbackDoc.fee || fee;
//     }
//     state.modalDoctor = therapist || null;

//     const nameElement = document.getElementById('dbModalDocName');
//     const feeElement = document.getElementById('dbModalDocFee');
//     if (nameElement) nameElement.textContent = resolvedName;
//     if (feeElement) feeElement.textContent = resolvedFee;

//     setHiddenValue('dbDoctorId', id);
//     setHiddenValue('dbDoctorName', resolvedName);
//     setHiddenValue('dbDoctorFee', resolvedFee);

//     setHiddenValue('dbBookingTime', '');
//     ensureDatePills(therapist);
//     renderTimePills();

//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     if (paymentButtonContainer) {
//       paymentButtonContainer.style.display = 'none';
//       paymentButtonContainer.replaceChildren();
//     }

//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'block';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'none';
//     const otpInput = document.getElementById('dbOtpCode');
//     if (otpInput) otpInput.value = '';
//     const otpStatus = document.getElementById('dbOtpStatus');
//     if (otpStatus) otpStatus.textContent = '';

//     modal.classList.add('active');
//     loadAvailability().catch(() => {});
//   }

//   const closeBookingModal = () => {
//     document.getElementById('dbBookingModal')?.classList.remove('active');
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//   };

//   function markSlotBookedLocally(iso, time, expiresAt) {
//     if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
//     state.localBooked.push({ doctorId: state.currentDoctorId, date: iso, time, expiresAt });
//     const key = `${state.currentDoctorId}|${iso}`;
//     if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
//     state.pendingMap.get(key).add(time);
//     markFullDatePills();
//     renderTimePills();
//     loadAvailability().catch(() => { });
//   }

//   function loadRazorpayCheckout() {
//     if (window.Razorpay) return Promise.resolve();
//     if (state.checkoutPromise) return state.checkoutPromise;
//     state.checkoutPromise = new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.async = true;
//       script.onload = () => resolve();
//       script.onerror = () => reject(new Error('Razorpay Checkout could not be loaded.'));
//       document.head.appendChild(script);
//     }).finally(() => { state.checkoutPromise = null; });
//     return state.checkoutPromise;
//   }

//   async function verifyRazorpayPayment(response) {
//     let lastResult = null;
//     for (let attempt = 0; attempt < 3; attempt++) {
//       if (attempt > 0) await new Promise(resolve => window.setTimeout(resolve, 1500));
//       lastResult = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_payment',
//           request_id: state.bookingRequestId,
//           razorpay_payment_id: response.razorpay_payment_id,
//           razorpay_order_id: response.razorpay_order_id,
//           razorpay_signature: response.razorpay_signature
//         })
//       });
//       if (lastResult?.success === true && stringValue(lastResult?.status).toLowerCase() === 'confirmed') return lastResult;
//       if (lastResult?.code !== 'PAYMENT_NOT_CAPTURED') break;
//     }
//     const error = new Error(lastResult?.message || 'Payment verification is still pending.');
//     error.code = lastResult?.code || 'PAYMENT_VERIFICATION_FAILED';
//     throw error;
//   }

//   async function startRazorpayCheckout(checkout) {
//     if (!checkout?.key_id || !checkout?.order_id || !checkout?.amount) return;
//     try {
//       await loadRazorpayCheckout();
//       const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//       const patientEmail = stringValue(document.getElementById('dbPatientEmail')?.value);
//       const rawPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//       const phoneDigits = rawPhone.replace(/\D/g, '');
//       const patientPhone = rawPhone.startsWith('+')
//         ? `+${phoneDigits}`
//         : phoneDigits.length === 10
//           ? `+91${phoneDigits}`
//           : `+${phoneDigits}`;
//       const razorpay = new window.Razorpay({
//         key: checkout.key_id,
//         order_id: checkout.order_id,
//         amount: checkout.amount,
//         currency: checkout.currency || 'INR',
//         name: 'MushinTalks',
//         description: `Therapy session with ${stringValue(document.getElementById('dbDoctorName')?.value)}`,
//         prefill: {
//           name: patientName,
//           email: patientEmail,
//           contact: patientPhone
//         },
//         readonly: { name: true, contact: true, email: Boolean(patientEmail) },
//         hidden: { contact: true, email: Boolean(patientEmail) },
//         theme: { color: '#786c8a' },
//         handler: async response => {
//           const successTitle = document.getElementById('dbSuccessTitle');
//           const successText = document.getElementById('dbSuccessText');
//           if (successTitle) successTitle.textContent = 'Verifying Payment…';
//           if (successText) successText.textContent = 'Please wait while we securely confirm your payment.';
//           try {
//             const verified = await verifyRazorpayPayment(response);
//             state.bookingRequestId = '';
//             state.currentCheckout = null;
//             showBookingSuccess(verified.payment_status, verified.status, null);
//           } catch (error) {
//             showBookingSuccess('pending', 'payment_pending', checkout);
//             window.alert(error?.message || 'Payment verification is pending. Please contact us with your payment ID.');
//           }
//         }
//       });
//       razorpay.on('payment.failed', response => {
//         const description = response?.error?.description || 'Payment failed. You can retry using the same reserved slot.';
//         window.alert(description);
//       });
//       razorpay.open();
//     } catch (error) {
//       window.alert(error?.message || 'Payment could not be opened. Please try again.');
//     }
//   }

//   function renderCheckoutButton(container, checkout) {
//     container.replaceChildren();
//     const button = document.createElement('button');
//     button.type = 'button';
//     button.className = 'db-btn-primary db-pay-now-btn';
//     button.textContent = 'Pay Now →';
//     button.addEventListener('click', () => startRazorpayCheckout(checkout));
//     container.appendChild(button);
//   }

//   function showBookingSuccess(paymentStatus, bookingStatus, checkout) {
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     state.otpResendTimer = null;
//     const stepOne = document.getElementById('dbModalStep1');
//     const otpStep = document.getElementById('dbModalStepOtp');
//     const success = document.getElementById('dbModalStepSuccess');
//     if (stepOne) stepOne.style.display = 'none';
//     if (otpStep) otpStep.style.display = 'none';
//     if (success) success.style.display = 'block';
//     const normalizedPaymentStatus = stringValue(paymentStatus).toLowerCase();
//     const normalizedBookingStatus = stringValue(bookingStatus).toLowerCase();
//     const paymentConfirmed = ['paid', 'captured', 'success'].includes(normalizedPaymentStatus)
//       || normalizedBookingStatus === 'confirmed';
//     const successTitle = document.getElementById('dbSuccessTitle');
//     const successText = document.getElementById('dbSuccessText');
//     if (successTitle) successTitle.textContent = paymentConfirmed ? 'Booking Confirmed!' : 'Slot Reserved';
//     if (successText) {
//       successText.textContent = paymentConfirmed
//         ? 'Your payment is confirmed and your consultation has been booked.'
//         : 'Your slot is reserved pending payment. Complete the payment below to confirm your booking.';
//     }
//     const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
//     const resolvedCheckout = checkout?.order_id ? checkout : state.currentCheckout;
//     if (paymentButtonContainer) {
//       if (!paymentConfirmed && resolvedCheckout) {
//         state.currentCheckout = resolvedCheckout;
//         paymentButtonContainer.style.display = 'block';
//         renderCheckoutButton(paymentButtonContainer, resolvedCheckout);
//       } else {
//         paymentButtonContainer.style.display = 'none';
//         paymentButtonContainer.replaceChildren();
//         if (!paymentConfirmed && successText) {
//           successText.textContent = 'The payment session could not be prepared. Close this window and retry the same slot with the same phone number.';
//         }
//       }
//     }
//   }

//   function setOtpStatus(message, isError = false) {
//     const status = document.getElementById('dbOtpStatus');
//     if (!status) return;
//     status.textContent = message || '';
//     status.classList.toggle('db-otp-status-error', Boolean(isError));
//   }

//   function validateOtpRequestForm() {
//     if (!state.loaded) {
//       window.alert('Please wait until availability has been checked.');
//       return null;
//     }
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return null;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');
//     const localDigits = phoneDigits.length === 12 && phoneDigits.startsWith('91')
//       ? phoneDigits.slice(2)
//       : phoneDigits.length === 11 && phoneDigits.startsWith('0')
//         ? phoneDigits.slice(1)
//         : phoneDigits;
//     if (!patientName || !/^[6-9]\d{9}$/.test(localDigits)) {
//       window.alert('Please enter your full name and a valid 10-digit Indian WhatsApp number.');
//       return null;
//     }
//     if (!stringValue(document.getElementById('dbBookingTime')?.value)) {
//       window.alert('Please select an available time slot first.');
//       return null;
//     }
//     return { patientName, patientPhone };
//   }

//   function startOtpResendCountdown(seconds) {
//     const button = document.getElementById('dbOtpResendBtn');
//     if (!button) return;
//     if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//     let remaining = Math.max(1, Number(seconds) || 60);
//     const render = () => {
//       button.disabled = remaining > 0;
//       button.textContent = remaining > 0 ? `Resend in ${remaining}s` : 'Resend code';
//     };
//     render();
//     state.otpResendTimer = window.setInterval(() => {
//       remaining -= 1;
//       render();
//       if (remaining <= 0) {
//         window.clearInterval(state.otpResendTimer);
//         state.otpResendTimer = null;
//       }
//     }, 1000);
//   }

//   async function requestBookingOtp(button) {
//     const details = validateOtpRequestForm();
//     if (!details) return;
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'SENDING CODE…';
//     setOtpStatus('');
//     let result = null;
//     try {
//       result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({ action: 'send_otp', patient_phone: details.patientPhone })
//       });
//       if (result?.success !== true || !result?.challenge_id) {
//         const unknownOtpAction = result?.code === 'UNKNOWN_ACTION' ||
//           /^Unknown action:\s*send_otp$/i.test(stringValue(result?.message));
//         const error = new Error(unknownOtpAction
//           ? 'The booking service is using an older Apps Script deployment. Publish the latest Code.gs as a new version of the existing web app deployment, then try again.'
//           : result?.message || 'The verification code could not be sent.');
//         error.code = result?.code || 'OTP_SEND_FAILED';
//         throw error;
//       }
//       state.otpChallengeId = stringValue(result.challenge_id);
//       state.otpVerificationToken = '';
//       const stepOne = document.getElementById('dbModalStep1');
//       const otpStep = document.getElementById('dbModalStepOtp');
//       if (stepOne) stepOne.style.display = 'none';
//       if (otpStep) otpStep.style.display = 'block';
//       const masked = document.getElementById('dbOtpMaskedPhone');
//       if (masked) masked.textContent = stringValue(result.masked_phone) || 'your WhatsApp number';
//       const input = document.getElementById('dbOtpCode');
//       if (input) {
//         input.value = '';
//         input.focus();
//       }
//       setOtpStatus('Code sent. It expires in 5 minutes.');
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP could not be sent.', error);
//       setOtpStatus(error?.message || 'The verification code could not be sent.', true);
//       window.alert(error?.message || 'The verification code could not be sent.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//     if (result?.success === true) startOtpResendCountdown(result.retry_after);
//   }

//   async function verifyBookingOtp(button) {
//     const otp = stringValue(document.getElementById('dbOtpCode')?.value).replace(/\D/g, '');
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     if (!state.otpChallengeId || !/^\d{6}$/.test(otp)) {
//       setOtpStatus('Enter the 6-digit code sent on WhatsApp.', true);
//       return;
//     }
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'VERIFYING…';
//     setOtpStatus('Verifying code…');
//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify({
//           action: 'verify_otp',
//           patient_phone: patientPhone,
//           challenge_id: state.otpChallengeId,
//           otp
//         })
//       });
//       if (result?.success !== true || !result?.verification_token) {
//         const error = new Error(result?.message || 'The verification code is incorrect.');
//         error.code = result?.code || 'OTP_INCORRECT';
//         throw error;
//       }
//       state.otpVerificationToken = stringValue(result.verification_token);
//       setOtpStatus('WhatsApp number verified. Reserving your slot…');
//       await submitBooking(button);
//     } catch (error) {
//       console.error('[DoctorBooking] WhatsApp OTP verification failed.', error);
//       setOtpStatus(error?.message || 'The verification code could not be verified.', true);
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   async function submitBooking(button) {
//     const form = document.getElementById('dbBookingForm');
//     if (form && !form.reportValidity()) return;
//     const patientName = stringValue(document.getElementById('dbPatientName')?.value);
//     const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
//     const phoneDigits = patientPhone.replace(/\D/g, '');

//     if (!patientName || phoneDigits.length < 7 || phoneDigits.length > 15) {
//       window.alert('Please enter your full name and a valid phone number.');
//       return;
//     }

//     const mode = stringValue(document.getElementById('dbConsultationMode')?.value) || 'Online Video';
//     const datePill = activeDatePill();
//     const date = datePill?.dataset.iso || stringValue(document.getElementById('dbBookingDate')?.value) || 'Today';
//     const time = stringValue(document.getElementById('dbBookingTime')?.value);
//     if (!time) {
//       window.alert('No slots are left on this date — please pick another day.');
//       return;
//     }

//     if (!state.bookingRequestId) state.bookingRequestId = safeUuid();
//     const payload = {
//       action: 'book',
//       request_id: state.bookingRequestId,
//       doctor_id: state.currentDoctorId,
//       doctor_name: stringValue(document.getElementById('dbDoctorName')?.value),
//       doctor_fee: stringValue(document.getElementById('dbDoctorFee')?.value),
//       patient_name: patientName,
//       patient_phone: patientPhone,
//       patient_email: stringValue(document.getElementById('dbPatientEmail')?.value),
//       otp_verification_token: state.otpVerificationToken,
//       mode: mode,
//       date: date,
//       date_label: stringValue(datePill?.dataset.date),
//       time: time,
//       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       source: 'shopify-storefront'
//     };

//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'CONFIRMING…';

//     try {
//       const result = await fetchJson(apiUrl(), {
//         method: 'POST',
//         credentials: 'omit',
//         cache: 'no-store',
//         headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const resultStatus = stringValue(result?.status || 'booked').toLowerCase();
//       const confirmed = result?.success === true && ['booked', 'confirmed', 'payment_pending', 'reserved'].includes(resultStatus);
//       if (!confirmed) {
//         const bookingError = new Error(result?.message || 'The slot could not be booked.');
//         bookingError.code = result?.code || 'BOOKING_REJECTED';
//         throw bookingError;
//       }
//       showBookingSuccess(
//         result?.payment_status,
//         result?.status,
//         result?.checkout
//       );
//       state.bookingRequestId = stringValue(result?.request_id) || state.bookingRequestId;
//       markSlotBookedLocally(date, time, result?.payment_expires_at);
//     } catch (error) {
//       console.error('[DoctorBooking] Booking was not confirmed.', error);
//       if (error?.code === 'SLOT_ALREADY_BOOKED') state.bookingRequestId = '';
//       if (['OTP_REQUIRED', 'OTP_EXPIRED', 'OTP_INVALID', 'OTP_ALREADY_USED'].includes(error?.code)) {
//         state.otpVerificationToken = '';
//         setOtpStatus(error?.message || 'Verify your WhatsApp number again.', true);
//         const otpStep = document.getElementById('dbModalStepOtp');
//         if (otpStep) otpStep.style.display = 'block';
//       }
//       await loadAvailability().catch(() => { });
//       window.alert(error?.message || 'The booking could not be confirmed. Please try again.');
//     } finally {
//       button.disabled = false;
//       button.textContent = originalText;
//     }
//   }

//   function initBookingModal() {
//     const modal = document.getElementById('dbBookingModal');
//     if (!modal) return;
//     document.addEventListener('click', event => {
//       const bookButton = event.target.closest('.book-btn, .buy-btn, .db-btn-book');
//       if (bookButton) {
//         event.preventDefault();
//         event.stopPropagation();
//         openBookingModal(bookButton);
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.closest('.db-modal-close, .db-modal-cancel')) closeBookingModal();
//     });

//     document.addEventListener('keydown', event => {
//       if (event.key === 'Escape' && modal.classList.contains('active')) closeBookingModal();
//     });

//     modal.querySelector('.db-date-prev')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: -160, behavior: 'smooth' });
//     });
//     modal.querySelector('.db-date-next')?.addEventListener('click', () => {
//       modal.querySelector('.db-date-picker-row')?.scrollBy({ left: 160, behavior: 'smooth' });
//     });

//     document.getElementById('dbConfirmBookingBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbVerifyOtpBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       verifyBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpResendBtn')?.addEventListener('click', event => {
//       event.preventDefault();
//       requestBookingOtp(event.currentTarget);
//     });
//     document.getElementById('dbOtpBackBtn')?.addEventListener('click', () => {
//       if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
//       state.otpResendTimer = null;
//       state.otpChallengeId = '';
//       state.otpVerificationToken = '';
//       const otpStep = document.getElementById('dbModalStepOtp');
//       const stepOne = document.getElementById('dbModalStep1');
//       if (otpStep) otpStep.style.display = 'none';
//       if (stepOne) stepOne.style.display = 'block';
//     });
//     document.getElementById('dbOtpCode')?.addEventListener('keydown', event => {
//       if (event.key === 'Enter') {
//         event.preventDefault();
//         const verifyButton = document.getElementById('dbVerifyOtpBtn');
//         if (verifyButton && !verifyButton.disabled) verifyButton.click();
//       }
//     });
//   }

//   /* ---------- Video Modal ---------- */
//   function initVideoModal() {
//     const modal = document.getElementById('videoModal');
//     const box = document.getElementById('videoBox');
//     if (!modal || !box) return;

//     document.addEventListener('click', event => {
//       const playBtn = event.target.closest('.play-btn, [data-play]');
//       if (playBtn) {
//         event.preventDefault();
//         event.stopPropagation();
//         const card = playBtn.closest('.t-card, .profile-page, #profileContent');
//         const docName = card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent?.trim() || 'this therapist';
//         box.innerHTML = `
//           <div class="vb-fill">A short intro from ${docName} would play here &mdash; 20&ndash;30 seconds, just enough to get a feel for them before you book.</div>
//           <button class="vb-close" id="videoClose">&times;</button>
//         `;
//         modal.classList.add('open');
//         document.getElementById('videoClose')?.addEventListener('click', () => modal.classList.remove('open'));
//       }
//     });

//     modal.addEventListener('click', event => {
//       if (event.target === modal || event.target.id === 'videoClose') {
//         modal.classList.remove('open');
//       }
//     });
//   }

//   /* ---------- FAQ Accordion ---------- */
//   function initFaqAccordion() {
//     document.addEventListener('click', event => {
//       const faqQ = event.target.closest('.p-faq-q');
//       if (faqQ) {
//         event.preventDefault();
//         const item = faqQ.closest('.p-faq-item');
//         if (item) item.classList.toggle('open');
//       }
//     });
//   }

//   /* ---------- Card Navigation to Profile ---------- */
//   function initCardNavigation() {
//     document.addEventListener('click', event => {
//       const card = event.target.closest('.t-card');
//       if (!card) return;
//       if (event.target.closest('.play-btn, .book-btn, .consult-btn, .db-btn-book, a, button')) return;
//       const docId = card.dataset.open || card.dataset.id;
//       if (docId) {
//         window.location.href = `/pages/doctor-profile?id=${encodeURIComponent(docId)}`;
//       }
//     });
//   }

//   /* ---------- Profile Page Data (Shopify Metafields + Google Sheet) ---------- */
//   function paletteForId(id) {
//     const hash = Array.from(normalizeId(id)).reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 997, 7);
//     return CARD_PALETTES[hash % CARD_PALETTES.length];
//   }

//   function splitList(text) {
//     if (Array.isArray(text)) return text.map(item => stringValue(item)).filter(Boolean);
//     return stringValue(text).split(',').map(item => item.trim()).filter(Boolean);
//   }

//   function normaliseFaqs(value) {
//     return (Array.isArray(value) ? value : []).map(entry => {
//       if (Array.isArray(entry)) return [stringValue(entry[0]), stringValue(entry[1])];
//       if (entry && typeof entry === 'object') return [stringValue(entry.question ?? entry.q), stringValue(entry.answer ?? entry.a)];
//       return ['', ''];
//     }).filter(pair => pair[0] || pair[1]);
//   }

//   function therapistProfile(therapist, palette) {
//     if (!therapist) return null;
//     const data = {
//       name: stringValue(therapist.name),
//       title: stringValue(therapist.role || therapist.title),
//       experience: stringValue(therapist.experience),
//       rating: stringValue(therapist.rating),
//       fee: stringValue(therapist.price || therapist.fee),
//       modes: stringValue(therapist.centre || therapist.modes),
//       duration: stringValue(therapist.duration),
//       speaks: stringValue(therapist.languages || therapist.speaks),
//       initials: initialsOf(therapist.name),
//       next_slot: stringValue(therapist.availability || therapist.next_slot),
//       bio: stringValue(therapist.bio),
//       about: stringValue(therapist.about),
//       how_i_work: stringValue(therapist.how_i_work),
//       sessions: stringValue(therapist.sessions),
//       switch_policy: stringValue(therapist.switch_policy),
//       image_url: safeUrl(therapist.image_url)
//     };
//     const expertise = splitList(therapist.expertise);
//     const helpTags = splitList(therapist.help_tags);
//     const faqs = normaliseFaqs(therapist.faqs);
//     if (expertise.length) data.expertise = expertise;
//     if (helpTags.length) data.help_tags = helpTags;
//     if (faqs.length) data.faqs = faqs;
//     if (palette) data.palette = palette;
//     Object.keys(data).forEach(key => {
//       if (data[key] === '' || data[key] === null || typeof data[key] === 'undefined') {
//         delete data[key];
//       }
//     });
//     return data;
//   }

//   function findTherapistForId(id) {
//     if (!id) return null;
//     const direct = state.therapists.get(id);
//     if (direct) return direct;
//     const fallback = state.profileFallback?.[id];
//     if (!fallback) return null;
//     return state.therapists.get(normalizeId(fallback.name).replace(/\s+/g, '-')) || null;
//   }

//   function applyProfileData(profile, doctor) {
//     if (!profile || !doctor) return;
//     const root = profile.closest('.db-page-wrapper') || profile;

//     ['title', 'experience', 'fee', 'rating', 'speaks', 'about', 'modes', 'duration', 'sessions', 'how_i_work', 'initials', 'next_slot', 'switch_policy'].forEach(field => {
//       root.querySelectorAll(`[data-bind="${field}"]`).forEach(element => {
//         if (doctor[field]) element.textContent = doctor[field];
//       });
//     });

//     root.querySelectorAll('[data-bind="name"]:not(.db-btn-book)').forEach(element => {
//       if (doctor.name) element.textContent = doctor.name;
//     });

//     const slotBadge = root.querySelector('.slot-badge');
//     if (slotBadge) slotBadge.style.display = doctor.next_slot ? '' : 'none';

//     const pMedia = document.getElementById('pMedia');
//     if (pMedia) {
//       const initials = pMedia.querySelector('.media-initials');
//       if (doctor.image_url) {
//         pMedia.style.background = `url("${doctor.image_url.replace(/["'()]/g, '')}") center/cover no-repeat`;
//         if (initials) initials.style.display = 'none';
//       } else if (Array.isArray(doctor.palette)) {
//         pMedia.style.background = `linear-gradient(150deg, ${doctor.palette[0]}, ${doctor.palette[1]} 120%)`;
//         if (initials) initials.style.display = '';
//       }
//     }

//     const tags = root.querySelector('[data-bind="expertise-tags"]');
//     if (tags && Array.isArray(doctor.expertise)) {
//       clearElement(tags);
//       doctor.expertise.forEach(expertise => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = expertise;
//         tags.appendChild(tag);
//       });
//     }

//     const helpTags = root.querySelector('[data-bind="help_tags"]');
//     if (helpTags && Array.isArray(doctor.help_tags)) {
//       clearElement(helpTags);
//       doctor.help_tags.forEach(htag => {
//         const tag = document.createElement('span');
//         tag.className = 'tag';
//         tag.textContent = htag;
//         helpTags.appendChild(tag);
//       });
//     }

//     const faqsContainer = document.getElementById('pFAQs');
//     if (faqsContainer && Array.isArray(doctor.faqs)) {
//       clearElement(faqsContainer);
//       doctor.faqs.forEach(([question, answer], index) => {
//         const item = document.createElement('div');
//         item.className = `p-faq-item${index === 0 ? ' open' : ''}`;
//         item.innerHTML = `
//           <button type="button" class="p-faq-q">
//             <span>${esc(question)}</span>
//             <span class="plus">+</span>
//           </button>
//           <div class="p-faq-a">
//             <p>${esc(answer)}</p>
//           </div>
//         `;
//         faqsContainer.appendChild(item);
//       });
//     }
//   }

//   function updateProfileButtons(profile, id, doctor) {
//     const root = profile.closest('.db-page-wrapper') || profile;
//     const displayedName = stringValue(root.querySelector('[data-bind="name"]')?.textContent) || doctor.name || 'Therapist';
//     const price = stringValue(root.querySelector('.p-value[data-bind="fee"]')?.textContent) || doctor.fee || '₹2000';
//     const displayedFee = doctor.duration && !price.includes(doctor.duration) ? `${price} for ${doctor.duration}` : price;

//     root.querySelectorAll('.db-btn-book, .buy-btn, .consult-btn').forEach(button => {
//       button.dataset.docId = id;
//       button.dataset.docName = displayedName;
//       const isFreeCall = button.classList.contains('consult-btn') || /^free\b/i.test(stringValue(button.textContent));
//       if (!isFreeCall) {
//         button.dataset.docFee = displayedFee;
//       }
//     });
//   }

//   function mergeProfileData(sheetDoctor, fallbackDoctor) {
//     const merged = Object.assign({}, sheetDoctor || {}, fallbackDoctor || {});
//     if (sheetDoctor?.fee) merged.fee = sheetDoctor.fee;
//     if (sheetDoctor?.duration) merged.duration = sheetDoctor.duration;
//     return merged;
//   }

//   function renderProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const requested = normalizeId(profile.dataset.doctorId);
//     const therapist = findTherapistForId(requested);
//     const fallbackDoctor = state.profileFallback?.[requested] || null;

//     // Do not reveal a hard-coded/Shopify-only profile. The Sheet record must
//     // resolve first so visitors never see stale data flash before replacement.
//     if (!therapist) {
//       renderProfileStatus('This therapist was not found in the Google Sheet.', true);
//       return;
//     }

//     const sheetDoctor = therapistProfile(therapist, paletteForId(therapist.id));
//     // Shopify may supply richer profile copy, but the Sheet is the source of
//     // truth for live commercial fields. Without these explicit overrides, the
//     // hard-coded fallback fee (usually ₹2000) masks every Sheet price update.
//     const doctor = mergeProfileData(sheetDoctor, fallbackDoctor);
//     if (sheetDoctor?.faqs?.length && !fallbackDoctor?.faqs?.length) {
//       doctor.faqs = sheetDoctor.faqs;
//     }
//     if (sheetDoctor?.next_slot && !fallbackDoctor?.next_slot) {
//       doctor.next_slot = sheetDoctor.next_slot;
//     }

//     if (state.loaded && state.availabilityEnabled) {
//       doctor.next_slot = state.doctors.get(therapist.id)?.next_slot || '';
//     }

//     applyProfileData(profile, doctor);

//     const id = therapist?.id || requested;
//     profile.dataset.doctorId = id;
//     updateProfileButtons(profile, id, doctor);
//     revealProfilePage(profile);
//   }

//   /* ---------- Profile Page Initialization ---------- */
//   function initProfilePage() {
//     const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
//     if (!profile) return;
//     const queryId = new URLSearchParams(window.location.search).get('id')
//       || new URLSearchParams(window.location.search).get('doctor')
//       || new URLSearchParams(window.location.search).get('handle');

//    const profileData = {
//   "palak-chhabra": {
//     "name": "Palak Chhabra",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "PC",
//     "expertise": ["Emotional concerns", "Life transitions", "Grief and loss", "Self esteem"],
//     "help_tags": ["Relationship concerns", "Self and body image", "Burnout", "Confidence and growth"],
//     "bio": "Helping adults navigate their feelings and finding their way through life’s tough moments.",
//     "about": "Trauma-informed, queer-affirmative Counselling Psychologist supporting adults through emotions and transitions, with an M.A. in Lifespan Counselling, B.A. in Psychology & Philosophy, and a Diploma in Narrative Therapy.",
//     "how_i_work": "Warm, collaborative, non-pathologising sessions without having the pressure to figure it out. We explore your story together, your context, the meaning you make of your experiences and a range of emotions with empathy and understanding.",
//     "faqs": [
//       ["I'm part of the LGBTQ+ community. Is your practice queer-affirmative?", "Yes, absolutely. I work from a queer-affirmative and trauma-informed lens, and my practice is grounded in creating a safe, inclusive, non-judgmental space where you can come as you are without labels or the pressure to have everything figured out. I work in both English and Hindi."],
//       ["I don't know exactly what's wrong I just feel stuck or disconnected. Can I still come?", "Yes. You don't need to have a clear problem or everything figured out before you start. Many people come feeling stuck, lost, or disconnected from themselves, and we can explore that together at your pace, without forcing a diagnosis or a fixed way of working."],
//       ["Will I have homework or need to do things between sessions?", "Only if it feels useful to you. I may offer reflections, questions, or exercises between sessions when they seem helpful, but I don't believe therapy needs to be done perfectly curiosity, honesty, and engagement matter far more to me than getting everything \"right.\""],
//       ["Can I disagree with you or change what we talk about?", "Absolutely, in fact, I encourage it. You can call me by my first name, tell me something isn't working, change your mind about what you want to discuss, or simply show up on a day when you don't know what to say. I believe therapy works best when there's room for all of that."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "arushi-raheja": {
//     "name": "Arushi Raheja",
//     "title": "Child Psychologist",
//     "experience": "9+ yrs",
//     "sessions": "4000+ hours of healing",
//     "rating": "4.9",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AR",
//     "expertise": ["Parenting support", "Anxiety", "Attention and focus difficulties", "Autism"],
//     "help_tags": ["Trauma and grief", "Thoughts of self-harm or deep distress", "Emotional and behavioural difficulties", "Building self-confidence"],
//     "bio": "Helps in guiding children, adolescents, and parents through emotional hurdles, behavioural challenges, and parenting struggles in a safe environment.",
//     "about": "A Child Psychologist with a Master's degree in Clinical Psychology and NCERT- PG Diploma in Child Guidance, using a Gestalt-informed lens and experience helping children, young adults, and families thrive.",
//     "how_i_work": "Through compassionate conversations, creative activities, and practical guidance, we work together to help you understand your feelings, build strength, and make lasting progress to achieve a better sense of self.",
//     "faqs": [
//       ["My child has been diagnosed with ADHD or Autism — how do you approach that?", "I hold a Master's degree and a PG Diploma in Child Guidance and Counselling, and my practice focuses on supporting children and adolescents with ADHD, autism, learning disabilities, and related concerns. I tailor my approach to each child's unique needs, using a Gestalt-informed lens alongside practical, structured strategies that work for them."],
//       ["Do you work with adults too, or only children?", "While my core focus is children, adolescents, and young adults, I also work with parents and families. I facilitate workshops and training for parents, educators, and organisations on emotional well-being, positive parenting, and mental health topics."],
//       ["I'm worried about my child's self-harm or deep distress — how do you handle that?", "I have clinical experience supporting individuals experiencing self-harm or suicidal ideation. My approach is to create a safe, compassionate space where your child feels heard, assess the level of risk carefully, and work collaboratively with you to ensure they get the right support — including involving a psychiatrist or crisis support if needed."],
//       ["What does a session with you look like?", "Sessions are warm and tailored to your child's age and needs. I use compassionate conversations, creative activities, and practical guidance — drawing on Gestalt therapy and other modalities including dance movement therapy where appropriate — so therapy feels engaging rather than clinical."],
//       ["Do you only do individual therapy, or also workshops?", "I do both. Alongside individual sessions, I facilitate workshops and training programmes for schools, educators, parents, and organisations on emotional well-being, positive parenting, resilience, trauma, grief, and suicide prevention."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "mahita-kochhar": {
//     "name": "Mahita Kochhar",
//     "title": "Counselling Psychologist",
//     "experience": "5+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "MK",
//     "expertise": ["Children and adolescent concerns", "Parenting support", "Emotional regulation", "School-related concerns"],
//     "help_tags": ["Behavioural concerns", "Self-esteem and confidence", "Social and relationship skills", "Adjustment and life transitions"],
//     "bio": "Sits with emotional, behavioural, and school-related difficulties with children, teens and parents to work through them with art based approaches.",
//     "about": "A Counselling Psychologist with a Masters in Clinical Psychology and a PG Diploma in Guidance and counselling and experience in school counselling and Special Educational Needs (SEN) settings.",
//     "how_i_work": "Sessions are warm, empathetic, and conversational. Through engaging activities and creative art-based techniques, we work together to build self-awareness, emotional regulation and develop healthy coping habits.",
//     "faqs": [
//       ["I'm an adult — do you only work with children?", "No — while my core focus is children and adolescents, I also work with adults, especially parents and those navigating emotional regulation, anxiety, self-esteem, and life transitions. My art-based approach can be adapted to adults too, if that feels helpful."],
//       ["I'm not great at talking about my feelings — will therapy still work for me?", "Absolutely. I use creative and art-based techniques alongside conversation, so you can express yourself in ways beyond words — through drawing, colours, and activities — at a pace that feels comfortable for you."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, in Hindi or English. We'll begin by understanding your story and goals, then build a warm, personalised rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your concerns and goals — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["I'm a parent — can you help me support my child better?", "Yes — parenting support is one of my focus areas. I work with parents to help them understand and support their child's emotional and behavioural needs, through separate parent sessions or joint check-ins where helpful."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   },
//   "chavika-dudeja": {
//     "name": "Chavika Dudeja",
//     "title": "Counselling Psychologist | RCI Licensed Rehabilitation Counselor",
//     "experience": "2 yrs",
//     "sessions": "1300+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "CD",
//     "expertise": ["Child counselling", "Family concerns", "Adjustment issues", "Emotional well being"],
//     "help_tags": ["Child counselling and rehabilitation", "Special needs children", "Personal growth", "Self-esteem challenges"],
//     "bio": "Works with individuals and children navigating emotions and transitions to build clarity and self-connection.",
//     "about": "A Counselling Psychologist with a B.A. in Human Development & Family Empowerment and an M.A. in Psychology specializing in Child and Adolescent Guidance.",
//     "how_i_work": "Sessions are warm, grounded, and structured yet flexible. Through compassionate conversations, clear understanding and practical strategies, we work together to help you gain insight and growth.",
//     "faqs": [
//       ["Do you take couples counselling?", "I work primarily with individuals, but if you're navigating relational concerns, we can explore those together in individual sessions."],
//       ["Do you provide medication?", "No — I'm a counselling psychologist, not a psychiatrist, so I don't prescribe medication. If it feels relevant, I can work alongside a psychiatrist or help you connect with one while we continue therapy together."],
//       ["What's the session format and duration?", "Sessions are 50 minutes, held online, and conducted in Hindi or English. We'll start with understanding your story and goals, then build a warm, structured yet flexible rhythm that works for you."],
//       ["How many sessions will I need?", "It depends on your goals and what you're navigating — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
//       ["Do you work with children and adolescents?", "Yes — I'm specializing in Child and Adolescent Guidance and Counselling, so I work with young people as well as adults, tailoring the approach to their age and needs."]
//     ],
//     "palette": ["#EAD9DE", "#EFE7DA"]
//   },
//   "alisha-crasto": {
//     "name": "Alisha Crasto",
//     "title": "Counselling Psychologist",
//     "experience": "7+ yrs",
//     "sessions": "2500+ hours of healing",
//     "rating": "4.8",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "AC",
//     "expertise": ["Child counselling", "Work stress and burnout", "Relationship understanding"],
//     "help_tags": ["Anxiety and stress", "Trauma", "Depression", "Self esteem"],
//     "bio": "Sits with children, adolescents, and adults as a gentle facilitator, trusting that clients hold their own answers and that every person deserves compassionate, accessible mental health care.",
//     "about": "A Psychologist and Narrative Therapy practitioner with a Master's in Clinical Psychology and a Diploma in Community Mental Health from NIMHANS, bringing 7 years of experience supporting children, adolescents, and adults across diverse mental health concerns.",
//     "how_i_work": "Sessions are warm, collaborative, and story-centred, where we explore your experiences together, gently re-authoring the narratives that shape you, at a pace that feels safe and yours. There is no fixing involved but understanding and acceptance.",
//     "faqs": [
//       ["Do you only use narrative therapy?", "Narrative therapy is my core approach, but I blend it with my clinical psychology training to meet each client's needs. The thread throughout is my belief that you are the expert on your own life, I'm here to walk alongside you, not to impose answers."],
//       ["I'm not sure how to talk about what I'm going through. Is that okay?", "Completely. Many people arrive not knowing how to put things into words. We'll go at your pace, and the narrative approach gives us gentle ways to explore your story without pressure to have it all figured out."],
//       ["Do you work with children and adolescents too?", "Yes, I have experience across children, adolescents, and adults. With younger clients, I adapt the approach to their age and world, often using stories and creative expression to help them feel comfortable."],
//       ["What does a first session look like?", "We'll start by getting to know each other and understanding what brought you in with no pressure to have a clear problem or goal. It's a space to share as much or as little as you're comfortable with, and we'll decide together how to move forward."]
//     ],
//     "palette": ["#EAD9DE", "#786C8A"]
//   },
//   "vanshika-vakharia": {
//     "name": "Vanshika Vakharia",
//     "title": "Counselling Psychologist",
//     "experience": "4+ yrs",
//     "sessions": "1500+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "VV",
//     "expertise": ["Emotional regulation", "Healthy coping", "Self understanding"],
//     "help_tags": ["Anxiety and stress", "Emotional regulation", "Self-esteem and confidence", "Life transitions and adjustment", "Relationship concerns"],
//     "bio": "Works with children, adolescents, and adults by helping them understand unhelpful patterns, build healthier coping, and reconnect.",
//     "about": "Counselling Psychologist with a MA in counseling and clinical psychology who works with children, adolescents, and adults through various modalities like mindfulness, and emotional regulation strategies.",
//     "how_i_work": "A warm, collaborative conversation where you feel safe enough to be vulnerable, make sense of your thoughts and emotions, and move towards healing, growth, and lasting change, at a pace that feels right for you.",
//     "faqs": [
//       ["What does a first session look like?", "A warm, collaborative conversation where you feel safe enough to be vulnerable. We'll start by understanding what brought you in and what you're hoping to work on with no pressure to have it all figured out. We'll take it at a pace that feels right for you."],
//       ["Do you only use one type of therapy?", "No I integrate several evidence-based approaches, including CBT, REBT, mindfulness-based interventions, psychoeducation, and emotional regulation strategies. I tailor the blend to your needs and what feels most useful to you."],
//       ["I'm not good at opening up. Is that a problem?", "Not at all. Many clients find it hard to open up at first, and that's completely normal. My job is to create a safe, accepting space where you can be vulnerable at your own pace, there's no rush and no judgment."],
//       ["Do you work with children and adolescents too?", "Yes, I work across children, adolescents, and adults. With younger clients, I adapt my approach to their age and world, using age-appropriate, engaging methods to help them feel comfortable and understood."]
//     ],
//     "palette": ["#EFE7DA", "#EAD9DE"]
//   },
//   "hita-shah": {
//     "name": "Hita Shah",
//     "title": "Counselling Psychologist",
//     "experience": "3+ yrs",
//     "sessions": "2000+ hours of healing",
//     "rating": "4.7",
//     "fee": "₹2000",
//     "modes": "Online",
//     "duration": "50 min",
//     "speaks": "Hindi, English",
//     "initials": "HS",
//     "expertise": ["Self understanding", "Anxiety and stress", "Relationship issues", "Transitions"],
//     "help_tags": ["Emotional balance", "Overthinking", "Confidence & self-worth", "Feeling stuck", "Personal growth"],
//     "bio": "Works in a warm, understanding space to slow down, make sense of what you’re feeling, and find ways forward at your own pace.",
//     "about": "A Counselling Psychologist holding an MSc in Psychology of Mental Health and a Diploma in Guidance and Counselling; offers a warm, supportive space to understand yourself and what you’re going through.",
//     "how_i_work": "Sessions are a space to slow down, talk openly, and make sense of what you’re experiencing. Together, we explore your thoughts, feelings, and patterns, while finding practical ways forward. We work collaboratively and at your pace.",
//     "faqs": [
//       ["What can I talk about in therapy?", "You can talk about whatever feels important to you, your thoughts, feelings, relationships, work, everyday struggles, or things you may not fully understand yet. You don’t need to know exactly where to begin."],
//       ["What happens in the first session?", "The first session is usually about getting to know you, understanding what brings you to therapy, and discussing what you would like support with. There is no pressure to have everything figured out."],
//       ["Will I be given advice or told what to do?", "Therapy with Hita is collaborative. Rather than simply telling you what to do, she helps you understand yourself, explore different perspectives, and find approaches that feel right for you."],
//       ["How often do I need to have sessions?", "There is no one-size-fits-all answer. The frequency can depend on what you’re looking for and what feels comfortable for you. This can be discussed together as you begin."],
//       ["What if I don’t know how to explain what I’m feeling?", "That’s completely okay. You don’t need to come with the perfect words. Sessions can be a space to slowly make sense of what you’re experiencing together."]
//     ],
//     "palette": ["#786C8A", "#EFE7DA"]
//   }
// };
//     profileData.palak = profileData["palak-chhabra"];
//     profileData.arushi = profileData["arushi-raheja"];
//     profileData.mahita = profileData["mahita-kochhar"];
//     profileData.chavika = profileData["chavika-dudeja"];

//     // Parse Shopify Product Metafields JSON output by the Liquid template
//     const shopifyProfiles = {};
//     let firstShopifyHandle = '';
//     const shopifyJsonEl = document.getElementById('shopify-doctors-json');
//     if (shopifyJsonEl) {
//       try {
//         const rawShopify = JSON.parse(shopifyJsonEl.textContent);
//         Object.keys(rawShopify).forEach(handle => {
//           const normKey = normalizeId(handle);
//           if (!firstShopifyHandle) firstShopifyHandle = normKey;
//           const norm = therapistProfile(rawShopify[handle], paletteForId(normKey));
//           if (norm) {
//             shopifyProfiles[normKey] = norm;
//             // Also index by first-name alias (e.g., "palak" -> "palak-chhabra") if not already taken
//             const shortKey = normKey.split('-')[0];
//             if (shortKey && !shopifyProfiles[shortKey]) {
//               shopifyProfiles[shortKey] = norm;
//             }
//           }
//         });
//       } catch (err) {
//         console.warn('[DoctorBooking] Could not parse shopify-doctors-json:', err);
//       }
//     }

//     // Merge hardcoded defaults with Shopify Product Metafields (Shopify Metafields override defaults)
//     state.profileFallback = Object.assign({}, profileData);
//     Object.keys(shopifyProfiles).forEach(key => {
//       state.profileFallback[key] = Object.assign({}, state.profileFallback[key] || {}, shopifyProfiles[key]);
//     });

//     const defaultId = profile.dataset.doctorId && profile.dataset.doctorId !== 'palak-chhabra'
//       ? profile.dataset.doctorId
//       : (firstShopifyHandle || 'palak-chhabra');

//     const id = normalizeId(queryId || defaultId);
//     profile.dataset.doctorId = id;

//     // Keep the Liquid fallback hidden while loadTherapists() resolves. It is
//     // used only to supplement the live Sheet record after that record exists.
//     profile.hidden = true;
//     profile.setAttribute('aria-busy', 'true');
//     const loader = document.getElementById('dbProfileLoading');
//     if (loader) loader.hidden = false;
//     const buyBar = document.getElementById('profileBuyBar');
//     if (buyBar) buyBar.hidden = true;
//     const buyBarLoading = document.getElementById('profileBuyBarLoading');
//     if (buyBarLoading) buyBarLoading.hidden = false;
//   }

//   function initialise() {
//     initProfilePage();
//     initCategoryTabs();
//     initSelectionEvents();
//     initBookingModal();
//     initVideoModal();
//     initFaqAccordion();
//     initCardNavigation();
//     loadTherapists().then(renderProfilePage).catch(() => { });
//     loadAvailability().catch(() => { });
//     initAutoRefresh();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
//   else initialise();
// })();

(() => {
  'use strict';

  const DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbx4o7EeOP02BZVv5AwtiFGY-5uTiGalPiJzqIUu7r9hRPPNdasApH7wGxjNxwVRtrQdcA/exec';
  const REFRESH_INTERVAL_MS = 45000;
  const REQUEST_TIMEOUT_MS = 15000;
  const state = {
    doctors: new Map(),
    therapists: new Map(),
    bookedMap: new Map(),
    pendingMap: new Map(),
    profileFallback: null,
    currentDoctorId: '',
    modalDoctor: null,
    loaded: false,
    availabilityEnabled: false,
    loadingPromise: null,
    therapistsPromise: null,
    requestController: null,
    bookingRequestId: '',
    otpChallengeId: '',
    otpVerificationToken: '',
    otpResendTimer: null,
    checkoutPromise: null,
    currentCheckout: null,
    localBooked: [],
    refreshTimer: null
  };

  const apiUrl = () => {
    const configured = document.querySelector('[data-booking-api-url]')?.dataset.bookingApiUrl?.trim();
    return configured || window.DoctorBookingConfig?.apiUrl || DEFAULT_API_URL;
  };
  const normalizeId = value => String(value ?? '').trim().toLowerCase();
  const normalizeMode = value => {
    const mode = String(value ?? 'online').toLowerCase();
    return mode.includes('person') || mode.includes('clinic') ? 'in-person' : 'online';
  };
  const stringValue = value => String(value ?? '').trim();
  const sheetKey = value => stringValue(value).toLowerCase()
    .replace(/[\s-]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_');
  const normaliseSlotTime = value => {
    const text = stringValue(value).toUpperCase();
    const match = text.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/);
    if (!match) return text;
    const hour = Number(match[1]);
    if (Number(match[2]) > 59 || hour > (match[3] ? 12 : 23) || (match[3] && hour < 1)) return text;
    return `${String(hour % 12 || 12).padStart(2, '0')}:${match[2]} ${match[3] || (hour >= 12 ? 'PM' : 'AM')}`;
  };

  /* ---------- Google Sheet therapist data ---------- */
  const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const DEFAULT_TIME_SLOTS = ['10:00 AM', '11:30 AM', '02:00 PM', '03:30 PM', '05:00 PM', '06:30 PM'];
  const CARD_PALETTES = [
    ['#EAD9DE', '#786C8A'],
    ['#EFE7DA', '#EAD9DE'],
    ['#786C8A', '#EFE7DA'],
    ['#EAD9DE', '#EFE7DA'],
    ['#EFE7DA', '#786C8A']
  ];
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const safeUrl = value => /^https?:\/\//i.test(stringValue(value)) ? stringValue(value) : '';
  const initialsOf = name => stringValue(name).split(/\s+/).slice(0, 2).map(word => word.slice(0, 1).toUpperCase()).join('') || '?';

  function normaliseTherapist(record) {
    if (!record || typeof record !== 'object') return null;
    const row = {};
    Object.keys(record).forEach(key => { row[sheetKey(key)] = record[key]; });
    const id = normalizeId(row.id || row.handle || row.slug).replace(/\s+/g, '-');
    if (!id) return null;
    const active = !['no', 'false', '0', 'hidden'].includes(stringValue(row.active || 'yes').toLowerCase());
    const slots = stringValue(row.time_slots).split(/[;,]/).map(normaliseSlotTime).filter(Boolean);
    const rawPrice = stringValue(row.price || row.fee);
    const trustParts = stringValue(row.trust_line).split('|').map(stringValue).filter(Boolean);
    const days = stringValue(row.days).split(/[,;]/)
      .map(day => day.trim().toUpperCase().slice(0, 3))
      .filter(day => DAY_NAMES.includes(day));
    return {
      id,
      name: stringValue(row.name) || 'Therapist',
      role: stringValue(row.role || row.title) || 'Therapist',
      rating: stringValue(row.rating),
      price: /^\d+(\.\d+)?$/.test(rawPrice) ? `₹${Number(rawPrice).toLocaleString('en-IN')}` : rawPrice,
      duration: stringValue(row.duration),
      availability: stringValue(row.availability || row.next_slot),
      image_url: safeUrl(row.image_url || row.image),
      experience: stringValue(row.experience),
      expertise: stringValue(row.expertise),
      languages: stringValue(row.languages || row.speaks),
      centre: stringValue(row.centre || row.format) || 'Online',
      gender: stringValue(row.gender),
      bio: stringValue(row.bio),
      trust_line: stringValue(row.trust_line),
      about: stringValue(row.about),
      how_i_work: stringValue(row.how_i_work),
      help_tags: stringValue(row.help_tags),
      faqs: Array.isArray(row.faqs) ? row.faqs : [],
      sessions: stringValue(row.sessions) || trustParts[0] || '',
      switch_policy: stringValue(row.switch_policy) || trustParts[1] || '',
      category: stringValue(row.category) || 'therapist',
      days: days.length ? days : null,
      time_slots: slots.length ? slots : DEFAULT_TIME_SLOTS.slice(),
      active
    };
  }

  function activeTherapists() {
    return Array.from(state.therapists.values()).filter(therapist => therapist.active);
  }

  function therapistFee(therapist) {
    if (!therapist?.price) return '';
    return therapist.duration ? `${therapist.price} for ${therapist.duration}` : therapist.price;
  }

  function loadTherapists() {
    if (state.therapistsPromise) return state.therapistsPromise;
    const url = apiUrl();
    const separator = url.includes('?') ? '&' : '?';
    state.therapistsPromise = fetchJson(`${url}${separator}action=therapists&_=${Date.now()}`, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(payload => {
      if (payload?.success === false) {
        throw new Error(payload.message || 'The therapist service rejected the request.');
      }
      const records = Array.isArray(payload) ? payload : payload?.therapists || payload?.data;
      if (!Array.isArray(records)) {
        throw new Error('The therapist response does not contain a valid therapists list.');
      }
      const nextTherapists = new Map();
      records.forEach(record => {
        const therapist = normaliseTherapist(record);
        if (therapist) nextTherapists.set(therapist.id, therapist);
      });
      state.therapists = nextTherapists;
      if (state.therapists.size > 0) {
        renderHomeCarousel();
        renderListingCards();
      } else {
        renderHomeTherapistStatus('No therapists are available right now.');
        renderListingStatus('No therapists are available right now.');
        if (!state.profileFallback) {
          renderProfileStatus('This therapist is not available right now.');
        }
      }
    }).catch(error => {
      console.warn('[DoctorBooking] Therapist sheet data could not be loaded.', error);
      renderHomeTherapistStatus('Therapists could not be loaded. Please try again shortly.', true);
      renderListingStatus('Therapists could not be loaded. Please try again shortly.', true);
      renderProfileStatus('This therapist could not be loaded. Please try again shortly.', true);
      throw error;
    }).finally(() => { state.therapistsPromise = null; });
    return state.therapistsPromise;
  }

  function renderHomeCarousel() {
    const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
    if (!carousel) return;
    const therapists = activeTherapists();
    if (!therapists.length) return;
    const bookLabel = stringValue(carousel.dataset.bookLabel) || 'Book Session';
    const endLink = carousel.querySelector('.carousel-end');
    carousel.innerHTML = therapists.map((therapist, index) => {
      const palette = CARD_PALETTES[index % CARD_PALETTES.length];
      const media = therapist.image_url
        ? `<img loading="lazy" src="${esc(therapist.image_url)}" alt="${esc(therapist.name)}">`
        : `<div class="mini-initials">${esc(initialsOf(therapist.name))}</div>`;
      const slot = therapist.availability
        ? `<span class="mini-slot"><span class="dot"></span>${esc(therapist.availability)}</span>`
        : '';
      return `<article class="mini-card" data-therapist-id="${esc(therapist.id)}" style="cursor:pointer;">
        <div class="mini-media" style="--card-a:${palette[0]};--card-b:${palette[1]}">${media}${slot}</div>
        <div class="mini-body"><div class="mini-name-row"><h3>${esc(therapist.name)}</h3><span class="mini-verified" aria-label="Verified">&#10003;</span></div><div class="mini-role">${esc(therapist.role)}</div><div class="mini-meta"><span class="star">&#9733;</span> ${esc(therapist.rating)}</div><div class="mini-price">${esc(therapist.price)}</div><button type="button" class="mini-book db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">${esc(bookLabel)}</button></div>
      </article>`;
    }).join('');
    if (endLink) {
      endLink.hidden = false;
      carousel.appendChild(endLink);
    }
    carousel.setAttribute('aria-busy', 'false');
  }

  function renderHomeTherapistStatus(message, isError = false) {
    const carousel = document.querySelector('.mt-home .mt-therapists-carousel');
    if (!carousel) return;
    const status = document.createElement('div');
    status.className = `mt-therapists-status${isError ? ' mt-therapists-status-error' : ''}`;
    status.setAttribute('role', 'status');
    status.textContent = message;
    carousel.replaceChildren(status);
    carousel.setAttribute('aria-busy', 'false');
  }

  function renderListingStatus(message, isError = false) {
    const listEl = document.getElementById('cardList');
    if (!listEl) return;
    const status = document.createElement('div');
    status.className = `db-list-status${isError ? ' db-list-status-error' : ''}`;
    status.setAttribute('role', isError ? 'alert' : 'status');
    status.textContent = message;
    listEl.replaceChildren(status);
    listEl.setAttribute('aria-busy', 'false');
  }

  function renderProfileStatus(message, isError = false) {
    const loader = document.getElementById('dbProfileLoading');
    const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
    if (!loader || !profile) return;
    profile.hidden = true;
    const buyBar = document.getElementById('profileBuyBar');
    if (buyBar) buyBar.hidden = true;
    const buyBarLoading = document.getElementById('profileBuyBarLoading');
    if (buyBarLoading) buyBarLoading.hidden = true;
    const status = document.createElement('div');
    status.className = `db-profile-status${isError ? ' db-profile-status-error' : ''}`;
    status.setAttribute('role', isError ? 'alert' : 'status');
    status.textContent = message;
    loader.replaceChildren(status);
    loader.hidden = false;
  }

  function revealProfilePage(profile) {
    const loader = document.getElementById('dbProfileLoading');
    if (loader) loader.hidden = true;
    profile.hidden = false;
    profile.setAttribute('aria-busy', 'false');
    const buyBar = document.getElementById('profileBuyBar');
    if (buyBar) buyBar.hidden = false;
    const buyBarLoading = document.getElementById('profileBuyBarLoading');
    if (buyBarLoading) buyBarLoading.hidden = true;
  }

  function listingCardHtml(therapist, index) {
    const palette = CARD_PALETTES[index % CARD_PALETTES.length];
    const tags = therapist.expertise.split(',').map(tag => tag.trim()).filter(Boolean)
      .map(tag => `<span class="tag">${esc(tag)}</span>`).join('');
    const mediaStyle = therapist.image_url
      ? `background:url('${esc(therapist.image_url)}') center/cover no-repeat, linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`
      : `background:linear-gradient(150deg, ${palette[0]}, ${palette[1]} 120%);`;
    const meta = [
      `<span class="star">&#9733;</span>${esc(therapist.rating)}`,
      therapist.role ? `<span class="sep">&middot;</span> ${esc(therapist.role)}` : '',
      therapist.experience ? `<span class="sep">&middot;</span> ${esc(therapist.experience)}` : ''
    ].join(' ');
    return `<article class="t-card" data-id="${esc(therapist.id)}" data-category="${esc(therapist.category)}" data-open="${esc(therapist.id)}">
      <div class="media" style="${mediaStyle}">
        ${therapist.image_url ? '' : `<div class="media-initials">${esc(initialsOf(therapist.name))}</div>`}
        ${therapist.availability ? `<span class="slot-badge"><span class="dot"></span>Next: ${esc(therapist.availability)}</span>` : ''}
      </div>
      <div class="t-body">
        <div class="name-row"><h2>${esc(therapist.name)}</h2><span class="verified" title="Verified">&#10003;</span></div>
        <div class="meta-line">${meta}</div>
        ${tags ? `<div class="tags-row">${tags}</div>` : ''}
        ${therapist.bio ? `<p class="bio-line">${esc(therapist.bio)}</p>` : ''}
       ${String(therapist.trust_line || '')
  .split('|')
  .map(line => line.trim())
  .filter(Boolean)
  .map(line => `
    <div class="trust-line">
      <span class="ic">&#10003;</span>
      <span>${esc(line)}</span>
    </div>
  `)
  .join('')}
        ${therapist.sessions ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.sessions)}</div>` : ''}
        ${therapist.switch_policy ? `<div class="trust-line"><span class="ic">&#10003;</span>${esc(therapist.switch_policy)}</div>` : ''}
        <div class="price-cta-row">
          <div class="price-line">
            <span class="p-label">${esc(therapist.centre)}${therapist.duration ? ` &middot; ${esc(therapist.duration)}` : ''}</span>
            <span class="p-value">${esc(therapist.price)}</span>
          </div>
          <div class="cta-buttons-row">
            <a href="/pages/doctor-profile?id=${encodeURIComponent(therapist.id)}" class="consult-btn" data-consult="${esc(therapist.id)}">Free 15-min call</a>
            <button type="button" class="book-btn db-btn-book" data-doc-id="${esc(therapist.id)}" data-doc-name="${esc(therapist.name)}" data-doc-fee="${esc(therapistFee(therapist))}">Book Session</button>
          </div>
        </div>
      </div>
    </article>`;
  }

  function renderListingCards() {
    const listEl = document.getElementById('cardList');
    if (!listEl) return;
    const therapists = activeTherapists();
    if (!therapists.length) return;
    listEl.innerHTML = therapists.map((therapist, index) => listingCardHtml(therapist, index)).join('');
    listEl.setAttribute('aria-busy', 'false');
    updateDoctorCards();
    filterDoctors();
  }

  function isoOf(day) {
    return `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
  }

  function dateFromIso(iso) {
    const match = stringValue(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function parseBooked(payload) {
    const entries = Array.isArray(payload?.booked) ? payload.booked : [];
    state.bookedMap = new Map();
    state.pendingMap = new Map();
    entries.forEach(entry => {
      const docId = normalizeId(entry.doctor_id).replace(/\s+/g, '-');
      const iso = stringValue(entry.date);
      const time = normaliseSlotTime(entry.time);
      if (!docId || !/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
      const key = `${docId}|${iso}`;
      const pending = stringValue(entry.status).toLowerCase() === 'payment_pending';
      const target = pending ? state.pendingMap : state.bookedMap;
      if (!target.has(key)) target.set(key, new Set());
      target.get(key).add(time);
    });
    state.localBooked = state.localBooked.filter(entry => !entry.expiresAt || Date.parse(entry.expiresAt) > Date.now());
    state.localBooked.forEach(entry => {
      const key = `${entry.doctorId}|${entry.date}`;
      if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
      state.pendingMap.get(key).add(entry.time);
    });
  }

  function activeDatePill() {
    return document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill.active')
      || document.querySelector('#dbBookingModal .db-date-picker-row .db-date-pill');
  }

  function modalSlots(iso = activeDatePill()?.dataset.iso || '') {
    if (state.availabilityEnabled) {
      return state.doctors.get(state.currentDoctorId)?.schedule?.[iso] || [];
    }
    const slots = state.modalDoctor?.time_slots;
    return slots?.length ? slots : DEFAULT_TIME_SLOTS;
  }

  function markFullDatePills() {
    document.querySelectorAll('#dbBookingModal .db-date-pill').forEach(pill => {
      const slots = modalSlots(pill.dataset.iso);
      const booked = state.bookedMap.get(`${state.currentDoctorId}|${pill.dataset.iso}`);
      const isFull = slots.length > 0 && !!booked && slots.every(slot => booked.has(slot));
      pill.classList.toggle('db-date-full', isFull);
    });
  }

  function ensureDatePills(therapist) {
    const row = document.querySelector('#dbBookingModal .db-date-picker-row');
    if (!row) return;
    const previousIso = activeDatePill()?.dataset.iso || '';
    if (!state.loaded) {
      setHiddenValue('dbBookingDate', '');
      showLoading(row, 'Loading dates…');
      return;
    }

    if (state.availabilityEnabled) {
      const today = isoOf(new Date());
      const schedule = state.doctors.get(state.currentDoctorId)?.schedule || {};
      const dates = Object.keys(schedule)
        .filter(iso => iso >= today && Array.isArray(schedule[iso]) && schedule[iso].length)
        .sort();
      if (!dates.length) {
        setHiddenValue('dbBookingDate', '');
        setHiddenValue('dbBookingTime', '');
        renderMessage(row, 'No upcoming dates are available for this therapist.');
        return;
      }
      row.innerHTML = dates.map(iso => {
        const day = dateFromIso(iso);
        const dayName = DAY_NAMES[day.getDay()];
        const offset = Math.round((day.getTime() - dateFromIso(today).getTime()) / 86400000);
        const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
        const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
        return `<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`;
      }).join('');
      markFullDatePills();
      const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
      const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
      active?.classList.add('active');
      setHiddenValue('dbBookingDate', active?.dataset.iso || '');
      return;
    }

    const build = useDayFilter => {
      const pills = [];
      const now = new Date();
      for (let offset = 0; offset < 60 && pills.length < 30; offset++) {
        const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
        const dayName = DAY_NAMES[day.getDay()];
        if (useDayFilter && therapist?.days && !therapist.days.includes(dayName)) continue;
        const label = offset === 0 ? 'TODAY' : offset === 1 ? 'TOMORROW' : dayName;
        const num = `${day.getDate()} ${MONTH_NAMES[day.getMonth()]}`;
        const iso = isoOf(day);
        pills.push(`<div class="db-date-pill" data-date="${label} ${num}" data-iso="${iso}" data-day="${dayName}"><div class="db-date-day">${label}</div><div class="db-date-num">${num}</div></div>`);
      }
      return pills;
    };
    let pills = build(true);
    if (!pills.length) pills = build(false);
    row.innerHTML = pills.join('');
    markFullDatePills();
    const previous = previousIso ? row.querySelector(`[data-iso="${previousIso}"]:not(.db-date-full)`) : null;
    const active = previous || row.querySelector('.db-date-pill:not(.db-date-full)') || row.querySelector('.db-date-pill');
    active?.classList.add('active');
    setHiddenValue('dbBookingDate', active?.dataset.iso || '');
  }

  function renderTimePills() {
    const grid = document.querySelector('#dbBookingModal .db-time-grid');
    if (!grid) return;
    if (!state.loaded) {
      setHiddenValue('dbBookingTime', '');
      showLoading(grid);
      return;
    }
    const previous = stringValue(document.getElementById('dbBookingTime')?.value);
    const iso = activeDatePill()?.dataset.iso || '';
    const slots = modalSlots(iso);
    if (!iso || !slots.length) {
      setHiddenValue('dbBookingTime', '');
      renderMessage(grid, iso ? 'No times are available on this date.' : 'Select an available date first.');
      return;
    }
    const booked = state.bookedMap.get(`${state.currentDoctorId}|${iso}`);
    const pending = state.pendingMap.get(`${state.currentDoctorId}|${iso}`);
    grid.innerHTML = slots.map(slot => {
      if (booked?.has(slot)) {
        return `<div class="db-time-pill db-time-booked" aria-disabled="true">${esc(slot)}<span class="db-booked-tag">Booked</span></div>`;
      }
      if (pending?.has(slot)) {
        return `<div class="db-time-pill db-time-pending" title="Reserved. Select only to resume your existing payment.">${esc(slot)}<span class="db-booked-tag">Payment pending</span></div>`;
      }
      return `<div class="db-time-pill">${esc(slot)}</div>`;
    }).join('');
    const active = Array.from(grid.querySelectorAll('.db-time-pill:not(.db-time-booked)'))
      .find(pill => slotText(pill) === previous)
      || grid.querySelector('.db-time-pill:not(.db-time-booked):not(.db-time-pending)');
    active?.classList.add('active');
    setHiddenValue('dbBookingTime', active ? slotText(active) : '');
  }

  const slotText = pill => pill?.querySelector('.db-booked-tag')
    ? pill.textContent.replace(pill.querySelector('.db-booked-tag').textContent, '').trim()
    : stringValue(pill?.textContent);

  function safeUuid() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `booking-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function clearElement(element) {
    if (element) element.replaceChildren();
  }

  function renderMessage(container, message, isError = false) {
    if (!container) return;
    clearElement(container);
    const status = document.createElement('div');
    status.className = `db-availability-message${isError ? ' db-availability-error' : ''}`;
    status.setAttribute('role', 'status');
    status.textContent = message;
    container.appendChild(status);
  }

  function showLoading(container, message = 'Loading availability…') {
    if (!container) return;
    clearElement(container);
    const wrapper = document.createElement('div');
    wrapper.className = 'db-loading-spinner-wrap';
    wrapper.setAttribute('role', 'status');
    const spinner = document.createElement('div');
    spinner.className = 'db-loading-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.textContent = message;
    wrapper.append(spinner, label);
    container.appendChild(wrapper);
  }

  function normaliseSchedule(value) {
    const schedule = {};
    if (Array.isArray(value)) {
      value.forEach(entry => {
        const iso = stringValue(entry?.date);
        const slots = Array.isArray(entry?.slots) ? entry.slots : [];
        if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
          schedule[iso] = [...new Set(slots.map(normaliseSlotTime).filter(Boolean))];
        }
      });
      return schedule;
    }
    if (!value || typeof value !== 'object') return schedule;
    Object.keys(value).forEach(iso => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !Array.isArray(value[iso])) return;
      schedule[iso] = [...new Set(value[iso].map(normaliseSlotTime).filter(Boolean))];
    });
    return schedule;
  }

  function normaliseDoctor(record) {
    if (!record || typeof record !== 'object') return null;
    const id = normalizeId(record.doctor_id || record.doctorId || record.handle || record.id);
    if (!id) return null;
    const schedule = normaliseSchedule(record.schedule || record.availability_by_date);
    return {
      ...record,
      doctor_id: id,
      next_slot: stringValue(record.next_slot || record.nextSlot),
      dates: Array.isArray(record.dates || record.available_dates)
        ? (record.dates || record.available_dates).map(stringValue).filter(Boolean)
        : Object.keys(schedule),
      schedule
    };
  }

  function normalisePayload(payload) {
    if (payload && payload.success === false) {
      throw new Error(payload.message || 'The booking service rejected the availability request.');
    }
    const records = Array.isArray(payload) ? payload : payload?.doctors || payload?.data || payload?.availability || [];
    const map = new Map();
    records.forEach(item => {
      const doc = normaliseDoctor(item);
      if (doc) map.set(doc.doctor_id, doc);
    });
    return map;
  }

  async function fetchJson(url, options = {}) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      const text = await response.text();
      let data = null;
      try { data = JSON.parse(text); } catch (_) { }
      if (!response.ok) {
        const error = new Error(data?.message || `Request failed with HTTP status ${response.status}`);
        error.code = data?.code || `HTTP_${response.status}`;
        throw error;
      }
      if (data === null) {
        const error = new Error('The booking service returned an invalid response. Check the latest Apps Script execution log.');
        error.code = 'INVALID_JSON_RESPONSE';
        throw error;
      }
      return data;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function setHiddenValue(id, value) {
    const input = document.getElementById(id);
    if (input && typeof value !== 'undefined') input.value = value;
  }

  function updateDoctorCards() {
    document.querySelectorAll('.t-card, .db-doctor-card, .mini-card, .mt-therapist-skeleton').forEach(card => {
      const id = normalizeId(card.dataset.id || card.dataset.open || card.dataset.therapistId || card.dataset.docId);
      const doctor = state.doctors.get(id);
      if (!doctor) return;
      const badge = card.querySelector('.slot-badge, .db-next-slot, .mini-slot');
      if (doctor.next_slot) {
        if (badge) {
          badge.style.display = '';
          const dot = badge.querySelector('.dot, .db-status-dot');
          if (dot) {
            badge.innerHTML = `<span class="dot"></span>Next: ${esc(doctor.next_slot)}`;
          } else {
            badge.textContent = `Next: ${doctor.next_slot}`;
          }
        }
      } else if (state.availabilityEnabled && badge) {
        badge.style.display = 'none';
      }
    });

    const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
    const profileId = normalizeId(profile?.dataset.doctorId);
    const profileDoctor = state.doctors.get(profileId);
    if (profile && profileDoctor) {
      const badge = profile.querySelector('.slot-badge');
      const value = badge?.querySelector('[data-bind="next_slot"]');
      if (profileDoctor.next_slot) {
        if (value) value.textContent = profileDoctor.next_slot;
        if (badge) badge.style.display = '';
      } else if (state.availabilityEnabled && badge) {
        badge.style.display = 'none';
      }
    }
  }

  async function loadAvailability() {
    const url = apiUrl();
    if (!url) return null;
    if (state.loadingPromise) return state.loadingPromise;
    const separator = url.includes('?') ? '&' : '?';
    state.loadingPromise = fetchJson(`${url}${separator}action=availability&_=${Date.now()}`, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(payload => {
      if (!Array.isArray(payload?.booked)) throw new Error('Availability response is missing booked slots.');
      state.doctors = normalisePayload(payload);
      state.availabilityEnabled = payload?.availability_enabled === true;
      state.loaded = true;
      parseBooked(payload);
      updateDoctorCards();
      if (document.getElementById('dbBookingModal')?.classList.contains('active')) {
        ensureDatePills(state.modalDoctor);
        renderTimePills();
      }
      return payload;
    }).catch(error => {
      state.loaded = false;
      setHiddenValue('dbBookingDate', '');
      setHiddenValue('dbBookingTime', '');
      renderMessage(document.querySelector('#dbBookingModal .db-date-picker-row'), 'Available dates could not be checked. Please try again.', true);
      renderMessage(document.getElementById('dbTimeGrid'), 'Availability could not be checked. Please reopen the booking form to retry.', true);
      console.warn('[DoctorBooking] Note on live availability:', error);
    }).finally(() => { state.loadingPromise = null; });
    return state.loadingPromise;
  }

  function initAutoRefresh() {
    const refreshSheetData = () => {
      loadTherapists().then(renderProfilePage).catch(() => { });
      loadAvailability().catch(() => { });
    };
    state.refreshTimer = window.setInterval(() => {
      if (document.visibilityState === 'visible') refreshSheetData();
    }, REFRESH_INTERVAL_MS);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refreshSheetData();
    });
  }

  /* ---------- Category Filter Tabs ---------- */
  function initCategoryTabs() {
    document.querySelectorAll('.db-tab-btn').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.db-tab-btn').forEach(item => item.classList.remove('active'));
        tab.classList.add('active');
        filterDoctors();
      });
    });
  }

  function filterDoctors() {
    const category = document.querySelector('.db-tab-btn.active')?.dataset.category || 'all';
    document.querySelectorAll('.t-card, .db-doctor-card').forEach(card => {
      const cardCat = stringValue(card.dataset.category).toLowerCase();
      const visible = (category === 'all' || cardCat.includes(category.toLowerCase()));
      card.style.display = visible ? '' : 'none';
    });
  }

  /* ---------- Selection Events (Mode / Date / Time) ---------- */
  function initSelectionEvents() {
    document.addEventListener('click', event => {
      const modeButton = event.target.closest('.db-mode-btn');
      if (modeButton) {
        const selector = modeButton.closest('.db-mode-selector');
        selector?.querySelectorAll('.db-mode-btn').forEach(button => {
          button.classList.toggle('active', button === modeButton);
        });
        const mode = normalizeMode(modeButton.dataset.mode || modeButton.textContent);
        setHiddenValue('dbConsultationMode', mode);
        return;
      }

      const datePill = event.target.closest('.db-date-pill');
      if (datePill) {
        if (datePill.classList.contains('db-date-full')) return;
        const row = datePill.closest('.db-date-picker-row');
        row?.querySelectorAll('.db-date-pill').forEach(pill => pill.classList.remove('active'));
        datePill.classList.add('active');
        setHiddenValue('dbBookingDate', datePill.dataset.iso || '');
        renderTimePills();
        return;
      }

      const timePill = event.target.closest('.db-time-pill');
      if (timePill) {
        if (timePill.classList.contains('db-time-booked')) return;
        const grid = timePill.closest('.db-time-grid');
        grid?.querySelectorAll('.db-time-pill').forEach(pill => pill.classList.remove('active'));
        timePill.classList.add('active');
        setHiddenValue('dbBookingTime', slotText(timePill));
        if (timePill.classList.contains('db-time-pending')) {
          window.alert('This slot is reserved pending payment. Continue only to resume your booking using the same verified WhatsApp number.');
        }
      }
    });
  }

  /* ---------- Booking Modal Functions ---------- */
  function openBookingModal(button) {
    const modal = document.getElementById('dbBookingModal');
    if (!modal) return;
    const card = button.closest('.t-card, .mini-card, .mt-therapist-skeleton, .profile-page, #profileContent');
    const id = normalizeId(button.dataset.docId || card?.dataset.id || card?.dataset.open || card?.dataset.therapistId || state.currentDoctorId || 'palak-chhabra');
    state.currentDoctorId = id;
    state.bookingRequestId = '';
    state.otpChallengeId = '';
    state.otpVerificationToken = '';
    state.currentCheckout = null;
    if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
    state.otpResendTimer = null;

    const name = stringValue(button.dataset.docName)
      || stringValue(card?.querySelector('.name-row h2, .mini-name-row h3, h1[data-bind="name"]')?.textContent)
      || 'Therapist';
    const fee = stringValue(button.dataset.docFee)
      || stringValue(card?.querySelector('.price-line .p-value, .mini-price, [data-bind="fee"]')?.textContent)
      || '₹2000';

    const therapist = state.therapists.get(id);
    const fallbackDoc = state.profileFallback?.[id];
    let resolvedName = name;
    let resolvedFee = fee;
    if (therapist) {
      resolvedName = therapist.name || name;
      resolvedFee = therapistFee(therapist) || fee;
    } else if (fallbackDoc) {
      resolvedName = fallbackDoc.name || name;
      resolvedFee = fallbackDoc.fee || fee;
    }
    state.modalDoctor = therapist || null;

    const nameElement = document.getElementById('dbModalDocName');
    const feeElement = document.getElementById('dbModalDocFee');
    if (nameElement) nameElement.textContent = resolvedName;
    if (feeElement) feeElement.textContent = resolvedFee;

    setHiddenValue('dbDoctorId', id);
    setHiddenValue('dbDoctorName', resolvedName);
    setHiddenValue('dbDoctorFee', resolvedFee);

    setHiddenValue('dbBookingTime', '');
    ensureDatePills(therapist);
    renderTimePills();

    const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
    if (paymentButtonContainer) {
      paymentButtonContainer.style.display = 'none';
      paymentButtonContainer.replaceChildren();
    }

    const stepOne = document.getElementById('dbModalStep1');
    const otpStep = document.getElementById('dbModalStepOtp');
    const success = document.getElementById('dbModalStepSuccess');
    if (stepOne) stepOne.style.display = 'block';
    if (otpStep) otpStep.style.display = 'none';
    if (success) success.style.display = 'none';
    const otpInput = document.getElementById('dbOtpCode');
    if (otpInput) otpInput.value = '';
    const otpStatus = document.getElementById('dbOtpStatus');
    if (otpStatus) otpStatus.textContent = '';

    modal.classList.add('active');
    loadAvailability().catch(() => {});
  }

  const closeBookingModal = () => {
    document.getElementById('dbBookingModal')?.classList.remove('active');
    if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
    state.otpResendTimer = null;
  };

  function markSlotBookedLocally(iso, time, expiresAt) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || !time) return;
    state.localBooked.push({ doctorId: state.currentDoctorId, date: iso, time, expiresAt });
    const key = `${state.currentDoctorId}|${iso}`;
    if (!state.pendingMap.has(key)) state.pendingMap.set(key, new Set());
    state.pendingMap.get(key).add(time);
    markFullDatePills();
    renderTimePills();
    loadAvailability().catch(() => { });
  }

  function loadRazorpayCheckout() {
    if (window.Razorpay) return Promise.resolve();
    if (state.checkoutPromise) return state.checkoutPromise;
    state.checkoutPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Razorpay Checkout could not be loaded.'));
      document.head.appendChild(script);
    }).finally(() => { state.checkoutPromise = null; });
    return state.checkoutPromise;
  }

  async function verifyRazorpayPayment(response) {
    let lastResult = null;
    for (let attempt = 0; attempt < 3; attempt++) {
      if (attempt > 0) await new Promise(resolve => window.setTimeout(resolve, 1500));
      lastResult = await fetchJson(apiUrl(), {
        method: 'POST',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
        body: JSON.stringify({
          action: 'verify_payment',
          request_id: state.bookingRequestId,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature
        })
      });
      if (lastResult?.success === true && stringValue(lastResult?.status).toLowerCase() === 'confirmed') return lastResult;
      if (lastResult?.code !== 'PAYMENT_NOT_CAPTURED') break;
    }
    const error = new Error(lastResult?.message || 'Payment verification is still pending.');
    error.code = lastResult?.code || 'PAYMENT_VERIFICATION_FAILED';
    throw error;
  }

  async function startRazorpayCheckout(checkout) {
    if (!checkout?.key_id || !checkout?.order_id || !checkout?.amount) return;
    try {
      await loadRazorpayCheckout();
      const patientName = stringValue(document.getElementById('dbPatientName')?.value);
      const patientEmail = stringValue(document.getElementById('dbPatientEmail')?.value);
      const rawPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
      const phoneDigits = rawPhone.replace(/\D/g, '');
      const patientPhone = rawPhone.startsWith('+')
        ? `+${phoneDigits}`
        : phoneDigits.length === 10
          ? `+91${phoneDigits}`
          : `+${phoneDigits}`;
      const razorpay = new window.Razorpay({
        key: checkout.key_id,
        order_id: checkout.order_id,
        amount: checkout.amount,
        currency: checkout.currency || 'INR',
        name: 'MushinTalks',
        description: `Therapy session with ${stringValue(document.getElementById('dbDoctorName')?.value)}`,
        prefill: {
          name: patientName,
          email: patientEmail,
          contact: patientPhone
        },
        readonly: { name: true, contact: true, email: Boolean(patientEmail) },
        hidden: { contact: true, email: Boolean(patientEmail) },
        theme: { color: '#786c8a' },
        handler: async response => {
          const successTitle = document.getElementById('dbSuccessTitle');
          const successText = document.getElementById('dbSuccessText');
          if (successTitle) successTitle.textContent = 'Verifying Payment…';
          if (successText) successText.textContent = 'Please wait while we securely confirm your payment.';
          try {
            const verified = await verifyRazorpayPayment(response);
            state.bookingRequestId = '';
            state.currentCheckout = null;
            showBookingSuccess(verified.payment_status, verified.status, null);
          } catch (error) {
            showBookingSuccess('pending', 'payment_pending', checkout);
            window.alert(error?.message || 'Payment verification is pending. Please contact us with your payment ID.');
          }
        }
      });
      razorpay.on('payment.failed', response => {
        const description = response?.error?.description || 'Payment failed. You can retry using the same reserved slot.';
        window.alert(description);
      });
      razorpay.open();
    } catch (error) {
      window.alert(error?.message || 'Payment could not be opened. Please try again.');
    }
  }

  function renderCheckoutButton(container, checkout) {
    container.replaceChildren();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'db-btn-primary db-pay-now-btn';
    button.textContent = 'Pay Now →';
    button.addEventListener('click', () => startRazorpayCheckout(checkout));
    container.appendChild(button);
  }

  function showBookingSuccess(paymentStatus, bookingStatus, checkout) {
    if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
    state.otpResendTimer = null;
    const stepOne = document.getElementById('dbModalStep1');
    const otpStep = document.getElementById('dbModalStepOtp');
    const success = document.getElementById('dbModalStepSuccess');
    if (stepOne) stepOne.style.display = 'none';
    if (otpStep) otpStep.style.display = 'none';
    if (success) success.style.display = 'block';
    const normalizedPaymentStatus = stringValue(paymentStatus).toLowerCase();
    const normalizedBookingStatus = stringValue(bookingStatus).toLowerCase();
    const paymentConfirmed = ['paid', 'captured', 'success'].includes(normalizedPaymentStatus)
      || normalizedBookingStatus === 'confirmed';
    const successTitle = document.getElementById('dbSuccessTitle');
    const successText = document.getElementById('dbSuccessText');
    if (successTitle) successTitle.textContent = paymentConfirmed ? 'Booking Confirmed!' : 'Slot Reserved';
    if (successText) {
      successText.textContent = paymentConfirmed
        ? 'Your payment is confirmed and your consultation has been booked.'
        : 'Your slot is reserved pending payment. Complete the payment below to confirm your booking.';
    }
    const paymentButtonContainer = document.getElementById('dbRazorpayButtonContainer');
    const resolvedCheckout = checkout?.order_id ? checkout : state.currentCheckout;
    if (paymentButtonContainer) {
      if (!paymentConfirmed && resolvedCheckout) {
        state.currentCheckout = resolvedCheckout;
        paymentButtonContainer.style.display = 'block';
        renderCheckoutButton(paymentButtonContainer, resolvedCheckout);
      } else {
        paymentButtonContainer.style.display = 'none';
        paymentButtonContainer.replaceChildren();
        if (!paymentConfirmed && successText) {
          successText.textContent = 'The payment session could not be prepared. Close this window and retry the same slot with the same phone number.';
        }
      }
    }
  }

  function setOtpStatus(message, isError = false) {
    const status = document.getElementById('dbOtpStatus');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('db-otp-status-error', Boolean(isError));
  }

  function validateOtpRequestForm() {
    if (!state.loaded) {
      window.alert('Please wait until availability has been checked.');
      return null;
    }
    const form = document.getElementById('dbBookingForm');
    if (form && !form.reportValidity()) return null;
    const patientName = stringValue(document.getElementById('dbPatientName')?.value);
    const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
    const phoneDigits = patientPhone.replace(/\D/g, '');
    const localDigits = phoneDigits.length === 12 && phoneDigits.startsWith('91')
      ? phoneDigits.slice(2)
      : phoneDigits.length === 11 && phoneDigits.startsWith('0')
        ? phoneDigits.slice(1)
        : phoneDigits;
    if (!patientName || !/^[6-9]\d{9}$/.test(localDigits)) {
      window.alert('Please enter your full name and a valid 10-digit Indian WhatsApp number.');
      return null;
    }
    if (!stringValue(document.getElementById('dbBookingTime')?.value)) {
      window.alert('Please select an available time slot first.');
      return null;
    }
    return { patientName, patientPhone };
  }

  function startOtpResendCountdown(seconds) {
    const button = document.getElementById('dbOtpResendBtn');
    if (!button) return;
    if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
    let remaining = Math.max(1, Number(seconds) || 60);
    const render = () => {
      button.disabled = remaining > 0;
      button.textContent = remaining > 0 ? `Resend in ${remaining}s` : 'Resend code';
    };
    render();
    state.otpResendTimer = window.setInterval(() => {
      remaining -= 1;
      render();
      if (remaining <= 0) {
        window.clearInterval(state.otpResendTimer);
        state.otpResendTimer = null;
      }
    }, 1000);
  }

  async function requestBookingOtp(button) {
    const details = validateOtpRequestForm();
    if (!details) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'SENDING CODE…';
    setOtpStatus('');
    let result = null;
    try {
      result = await fetchJson(apiUrl(), {
        method: 'POST',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
        body: JSON.stringify({ action: 'send_otp', patient_phone: details.patientPhone })
      });
      if (result?.success !== true || !result?.challenge_id) {
        const unknownOtpAction = result?.code === 'UNKNOWN_ACTION' ||
          /^Unknown action:\s*send_otp$/i.test(stringValue(result?.message));
        const error = new Error(unknownOtpAction
          ? 'The booking service is using an older Apps Script deployment. Publish the latest Code.gs as a new version of the existing web app deployment, then try again.'
          : result?.message || 'The verification code could not be sent.');
        error.code = result?.code || 'OTP_SEND_FAILED';
        throw error;
      }
      state.otpChallengeId = stringValue(result.challenge_id);
      state.otpVerificationToken = '';
      const stepOne = document.getElementById('dbModalStep1');
      const otpStep = document.getElementById('dbModalStepOtp');
      if (stepOne) stepOne.style.display = 'none';
      if (otpStep) otpStep.style.display = 'block';
      const masked = document.getElementById('dbOtpMaskedPhone');
      if (masked) masked.textContent = stringValue(result.masked_phone) || 'your WhatsApp number';
      const input = document.getElementById('dbOtpCode');
      if (input) {
        input.value = '';
        input.focus();
      }
      setOtpStatus('Code sent. It expires in 5 minutes.');
    } catch (error) {
      console.error('[DoctorBooking] WhatsApp OTP could not be sent.', error);
      setOtpStatus(error?.message || 'The verification code could not be sent.', true);
      window.alert(error?.message || 'The verification code could not be sent.');
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
    if (result?.success === true) startOtpResendCountdown(result.retry_after);
  }

  async function verifyBookingOtp(button) {
    const otp = stringValue(document.getElementById('dbOtpCode')?.value).replace(/\D/g, '');
    const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
    if (!state.otpChallengeId || !/^\d{6}$/.test(otp)) {
      setOtpStatus('Enter the 6-digit code sent on WhatsApp.', true);
      return;
    }
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'VERIFYING…';
    setOtpStatus('Verifying code…');
    try {
      const result = await fetchJson(apiUrl(), {
        method: 'POST',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
        body: JSON.stringify({
          action: 'verify_otp',
          patient_phone: patientPhone,
          challenge_id: state.otpChallengeId,
          otp
        })
      });
      if (result?.success !== true || !result?.verification_token) {
        const error = new Error(result?.message || 'The verification code is incorrect.');
        error.code = result?.code || 'OTP_INCORRECT';
        throw error;
      }
      state.otpVerificationToken = stringValue(result.verification_token);
      setOtpStatus('WhatsApp number verified. Reserving your slot…');
      await submitBooking(button);
    } catch (error) {
      console.error('[DoctorBooking] WhatsApp OTP verification failed.', error);
      setOtpStatus(error?.message || 'The verification code could not be verified.', true);
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  async function submitBooking(button) {
    const form = document.getElementById('dbBookingForm');
    if (form && !form.reportValidity()) return;
    const patientName = stringValue(document.getElementById('dbPatientName')?.value);
    const patientPhone = stringValue(document.getElementById('dbPatientPhone')?.value);
    const phoneDigits = patientPhone.replace(/\D/g, '');

    if (!patientName || phoneDigits.length < 7 || phoneDigits.length > 15) {
      window.alert('Please enter your full name and a valid phone number.');
      return;
    }

    const mode = stringValue(document.getElementById('dbConsultationMode')?.value) || 'Online Video';
    const datePill = activeDatePill();
    const date = datePill?.dataset.iso || stringValue(document.getElementById('dbBookingDate')?.value) || 'Today';
    const time = stringValue(document.getElementById('dbBookingTime')?.value);
    if (!time) {
      window.alert('No slots are left on this date — please pick another day.');
      return;
    }

    if (!state.bookingRequestId) state.bookingRequestId = safeUuid();
    const payload = {
      action: 'book',
      request_id: state.bookingRequestId,
      doctor_id: state.currentDoctorId,
      doctor_name: stringValue(document.getElementById('dbDoctorName')?.value),
      doctor_fee: stringValue(document.getElementById('dbDoctorFee')?.value),
      patient_name: patientName,
      patient_phone: patientPhone,
      patient_email: stringValue(document.getElementById('dbPatientEmail')?.value),
      otp_verification_token: state.otpVerificationToken,
      mode: mode,
      date: date,
      date_label: stringValue(datePill?.dataset.date),
      time: time,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      source: 'shopify-storefront'
    };

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'CONFIRMING…';

    try {
      const result = await fetchJson(apiUrl(), {
        method: 'POST',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const resultStatus = stringValue(result?.status || 'booked').toLowerCase();
      const confirmed = result?.success === true && ['booked', 'confirmed', 'payment_pending', 'reserved'].includes(resultStatus);
      if (!confirmed) {
        const bookingError = new Error(result?.message || 'The slot could not be booked.');
        bookingError.code = result?.code || 'BOOKING_REJECTED';
        throw bookingError;
      }
      showBookingSuccess(
        result?.payment_status,
        result?.status,
        result?.checkout
      );
      state.bookingRequestId = stringValue(result?.request_id) || state.bookingRequestId;
      markSlotBookedLocally(date, time, result?.payment_expires_at);
    } catch (error) {
      console.error('[DoctorBooking] Booking was not confirmed.', error);
      if (error?.code === 'SLOT_ALREADY_BOOKED') state.bookingRequestId = '';
      if (['OTP_REQUIRED', 'OTP_EXPIRED', 'OTP_INVALID', 'OTP_ALREADY_USED'].includes(error?.code)) {
        state.otpVerificationToken = '';
        setOtpStatus(error?.message || 'Verify your WhatsApp number again.', true);
        const otpStep = document.getElementById('dbModalStepOtp');
        if (otpStep) otpStep.style.display = 'block';
      }
      await loadAvailability().catch(() => { });
      window.alert(error?.message || 'The booking could not be confirmed. Please try again.');
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function initBookingModal() {
    const modal = document.getElementById('dbBookingModal');
    if (!modal) return;
    document.addEventListener('click', event => {
      const bookButton = event.target.closest('.book-btn, .buy-btn, .db-btn-book');
      if (bookButton) {
        event.preventDefault();
        event.stopPropagation();
        openBookingModal(bookButton);
      }
    });

    modal.addEventListener('click', event => {
      if (event.target === modal || event.target.closest('.db-modal-close, .db-modal-cancel')) closeBookingModal();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && modal.classList.contains('active')) closeBookingModal();
    });

    modal.querySelector('.db-date-prev')?.addEventListener('click', () => {
      modal.querySelector('.db-date-picker-row')?.scrollBy({ left: -160, behavior: 'smooth' });
    });
    modal.querySelector('.db-date-next')?.addEventListener('click', () => {
      modal.querySelector('.db-date-picker-row')?.scrollBy({ left: 160, behavior: 'smooth' });
    });

    document.getElementById('dbConfirmBookingBtn')?.addEventListener('click', event => {
      event.preventDefault();
      requestBookingOtp(event.currentTarget);
    });
    document.getElementById('dbVerifyOtpBtn')?.addEventListener('click', event => {
      event.preventDefault();
      verifyBookingOtp(event.currentTarget);
    });
    document.getElementById('dbOtpResendBtn')?.addEventListener('click', event => {
      event.preventDefault();
      requestBookingOtp(event.currentTarget);
    });
    document.getElementById('dbOtpBackBtn')?.addEventListener('click', () => {
      if (state.otpResendTimer) window.clearInterval(state.otpResendTimer);
      state.otpResendTimer = null;
      state.otpChallengeId = '';
      state.otpVerificationToken = '';
      const otpStep = document.getElementById('dbModalStepOtp');
      const stepOne = document.getElementById('dbModalStep1');
      if (otpStep) otpStep.style.display = 'none';
      if (stepOne) stepOne.style.display = 'block';
    });
    document.getElementById('dbOtpCode')?.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const verifyButton = document.getElementById('dbVerifyOtpBtn');
        if (verifyButton && !verifyButton.disabled) verifyButton.click();
      }
    });
  }

  /* ---------- Video Modal ---------- */
  function initVideoModal() {
    const modal = document.getElementById('videoModal');
    const box = document.getElementById('videoBox');
    if (!modal || !box) return;

    document.addEventListener('click', event => {
      const playBtn = event.target.closest('.play-btn, [data-play]');
      if (playBtn) {
        event.preventDefault();
        event.stopPropagation();
        const card = playBtn.closest('.t-card, .profile-page, #profileContent');
        const docName = card?.querySelector('.name-row h2, h1[data-bind="name"]')?.textContent?.trim() || 'this therapist';
        box.innerHTML = `
          <div class="vb-fill">A short intro from ${docName} would play here &mdash; 20&ndash;30 seconds, just enough to get a feel for them before you book.</div>
          <button class="vb-close" id="videoClose">&times;</button>
        `;
        modal.classList.add('open');
        document.getElementById('videoClose')?.addEventListener('click', () => modal.classList.remove('open'));
      }
    });

    modal.addEventListener('click', event => {
      if (event.target === modal || event.target.id === 'videoClose') {
        modal.classList.remove('open');
      }
    });
  }

  /* ---------- FAQ Accordion ---------- */
  function initFaqAccordion() {
    document.addEventListener('click', event => {
      const faqQ = event.target.closest('.p-faq-q');
      if (faqQ) {
        event.preventDefault();
        const item = faqQ.closest('.p-faq-item');
        if (item) item.classList.toggle('open');
      }
    });
  }

  /* ---------- Card Navigation to Profile ---------- */
  function initCardNavigation() {
    document.addEventListener('click', event => {
      const card = event.target.closest('.t-card, .mini-card, .mt-therapist-skeleton');
      if (!card) return;
      if (event.target.closest('.play-btn, .book-btn, .consult-btn, .mini-book, .db-btn-book, a, button')) return;
      const docId = normalizeId(
        card.dataset.open ||
        card.dataset.id ||
        card.dataset.therapistId ||
        card.dataset.docId ||
        card.querySelector('[data-doc-id]')?.dataset.docId
      ).replace(/\s+/g, '-');
      if (docId) {
        window.location.href = `/pages/doctor-profile?id=${encodeURIComponent(docId)}`;
      }
    });
  }

  /* ---------- Profile Page Data (Shopify Metafields + Google Sheet) ---------- */
  function paletteForId(id) {
    const hash = Array.from(normalizeId(id)).reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 997, 7);
    return CARD_PALETTES[hash % CARD_PALETTES.length];
  }

  function splitList(text) {
    if (Array.isArray(text)) return text.map(item => stringValue(item)).filter(Boolean);
    return stringValue(text).split(',').map(item => item.trim()).filter(Boolean);
  }

  function normaliseFaqs(value) {
    return (Array.isArray(value) ? value : []).map(entry => {
      if (Array.isArray(entry)) return [stringValue(entry[0]), stringValue(entry[1])];
      if (entry && typeof entry === 'object') return [stringValue(entry.question ?? entry.q), stringValue(entry.answer ?? entry.a)];
      return ['', ''];
    }).filter(pair => pair[0] || pair[1]);
  }

  function therapistProfile(therapist, palette) {
    if (!therapist) return null;
    const data = {
      name: stringValue(therapist.name),
      title: stringValue(therapist.role || therapist.title),
      experience: stringValue(therapist.experience),
      rating: stringValue(therapist.rating),
      fee: stringValue(therapist.price || therapist.fee),
      modes: stringValue(therapist.centre || therapist.modes),
      duration: stringValue(therapist.duration),
      speaks: stringValue(therapist.languages || therapist.speaks),
      initials: initialsOf(therapist.name),
      next_slot: stringValue(therapist.availability || therapist.next_slot),
      bio: stringValue(therapist.bio),
      about: stringValue(therapist.about),
      how_i_work: stringValue(therapist.how_i_work),
      sessions: stringValue(therapist.sessions),
      switch_policy: stringValue(therapist.switch_policy),
      image_url: safeUrl(therapist.image_url)
    };
    const expertise = splitList(therapist.expertise);
    const helpTags = splitList(therapist.help_tags);
    const faqs = normaliseFaqs(therapist.faqs);
    if (expertise.length) data.expertise = expertise;
    if (helpTags.length) data.help_tags = helpTags;
    if (faqs.length) data.faqs = faqs;
    if (palette) data.palette = palette;
    Object.keys(data).forEach(key => {
      if (data[key] === '' || data[key] === null || typeof data[key] === 'undefined') {
        delete data[key];
      }
    });
    return data;
  }

  function findTherapistForId(id) {
    if (!id) return null;
    const direct = state.therapists.get(id);
    if (direct) return direct;
    const fallback = state.profileFallback?.[id];
    if (!fallback) return null;
    return state.therapists.get(normalizeId(fallback.name).replace(/\s+/g, '-')) || null;
  }

  function applyProfileData(profile, doctor) {
    if (!profile || !doctor) return;
    const root = profile.closest('.db-page-wrapper') || profile;

    ['title', 'experience', 'fee', 'rating', 'speaks', 'about', 'modes', 'duration', 'sessions', 'how_i_work', 'initials', 'next_slot', 'switch_policy'].forEach(field => {
      root.querySelectorAll(`[data-bind="${field}"]`).forEach(element => {
        if (doctor[field]) element.textContent = doctor[field];
      });
    });

    root.querySelectorAll('[data-bind="name"]:not(.db-btn-book)').forEach(element => {
      if (doctor.name) element.textContent = doctor.name;
    });

    const slotBadge = root.querySelector('.slot-badge');
    if (slotBadge) slotBadge.style.display = doctor.next_slot ? '' : 'none';

    const pMedia = document.getElementById('pMedia');
    if (pMedia) {
      const initials = pMedia.querySelector('.media-initials');
      if (doctor.image_url) {
        pMedia.style.background = `url("${doctor.image_url.replace(/["'()]/g, '')}") center/cover no-repeat`;
        if (initials) initials.style.display = 'none';
      } else if (Array.isArray(doctor.palette)) {
        pMedia.style.background = `linear-gradient(150deg, ${doctor.palette[0]}, ${doctor.palette[1]} 120%)`;
        if (initials) initials.style.display = '';
      }
    }

    const tags = root.querySelector('[data-bind="expertise-tags"]');
    if (tags && Array.isArray(doctor.expertise)) {
      clearElement(tags);
      doctor.expertise.forEach(expertise => {
        const tag = document.createElement('span');
        tag.className = 'tag';
        tag.textContent = expertise;
        tags.appendChild(tag);
      });
    }

    const helpTags = root.querySelector('[data-bind="help_tags"]');
    if (helpTags && Array.isArray(doctor.help_tags)) {
      clearElement(helpTags);
      doctor.help_tags.forEach(htag => {
        const tag = document.createElement('span');
        tag.className = 'tag';
        tag.textContent = htag;
        helpTags.appendChild(tag);
      });
    }

    const faqsContainer = document.getElementById('pFAQs');
    if (faqsContainer && Array.isArray(doctor.faqs)) {
      clearElement(faqsContainer);
      doctor.faqs.forEach(([question, answer], index) => {
        const item = document.createElement('div');
        item.className = `p-faq-item${index === 0 ? ' open' : ''}`;
        item.innerHTML = `
          <button type="button" class="p-faq-q">
            <span>${esc(question)}</span>
            <span class="plus">+</span>
          </button>
          <div class="p-faq-a">
            <p>${esc(answer)}</p>
          </div>
        `;
        faqsContainer.appendChild(item);
      });
    }
  }

  function updateProfileButtons(profile, id, doctor) {
    const root = profile.closest('.db-page-wrapper') || profile;
    const displayedName = stringValue(root.querySelector('[data-bind="name"]')?.textContent) || doctor.name || 'Therapist';
    const price = stringValue(root.querySelector('.p-value[data-bind="fee"]')?.textContent) || doctor.fee || '₹2000';
    const displayedFee = doctor.duration && !price.includes(doctor.duration) ? `${price} for ${doctor.duration}` : price;

    root.querySelectorAll('.db-btn-book, .buy-btn, .consult-btn').forEach(button => {
      button.dataset.docId = id;
      button.dataset.docName = displayedName;
      const isFreeCall = button.classList.contains('consult-btn') || /^free\b/i.test(stringValue(button.textContent));
      if (!isFreeCall) {
        button.dataset.docFee = displayedFee;
      }
    });
  }

  function mergeProfileData(sheetDoctor, fallbackDoctor) {
    // Shopify/hard-coded values are only fallbacks. The Google Sheet is the
    // live source of truth, so every non-empty field normalised from the Sheet
    // must win when the two records describe the same therapist.
    return Object.assign({}, fallbackDoctor || {}, sheetDoctor || {});
  }

  function renderProfilePage() {
    const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
    if (!profile) return;
    const requested = normalizeId(profile.dataset.doctorId);
    const therapist = findTherapistForId(requested);
    const fallbackDoctor = state.profileFallback?.[requested] || null;

    // Do not reveal a hard-coded/Shopify-only profile. The Sheet record must
    // resolve first so visitors never see stale data flash before replacement.
    if (!therapist) {
      renderProfileStatus('This therapist was not found in the Google Sheet.', true);
      return;
    }

    const sheetDoctor = therapistProfile(therapist, paletteForId(therapist.id));
    // Shopify may supply richer profile copy, but the Sheet is the source of
    // truth for live commercial fields. Without these explicit overrides, the
    // hard-coded fallback fee (usually ₹2000) masks every Sheet price update.
    const doctor = mergeProfileData(sheetDoctor, fallbackDoctor);
    if (sheetDoctor?.faqs?.length && !fallbackDoctor?.faqs?.length) {
      doctor.faqs = sheetDoctor.faqs;
    }
    if (sheetDoctor?.next_slot && !fallbackDoctor?.next_slot) {
      doctor.next_slot = sheetDoctor.next_slot;
    }

    if (state.loaded && state.availabilityEnabled) {
      doctor.next_slot = state.doctors.get(therapist.id)?.next_slot || '';
    }

    applyProfileData(profile, doctor);

    const id = therapist?.id || requested;
    profile.dataset.doctorId = id;
    updateProfileButtons(profile, id, doctor);
    revealProfilePage(profile);
  }

  /* ---------- Profile Page Initialization ---------- */
  function initProfilePage() {
    const profile = document.getElementById('profileContent') || document.getElementById('dbProfileSection');
    if (!profile) return;
    const queryId = new URLSearchParams(window.location.search).get('id')
      || new URLSearchParams(window.location.search).get('doctor')
      || new URLSearchParams(window.location.search).get('handle');

   const profileData = {
  "palak-chhabra": {
    "name": "Palak Chhabra",
    "title": "Counselling Psychologist",
    "experience": "5+ yrs",
    "sessions": "2000+ hours of healing",
    "rating": "4.9",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "PC",
    "expertise": ["Emotional concerns", "Life transitions", "Grief and loss", "Self esteem"],
    "help_tags": ["Relationship concerns", "Self and body image", "Burnout", "Confidence and growth"],
    "bio": "Helping adults navigate their feelings and finding their way through life’s tough moments.",
    "about": "Trauma-informed, queer-affirmative Counselling Psychologist supporting adults through emotions and transitions, with an M.A. in Lifespan Counselling, B.A. in Psychology & Philosophy, and a Diploma in Narrative Therapy.",
    "how_i_work": "Warm, collaborative, non-pathologising sessions without having the pressure to figure it out. We explore your story together, your context, the meaning you make of your experiences and a range of emotions with empathy and understanding.",
    "faqs": [
      ["I'm part of the LGBTQ+ community. Is your practice queer-affirmative?", "Yes, absolutely. I work from a queer-affirmative and trauma-informed lens, and my practice is grounded in creating a safe, inclusive, non-judgmental space where you can come as you are without labels or the pressure to have everything figured out. I work in both English and Hindi."],
      ["I don't know exactly what's wrong I just feel stuck or disconnected. Can I still come?", "Yes. You don't need to have a clear problem or everything figured out before you start. Many people come feeling stuck, lost, or disconnected from themselves, and we can explore that together at your pace, without forcing a diagnosis or a fixed way of working."],
      ["Will I have homework or need to do things between sessions?", "Only if it feels useful to you. I may offer reflections, questions, or exercises between sessions when they seem helpful, but I don't believe therapy needs to be done perfectly curiosity, honesty, and engagement matter far more to me than getting everything \"right.\""],
      ["Can I disagree with you or change what we talk about?", "Absolutely, in fact, I encourage it. You can call me by my first name, tell me something isn't working, change your mind about what you want to discuss, or simply show up on a day when you don't know what to say. I believe therapy works best when there's room for all of that."]
    ],
    "palette": ["#EAD9DE", "#786C8A"]
  },
  "arushi-raheja": {
    "name": "Arushi Raheja",
    "title": "Child Psychologist",
    "experience": "9+ yrs",
    "sessions": "4000+ hours of healing",
    "rating": "4.9",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "AR",
    "expertise": ["Parenting support", "Anxiety", "Attention and focus difficulties", "Autism"],
    "help_tags": ["Trauma and grief", "Thoughts of self-harm or deep distress", "Emotional and behavioural difficulties", "Building self-confidence"],
    "bio": "Helps in guiding children, adolescents, and parents through emotional hurdles, behavioural challenges, and parenting struggles in a safe environment.",
    "about": "A Child Psychologist with a Master's degree in Clinical Psychology and NCERT- PG Diploma in Child Guidance, using a Gestalt-informed lens and experience helping children, young adults, and families thrive.",
    "how_i_work": "Through compassionate conversations, creative activities, and practical guidance, we work together to help you understand your feelings, build strength, and make lasting progress to achieve a better sense of self.",
    "faqs": [
      ["My child has been diagnosed with ADHD or Autism — how do you approach that?", "I hold a Master's degree and a PG Diploma in Child Guidance and Counselling, and my practice focuses on supporting children and adolescents with ADHD, autism, learning disabilities, and related concerns. I tailor my approach to each child's unique needs, using a Gestalt-informed lens alongside practical, structured strategies that work for them."],
      ["Do you work with adults too, or only children?", "While my core focus is children, adolescents, and young adults, I also work with parents and families. I facilitate workshops and training for parents, educators, and organisations on emotional well-being, positive parenting, and mental health topics."],
      ["I'm worried about my child's self-harm or deep distress — how do you handle that?", "I have clinical experience supporting individuals experiencing self-harm or suicidal ideation. My approach is to create a safe, compassionate space where your child feels heard, assess the level of risk carefully, and work collaboratively with you to ensure they get the right support — including involving a psychiatrist or crisis support if needed."],
      ["What does a session with you look like?", "Sessions are warm and tailored to your child's age and needs. I use compassionate conversations, creative activities, and practical guidance — drawing on Gestalt therapy and other modalities including dance movement therapy where appropriate — so therapy feels engaging rather than clinical."],
      ["Do you only do individual therapy, or also workshops?", "I do both. Alongside individual sessions, I facilitate workshops and training programmes for schools, educators, parents, and organisations on emotional well-being, positive parenting, resilience, trauma, grief, and suicide prevention."]
    ],
    "palette": ["#EFE7DA", "#EAD9DE"]
  },
  "mahita-kochhar": {
    "name": "Mahita Kochhar",
    "title": "Counselling Psychologist",
    "experience": "5+ yrs",
    "sessions": "2000+ hours of healing",
    "rating": "4.8",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "MK",
    "expertise": ["Children and adolescent concerns", "Parenting support", "Emotional regulation", "School-related concerns"],
    "help_tags": ["Behavioural concerns", "Self-esteem and confidence", "Social and relationship skills", "Adjustment and life transitions"],
    "bio": "Sits with emotional, behavioural, and school-related difficulties with children, teens and parents to work through them with art based approaches.",
    "about": "A Counselling Psychologist with a Masters in Clinical Psychology and a PG Diploma in Guidance and counselling and experience in school counselling and Special Educational Needs (SEN) settings.",
    "how_i_work": "Sessions are warm, empathetic, and conversational. Through engaging activities and creative art-based techniques, we work together to build self-awareness, emotional regulation and develop healthy coping habits.",
    "faqs": [
      ["I'm an adult — do you only work with children?", "No — while my core focus is children and adolescents, I also work with adults, especially parents and those navigating emotional regulation, anxiety, self-esteem, and life transitions. My art-based approach can be adapted to adults too, if that feels helpful."],
      ["I'm not great at talking about my feelings — will therapy still work for me?", "Absolutely. I use creative and art-based techniques alongside conversation, so you can express yourself in ways beyond words — through drawing, colours, and activities — at a pace that feels comfortable for you."],
      ["What's the session format and duration?", "Sessions are 50 minutes, held online, in Hindi or English. We'll begin by understanding your story and goals, then build a warm, personalised rhythm that works for you."],
      ["How many sessions will I need?", "It depends on your concerns and goals — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
      ["I'm a parent — can you help me support my child better?", "Yes — parenting support is one of my focus areas. I work with parents to help them understand and support their child's emotional and behavioural needs, through separate parent sessions or joint check-ins where helpful."]
    ],
    "palette": ["#786C8A", "#EFE7DA"]
  },
  "chavika-dudeja": {
    "name": "Chavika Dudeja",
    "title": "Counselling Psychologist | RCI Licensed Rehabilitation Counselor",
    "experience": "2 yrs",
    "sessions": "1300+ hours of healing",
    "rating": "4.8",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "CD",
    "expertise": ["Child counselling", "Family concerns", "Adjustment issues", "Emotional well being"],
    "help_tags": ["Child counselling and rehabilitation", "Special needs children", "Personal growth", "Self-esteem challenges"],
    "bio": "Works with individuals and children navigating emotions and transitions to build clarity and self-connection.",
    "about": "A Counselling Psychologist with a B.A. in Human Development & Family Empowerment and an M.A. in Psychology specializing in Child and Adolescent Guidance.",
    "how_i_work": "Sessions are warm, grounded, and structured yet flexible. Through compassionate conversations, clear understanding and practical strategies, we work together to help you gain insight and growth.",
    "faqs": [
      ["Do you take couples counselling?", "I work primarily with individuals, but if you're navigating relational concerns, we can explore those together in individual sessions."],
      ["Do you provide medication?", "No — I'm a counselling psychologist, not a psychiatrist, so I don't prescribe medication. If it feels relevant, I can work alongside a psychiatrist or help you connect with one while we continue therapy together."],
      ["What's the session format and duration?", "Sessions are 50 minutes, held online, and conducted in Hindi or English. We'll start with understanding your story and goals, then build a warm, structured yet flexible rhythm that works for you."],
      ["How many sessions will I need?", "It depends on your goals and what you're navigating — some people find a few sessions helpful for clarity, while others prefer longer-term support. We'll check in along the way so you always know where things stand."],
      ["Do you work with children and adolescents?", "Yes — I'm specializing in Child and Adolescent Guidance and Counselling, so I work with young people as well as adults, tailoring the approach to their age and needs."]
    ],
    "palette": ["#EAD9DE", "#EFE7DA"]
  },
  "alisha-crasto": {
    "name": "Alisha Crasto",
    "title": "Counselling Psychologist",
    "experience": "7+ yrs",
    "sessions": "2500+ hours of healing",
    "rating": "4.8",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "AC",
    "expertise": ["Child counselling", "Work stress and burnout", "Relationship understanding"],
    "help_tags": ["Anxiety and stress", "Trauma", "Depression", "Self esteem"],
    "bio": "Sits with children, adolescents, and adults as a gentle facilitator, trusting that clients hold their own answers and that every person deserves compassionate, accessible mental health care.",
    "about": "A Psychologist and Narrative Therapy practitioner with a Master's in Clinical Psychology and a Diploma in Community Mental Health from NIMHANS, bringing 7 years of experience supporting children, adolescents, and adults across diverse mental health concerns.",
    "how_i_work": "Sessions are warm, collaborative, and story-centred, where we explore your experiences together, gently re-authoring the narratives that shape you, at a pace that feels safe and yours. There is no fixing involved but understanding and acceptance.",
    "faqs": [
      ["Do you only use narrative therapy?", "Narrative therapy is my core approach, but I blend it with my clinical psychology training to meet each client's needs. The thread throughout is my belief that you are the expert on your own life, I'm here to walk alongside you, not to impose answers."],
      ["I'm not sure how to talk about what I'm going through. Is that okay?", "Completely. Many people arrive not knowing how to put things into words. We'll go at your pace, and the narrative approach gives us gentle ways to explore your story without pressure to have it all figured out."],
      ["Do you work with children and adolescents too?", "Yes, I have experience across children, adolescents, and adults. With younger clients, I adapt the approach to their age and world, often using stories and creative expression to help them feel comfortable."],
      ["What does a first session look like?", "We'll start by getting to know each other and understanding what brought you in with no pressure to have a clear problem or goal. It's a space to share as much or as little as you're comfortable with, and we'll decide together how to move forward."]
    ],
    "palette": ["#EAD9DE", "#786C8A"]
  },
  "vanshika-vakharia": {
    "name": "Vanshika Vakharia",
    "title": "Counselling Psychologist",
    "experience": "4+ yrs",
    "sessions": "1500+ hours of healing",
    "rating": "4.7",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "VV",
    "expertise": ["Emotional regulation", "Healthy coping", "Self understanding"],
    "help_tags": ["Anxiety and stress", "Emotional regulation", "Self-esteem and confidence", "Life transitions and adjustment", "Relationship concerns"],
    "bio": "Works with children, adolescents, and adults by helping them understand unhelpful patterns, build healthier coping, and reconnect.",
    "about": "Counselling Psychologist with a MA in counseling and clinical psychology who works with children, adolescents, and adults through various modalities like mindfulness, and emotional regulation strategies.",
    "how_i_work": "A warm, collaborative conversation where you feel safe enough to be vulnerable, make sense of your thoughts and emotions, and move towards healing, growth, and lasting change, at a pace that feels right for you.",
    "faqs": [
      ["What does a first session look like?", "A warm, collaborative conversation where you feel safe enough to be vulnerable. We'll start by understanding what brought you in and what you're hoping to work on with no pressure to have it all figured out. We'll take it at a pace that feels right for you."],
      ["Do you only use one type of therapy?", "No I integrate several evidence-based approaches, including CBT, REBT, mindfulness-based interventions, psychoeducation, and emotional regulation strategies. I tailor the blend to your needs and what feels most useful to you."],
      ["I'm not good at opening up. Is that a problem?", "Not at all. Many clients find it hard to open up at first, and that's completely normal. My job is to create a safe, accepting space where you can be vulnerable at your own pace, there's no rush and no judgment."],
      ["Do you work with children and adolescents too?", "Yes, I work across children, adolescents, and adults. With younger clients, I adapt my approach to their age and world, using age-appropriate, engaging methods to help them feel comfortable and understood."]
    ],
    "palette": ["#EFE7DA", "#EAD9DE"]
  },
  "hita-shah": {
    "name": "Hita Shah",
    "title": "Counselling Psychologist",
    "experience": "3+ yrs",
    "sessions": "2000+ hours of healing",
    "rating": "4.7",
    "fee": "₹2000",
    "modes": "Online",
    "duration": "50 min",
    "speaks": "Hindi, English",
    "initials": "HS",
    "expertise": ["Self understanding", "Anxiety and stress", "Relationship issues", "Transitions"],
    "help_tags": ["Emotional balance", "Overthinking", "Confidence & self-worth", "Feeling stuck", "Personal growth"],
    "bio": "Works in a warm, understanding space to slow down, make sense of what you’re feeling, and find ways forward at your own pace.",
    "about": "A Counselling Psychologist holding an MSc in Psychology of Mental Health and a Diploma in Guidance and Counselling; offers a warm, supportive space to understand yourself and what you’re going through.",
    "how_i_work": "Sessions are a space to slow down, talk openly, and make sense of what you’re experiencing. Together, we explore your thoughts, feelings, and patterns, while finding practical ways forward. We work collaboratively and at your pace.",
    "faqs": [
      ["What can I talk about in therapy?", "You can talk about whatever feels important to you, your thoughts, feelings, relationships, work, everyday struggles, or things you may not fully understand yet. You don’t need to know exactly where to begin."],
      ["What happens in the first session?", "The first session is usually about getting to know you, understanding what brings you to therapy, and discussing what you would like support with. There is no pressure to have everything figured out."],
      ["Will I be given advice or told what to do?", "Therapy with Hita is collaborative. Rather than simply telling you what to do, she helps you understand yourself, explore different perspectives, and find approaches that feel right for you."],
      ["How often do I need to have sessions?", "There is no one-size-fits-all answer. The frequency can depend on what you’re looking for and what feels comfortable for you. This can be discussed together as you begin."],
      ["What if I don’t know how to explain what I’m feeling?", "That’s completely okay. You don’t need to come with the perfect words. Sessions can be a space to slowly make sense of what you’re experiencing together."]
    ],
    "palette": ["#786C8A", "#EFE7DA"]
  }
};
    profileData.palak = profileData["palak-chhabra"];
    profileData.arushi = profileData["arushi-raheja"];
    profileData.mahita = profileData["mahita-kochhar"];
    profileData.chavika = profileData["chavika-dudeja"];

    // Parse Shopify Product Metafields JSON output by the Liquid template
    const shopifyProfiles = {};
    let firstShopifyHandle = '';
    const shopifyJsonEl = document.getElementById('shopify-doctors-json');
    if (shopifyJsonEl) {
      try {
        const rawShopify = JSON.parse(shopifyJsonEl.textContent);
        Object.keys(rawShopify).forEach(handle => {
          const normKey = normalizeId(handle);
          if (!firstShopifyHandle) firstShopifyHandle = normKey;
          const norm = therapistProfile(rawShopify[handle], paletteForId(normKey));
          if (norm) {
            shopifyProfiles[normKey] = norm;
            // Also index by first-name alias (e.g., "palak" -> "palak-chhabra") if not already taken
            const shortKey = normKey.split('-')[0];
            if (shortKey && !shopifyProfiles[shortKey]) {
              shopifyProfiles[shortKey] = norm;
            }
          }
        });
      } catch (err) {
        console.warn('[DoctorBooking] Could not parse shopify-doctors-json:', err);
      }
    }

    // Merge hardcoded defaults with Shopify Product Metafields (Shopify Metafields override defaults)
    state.profileFallback = Object.assign({}, profileData);
    Object.keys(shopifyProfiles).forEach(key => {
      state.profileFallback[key] = Object.assign({}, state.profileFallback[key] || {}, shopifyProfiles[key]);
    });

    const defaultId = profile.dataset.doctorId && profile.dataset.doctorId !== 'palak-chhabra'
      ? profile.dataset.doctorId
      : (firstShopifyHandle || 'palak-chhabra');

    const id = normalizeId(queryId || defaultId);
    profile.dataset.doctorId = id;

    // Keep the Liquid fallback hidden while loadTherapists() resolves. It is
    // used only to supplement the live Sheet record after that record exists.
    profile.hidden = true;
    profile.setAttribute('aria-busy', 'true');
    const loader = document.getElementById('dbProfileLoading');
    if (loader) loader.hidden = false;
    const buyBar = document.getElementById('profileBuyBar');
    if (buyBar) buyBar.hidden = true;
    const buyBarLoading = document.getElementById('profileBuyBarLoading');
    if (buyBarLoading) buyBarLoading.hidden = false;
  }

  function initialise() {
    initProfilePage();
    initCategoryTabs();
    initSelectionEvents();
    initBookingModal();
    initVideoModal();
    initFaqAccordion();
    initCardNavigation();
    loadTherapists().then(renderProfilePage).catch(() => { });
    loadAvailability().catch(() => { });
    initAutoRefresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
